//#region \0rolldown/runtime.js
var e = Object.create, t = Object.defineProperty, n = Object.getOwnPropertyDescriptor, r = Object.getOwnPropertyNames, i = Object.getPrototypeOf, a = Object.prototype.hasOwnProperty, o = (e, t) => () => (e && (t = e(e = 0)), t), s = (e, t) => () => (t || (e((t = { exports: {} }).exports, t), e = null), t.exports), c = (e, n) => {
	let r = {};
	for (var i in e) t(r, i, {
		get: e[i],
		enumerable: !0
	});
	return n || t(r, Symbol.toStringTag, { value: "Module" }), r;
}, l = (e, i, o, s) => {
	if (i && typeof i == "object" || typeof i == "function") for (var c = r(i), l = 0, u = c.length, d; l < u; l++) d = c[l], !a.call(e, d) && d !== o && t(e, d, {
		get: ((e) => i[e]).bind(null, d),
		enumerable: !(s = n(i, d)) || s.enumerable
	});
	return e;
}, u = (n, r, a) => (a = n == null ? {} : e(i(n)), l(r || !n || !n.__esModule ? t(a, "default", {
	value: n,
	enumerable: !0
}) : a, n)), d = (e) => a.call(e, "module.exports") ? e["module.exports"] : l(t({}, "__esModule", { value: !0 }), e), f = function() {
	return f = Object.assign || function(e) {
		for (var t, n = 1, r = arguments.length; n < r; n++) for (var i in t = arguments[n], t) Object.prototype.hasOwnProperty.call(t, i) && (e[i] = t[i]);
		return e;
	}, f.apply(this, arguments);
};
function p(e, t) {
	var n = {};
	for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
	if (e != null && typeof Object.getOwnPropertySymbols == "function") for (var i = 0, r = Object.getOwnPropertySymbols(e); i < r.length; i++) t.indexOf(r[i]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[i]) && (n[r[i]] = e[r[i]]);
	return n;
}
function m(e) {
	var t = typeof Symbol == "function" && Symbol.iterator, n = t && e[t], r = 0;
	if (n) return n.call(e);
	if (e && typeof e.length == "number") return { next: function() {
		return e && r >= e.length && (e = void 0), {
			value: e && e[r++],
			done: !e
		};
	} };
	throw TypeError(t ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function h(e, t) {
	var n = typeof Symbol == "function" && e[Symbol.iterator];
	if (!n) return e;
	var r = n.call(e), i, a = [], o;
	try {
		for (; (t === void 0 || t-- > 0) && !(i = r.next()).done;) a.push(i.value);
	} catch (e) {
		o = { error: e };
	} finally {
		try {
			i && !i.done && (n = r.return) && n.call(r);
		} finally {
			if (o) throw o.error;
		}
	}
	return a;
}
function g(e, t, n) {
	if (n || arguments.length === 2) for (var r = 0, i = t.length, a; r < i; r++) (a || !(r in t)) && (a ||= Array.prototype.slice.call(t, 0, r), a[r] = t[r]);
	return e.concat(a || Array.prototype.slice.call(t));
}
//#endregion
//#region ../../node_modules/xstate/es/types.js
var _;
(function(e) {
	e.Start = "xstate.start", e.Stop = "xstate.stop", e.Raise = "xstate.raise", e.Send = "xstate.send", e.Cancel = "xstate.cancel", e.NullEvent = "", e.Assign = "xstate.assign", e.After = "xstate.after", e.DoneState = "done.state", e.DoneInvoke = "done.invoke", e.Log = "xstate.log", e.Init = "xstate.init", e.Invoke = "xstate.invoke", e.ErrorExecution = "error.execution", e.ErrorCommunication = "error.communication", e.ErrorPlatform = "error.platform", e.ErrorCustom = "xstate.error", e.Update = "xstate.update", e.Pure = "xstate.pure", e.Choose = "xstate.choose";
})(_ ||= {});
var v;
(function(e) {
	e.Parent = "#_parent", e.Internal = "#_internal";
})(v ||= {});
//#endregion
//#region ../../node_modules/xstate/es/actionTypes.js
var y = _.Start, b = _.Stop, x = _.Raise, S = _.Send, C = _.Cancel, w = _.NullEvent, T = _.Assign;
_.After, _.DoneState;
var E = _.Log, D = _.Init, O = _.Invoke;
_.ErrorExecution;
var k = _.ErrorPlatform, A = _.ErrorCustom, j = _.Update, M = _.Choose, N = _.Pure, P = {}, ee = "xstate.guard", F;
function I(e, t, n) {
	n === void 0 && (n = ".");
	var r = B(e, n), i = B(t, n);
	return G(i) ? G(r) ? i === r : !1 : G(r) ? r in i : Object.keys(r).every(function(e) {
		return e in i ? I(r[e], i[e]) : !1;
	});
}
function L(e) {
	try {
		return G(e) || typeof e == "number" ? `${e}` : e.type;
	} catch {
		throw Error("Events must be strings or objects with a string event.type property.");
	}
}
function R(e, t) {
	try {
		return he(e) ? e : e.toString().split(t);
	} catch {
		throw Error(`'${e}' is not a valid state path.`);
	}
}
function z(e) {
	return typeof e == "object" && "value" in e && "context" in e && "event" in e && "_event" in e;
}
function B(e, t) {
	return z(e) ? e.value : he(e) ? te(e) : typeof e == "string" ? te(R(e, t)) : e;
}
function te(e) {
	if (e.length === 1) return e[0];
	for (var t = {}, n = t, r = 0; r < e.length - 1; r++) r === e.length - 2 ? n[e[r]] = e[r + 1] : (n[e[r]] = {}, n = n[e[r]]);
	return t;
}
function ne(e, t) {
	for (var n = {}, r = Object.keys(e), i = 0; i < r.length; i++) {
		var a = r[i];
		n[a] = t(e[a], a, e, i);
	}
	return n;
}
function V(e, t, n) {
	var r, i, a = {};
	try {
		for (var o = m(Object.keys(e)), s = o.next(); !s.done; s = o.next()) {
			var c = s.value, l = e[c];
			n(l) && (a[c] = t(l, c, e));
		}
	} catch (e) {
		r = { error: e };
	} finally {
		try {
			s && !s.done && (i = o.return) && i.call(o);
		} finally {
			if (r) throw r.error;
		}
	}
	return a;
}
var re = function(e) {
	return function(t) {
		var n, r, i = t;
		try {
			for (var a = m(e), o = a.next(); !o.done; o = a.next()) {
				var s = o.value;
				i = i[s];
			}
		} catch (e) {
			n = { error: e };
		} finally {
			try {
				o && !o.done && (r = a.return) && r.call(a);
			} finally {
				if (n) throw n.error;
			}
		}
		return i;
	};
};
function ie(e, t) {
	return function(n) {
		var r, i, a = n;
		try {
			for (var o = m(e), s = o.next(); !s.done; s = o.next()) {
				var c = s.value;
				a = a[t][c];
			}
		} catch (e) {
			r = { error: e };
		} finally {
			try {
				s && !s.done && (i = o.return) && i.call(o);
			} finally {
				if (r) throw r.error;
			}
		}
		return a;
	};
}
function ae(e) {
	return e ? G(e) ? [[e]] : H(Object.keys(e).map(function(t) {
		var n = e[t];
		return typeof n != "string" && (!n || !Object.keys(n).length) ? [[t]] : ae(e[t]).map(function(e) {
			return [t].concat(e);
		});
	})) : [[]];
}
function H(e) {
	var t;
	return (t = []).concat.apply(t, g([], h(e), !1));
}
function oe(e) {
	return he(e) ? e : [e];
}
function U(e) {
	return e === void 0 ? [] : oe(e);
}
function se(e, t, n) {
	var r, i;
	if (W(e)) return e(t, n.data);
	var a = {};
	try {
		for (var o = m(Object.keys(e)), s = o.next(); !s.done; s = o.next()) {
			var c = s.value, l = e[c];
			W(l) ? a[c] = l(t, n.data) : a[c] = l;
		}
	} catch (e) {
		r = { error: e };
	} finally {
		try {
			s && !s.done && (i = o.return) && i.call(o);
		} finally {
			if (r) throw r.error;
		}
	}
	return a;
}
function ce(e) {
	return /^(done|error)\./.test(e);
}
function le(e) {
	return !!(e instanceof Promise || e !== null && (W(e) || typeof e == "object") && W(e.then));
}
function ue(e) {
	return typeof e == "object" && !!e && "transition" in e && typeof e.transition == "function";
}
function de(e, t) {
	var n, r, i = h([[], []], 2), a = i[0], o = i[1];
	try {
		for (var s = m(e), c = s.next(); !c.done; c = s.next()) {
			var l = c.value;
			t(l) ? a.push(l) : o.push(l);
		}
	} catch (e) {
		n = { error: e };
	} finally {
		try {
			c && !c.done && (r = s.return) && r.call(s);
		} finally {
			if (n) throw n.error;
		}
	}
	return [a, o];
}
function fe(e, t) {
	return ne(e.states, function(e, n) {
		if (e) {
			var r = (G(t) ? void 0 : t[n]) || (e ? e.current : void 0);
			if (r) return {
				current: r,
				states: fe(e, r)
			};
		}
	});
}
function pe(e, t) {
	return {
		current: t,
		states: fe(e, t)
	};
}
function me(e, t, n, r) {
	return e && n.reduce(function(e, n) {
		var i, a, o = n.assignment, s = {
			state: r,
			action: n,
			_event: t
		}, c = {};
		if (W(o)) c = o(e, t.data, s);
		else try {
			for (var l = m(Object.keys(o)), u = l.next(); !u.done; u = l.next()) {
				var d = u.value, f = o[d];
				c[d] = W(f) ? f(e, t.data, s) : f;
			}
		} catch (e) {
			i = { error: e };
		} finally {
			try {
				u && !u.done && (a = l.return) && a.call(l);
			} finally {
				if (i) throw i.error;
			}
		}
		return Object.assign({}, e, c);
	}, e);
}
function he(e) {
	return Array.isArray(e);
}
function W(e) {
	return typeof e == "function";
}
function G(e) {
	return typeof e == "string";
}
function ge(e, t) {
	if (e) return G(e) ? {
		type: ee,
		name: e,
		predicate: t ? t[e] : void 0
	} : W(e) ? {
		type: ee,
		name: e.name,
		predicate: e
	} : e;
}
function _e(e) {
	try {
		return "subscribe" in e && W(e.subscribe);
	} catch {
		return !1;
	}
}
var K = /* @__PURE__ */ function() {
	return typeof Symbol == "function" && Symbol.observable || "@@observable";
}();
F = {}, F[K] = function() {
	return this;
}, F[Symbol.observable] = function() {
	return this;
};
function ve(e) {
	return !!e && "__xstatenode" in e;
}
function q(e) {
	return !!e && typeof e.send == "function";
}
var ye = /* @__PURE__ */ function() {
	var e = 0;
	return function() {
		return e++, e.toString(16);
	};
}();
function be(e, t) {
	return G(e) || typeof e == "number" ? f({ type: e }, t) : e;
}
function J(e, t) {
	if (!G(e) && "$$type" in e && e.$$type === "scxml") return e;
	var n = be(e);
	return f({
		name: n.type,
		data: n,
		$$type: "scxml",
		type: "external"
	}, t);
}
function xe(e, t) {
	return oe(t).map(function(t) {
		return t === void 0 || typeof t == "string" || ve(t) ? {
			target: t,
			event: e
		} : f(f({}, t), { event: e });
	});
}
function Se(e) {
	if (!(e === void 0 || e === "")) return U(e);
}
function Ce(e, t, n, r, i) {
	var a = e.options.guards, o = {
		state: i,
		cond: t,
		_event: r
	};
	if (t.type === "xstate.guard") return (a?.[t.name] || t.predicate)(n, r.data, o);
	var s = a?.[t.type];
	if (!s) throw Error(`Guard '${t.type}' is not implemented on machine '${e.id}'.`);
	return s(n, r.data, o);
}
function we(e) {
	return typeof e == "string" ? { type: e } : e;
}
function Te(e, t, n) {
	if (typeof e == "object") return e;
	var r = function() {};
	return {
		next: e,
		error: t || r,
		complete: n || r
	};
}
function Ee(e, t) {
	return `${e}:invocation[${t}]`;
}
//#endregion
//#region ../../node_modules/xstate/es/actions.js
var De = /* @__PURE__ */ J({ type: D });
function Oe(e, t) {
	return t && t[e] || void 0;
}
function ke(e, t) {
	var n;
	if (G(e) || typeof e == "number") {
		var r = Oe(e, t);
		n = W(r) ? {
			type: e,
			exec: r
		} : r || {
			type: e,
			exec: void 0
		};
	} else if (W(e)) n = {
		type: e.name || e.toString(),
		exec: e
	};
	else {
		var r = Oe(e.type, t);
		if (W(r)) n = f(f({}, e), { exec: r });
		else if (r) {
			var i = r.type || e.type;
			n = f(f(f({}, r), e), { type: i });
		} else n = e;
	}
	return n;
}
var Ae = function(e, t) {
	return e ? (he(e) ? e : [e]).map(function(e) {
		return ke(e, t);
	}) : [];
};
function je(e) {
	var t = ke(e);
	return f(f({ id: G(e) ? e : t.id }, t), { type: t.type });
}
function Me(e) {
	return G(e) ? {
		type: x,
		event: e
	} : Pe(e, { to: v.Internal });
}
function Ne(e) {
	return {
		type: x,
		_event: J(e.event)
	};
}
function Pe(e, t) {
	return {
		to: t ? t.to : void 0,
		type: S,
		event: W(e) ? e : be(e),
		delay: t ? t.delay : void 0,
		id: t && t.id !== void 0 ? t.id : W(e) ? e.name : L(e)
	};
}
function Fe(e, t, n, r) {
	var i = { _event: n }, a = J(W(e.event) ? e.event(t, n.data, i) : e.event), o;
	if (G(e.delay)) {
		var s = r && r[e.delay];
		o = W(s) ? s(t, n.data, i) : s;
	} else o = W(e.delay) ? e.delay(t, n.data, i) : e.delay;
	var c = W(e.to) ? e.to(t, n.data, i) : e.to;
	return f(f({}, e), {
		to: c,
		_event: a,
		event: a.data,
		delay: o
	});
}
function Ie(e, t) {
	return Pe(e, f(f({}, t), { to: v.Parent }));
}
var Le = function(e, t, n) {
	return f(f({}, e), { value: G(e.expr) ? e.expr : e.expr(t, n.data, { _event: n }) });
}, Re = function(e) {
	return {
		type: C,
		sendId: e
	};
};
function ze(e) {
	var t = je(e);
	return {
		type: _.Start,
		activity: t,
		exec: void 0
	};
}
function Be(e) {
	var t = W(e) ? e : je(e);
	return {
		type: _.Stop,
		activity: t,
		exec: void 0
	};
}
function Ve(e, t, n) {
	var r = W(e.activity) ? e.activity(t, n.data) : e.activity, i = typeof r == "string" ? { id: r } : r;
	return {
		type: _.Stop,
		activity: i
	};
}
var He = function(e) {
	return {
		type: T,
		assignment: e
	};
};
function Ue(e, t) {
	var n = t ? `#${t}` : "";
	return `${_.After}(${e})${n}`;
}
function We(e, t) {
	var n = `${_.DoneState}.${e}`, r = {
		type: n,
		data: t
	};
	return r.toString = function() {
		return n;
	}, r;
}
function Ge(e, t) {
	var n = `${_.DoneInvoke}.${e}`, r = {
		type: n,
		data: t
	};
	return r.toString = function() {
		return n;
	}, r;
}
function Ke(e, t) {
	var n = `${_.ErrorPlatform}.${e}`, r = {
		type: n,
		data: t
	};
	return r.toString = function() {
		return n;
	}, r;
}
function qe(e) {
	return {
		type: _.Pure,
		get: e
	};
}
function Je(e, t) {
	return Pe(function(e, t) {
		return t;
	}, f(f({}, t), { to: e }));
}
function Ye(e) {
	return {
		type: _.Choose,
		conds: e
	};
}
function Xe(e, t, n, r, i, a) {
	a === void 0 && (a = !1);
	var o = h(a ? [[], i] : de(i, function(e) {
		return e.type === T;
	}), 2), s = o[0], c = o[1], l = s.length ? me(n, r, s, t) : n, u = a ? [n] : void 0;
	return [H(c.map(function(n) {
		switch (n.type) {
			case x: return Ne(n);
			case S: return Fe(n, l, r, e.options.delays);
			case E: return Le(n, l, r);
			case M:
				var i = n.conds.find(function(n) {
					var i = ge(n.cond, e.options.guards);
					return !i || Ce(e, i, l, r, t);
				})?.actions;
				if (!i) return [];
				var o = h(Xe(e, t, l, r, Ae(U(i), e.options.actions), a), 2), s = o[0];
				return l = o[1], u?.push(l), s;
			case N:
				var i = n.get(l, r.data);
				if (!i) return [];
				var c = h(Xe(e, t, l, r, Ae(U(i), e.options.actions), a), 2), d = c[0];
				return l = c[1], u?.push(l), d;
			case b: return Ve(n, l, r);
			case T:
				l = me(l, r, [n], t), u?.push(l);
				break;
			default:
				var p = ke(n, e.options.actions), m = p.exec;
				if (m && u) {
					var _ = u.length - 1;
					p = f(f({}, p), { exec: function(e) {
						var t = [...arguments].slice(1);
						m.apply(void 0, g([u[_]], h(t), !1));
					} });
				}
				return p;
		}
	}).filter(function(e) {
		return !!e;
	})), l];
}
//#endregion
//#region ../../node_modules/xstate/es/serviceScope.js
var Ze = [], Qe = function(e, t) {
	Ze.push(e);
	var n = t(e);
	return Ze.pop(), n;
}, $e = function(e) {
	return e(Ze[Ze.length - 1]);
};
//#endregion
//#region ../../node_modules/xstate/es/Actor.js
function et(e) {
	var t;
	return t = {
		id: e,
		send: function() {},
		subscribe: function() {
			return { unsubscribe: function() {} };
		},
		getSnapshot: function() {},
		toJSON: function() {
			return { id: e };
		}
	}, t[K] = function() {
		return this;
	}, t;
}
function tt(e, t, n, r) {
	var i = we(e.src), a = t?.options.services?.[i.type], o = e.data ? se(e.data, n, r) : void 0, s = a ? nt(a, e.id, o) : et(e.id);
	return s.meta = e, s;
}
function nt(e, t, n) {
	var r = et(t);
	if (r.deferred = !0, ve(e)) {
		var i = r.state = Qe(void 0, function() {
			return (n ? e.withContext(n) : e).initialState;
		});
		r.getSnapshot = function() {
			return i;
		};
	}
	return r;
}
function rt(e) {
	try {
		return typeof e.send == "function";
	} catch {
		return !1;
	}
}
function it(e) {
	return rt(e) && "id" in e;
}
function at(e) {
	var t;
	return f((t = {
		subscribe: function() {
			return { unsubscribe: function() {} };
		},
		id: "anonymous",
		getSnapshot: function() {}
	}, t[K] = function() {
		return this;
	}, t), e);
}
//#endregion
//#region ../../node_modules/xstate/es/stateUtils.js
var ot = function(e) {
	return e.type === "atomic" || e.type === "final";
};
function st(e) {
	return Object.keys(e.states).map(function(t) {
		return e.states[t];
	}).filter(function(e) {
		return e.type !== "history";
	});
}
function ct(e) {
	var t = [e];
	return ot(e) ? t : t.concat(H(st(e).map(ct)));
}
function lt(e, t) {
	var n, r, i, a, o, s, c, l, u = dt(new Set(e)), d = new Set(t);
	try {
		for (var f = m(d), p = f.next(); !p.done; p = f.next()) for (var h = p.value, g = h.parent; g && !d.has(g);) d.add(g), g = g.parent;
	} catch (e) {
		n = { error: e };
	} finally {
		try {
			p && !p.done && (r = f.return) && r.call(f);
		} finally {
			if (n) throw n.error;
		}
	}
	var _ = dt(d);
	try {
		for (var v = m(d), y = v.next(); !y.done; y = v.next()) {
			var h = y.value;
			if (h.type === "compound" && (!_.get(h) || !_.get(h).length)) u.get(h) ? u.get(h).forEach(function(e) {
				return d.add(e);
			}) : h.initialStateNodes.forEach(function(e) {
				return d.add(e);
			});
			else if (h.type === "parallel") try {
				for (var b = (o = void 0, m(st(h))), x = b.next(); !x.done; x = b.next()) {
					var S = x.value;
					d.has(S) || (d.add(S), u.get(S) ? u.get(S).forEach(function(e) {
						return d.add(e);
					}) : S.initialStateNodes.forEach(function(e) {
						return d.add(e);
					}));
				}
			} catch (e) {
				o = { error: e };
			} finally {
				try {
					x && !x.done && (s = b.return) && s.call(b);
				} finally {
					if (o) throw o.error;
				}
			}
		}
	} catch (e) {
		i = { error: e };
	} finally {
		try {
			y && !y.done && (a = v.return) && a.call(v);
		} finally {
			if (i) throw i.error;
		}
	}
	try {
		for (var C = m(d), w = C.next(); !w.done; w = C.next()) for (var h = w.value, g = h.parent; g && !d.has(g);) d.add(g), g = g.parent;
	} catch (e) {
		c = { error: e };
	} finally {
		try {
			w && !w.done && (l = C.return) && l.call(C);
		} finally {
			if (c) throw c.error;
		}
	}
	return d;
}
function ut(e, t) {
	var n = t.get(e);
	if (!n) return {};
	if (e.type === "compound") {
		var r = n[0];
		if (r) {
			if (ot(r)) return r.key;
		} else return {};
	}
	var i = {};
	return n.forEach(function(e) {
		i[e.key] = ut(e, t);
	}), i;
}
function dt(e) {
	var t, n, r = /* @__PURE__ */ new Map();
	try {
		for (var i = m(e), a = i.next(); !a.done; a = i.next()) {
			var o = a.value;
			r.has(o) || r.set(o, []), o.parent && (r.has(o.parent) || r.set(o.parent, []), r.get(o.parent).push(o));
		}
	} catch (e) {
		t = { error: e };
	} finally {
		try {
			a && !a.done && (n = i.return) && n.call(i);
		} finally {
			if (t) throw t.error;
		}
	}
	return r;
}
function ft(e, t) {
	return ut(e, dt(lt([e], t)));
}
function pt(e, t) {
	return Array.isArray(e) ? e.some(function(e) {
		return e === t;
	}) : e instanceof Set ? e.has(t) : !1;
}
function mt(e) {
	return g([], h(new Set(H(g([], h(e.map(function(e) {
		return e.ownEvents;
	})), !1)))), !1);
}
function ht(e, t) {
	return t.type === "compound" ? st(t).some(function(t) {
		return t.type === "final" && pt(e, t);
	}) : t.type === "parallel" ? st(t).every(function(t) {
		return ht(e, t);
	}) : !1;
}
function gt(e) {
	return e === void 0 && (e = []), e.reduce(function(e, t) {
		return t.meta !== void 0 && (e[t.id] = t.meta), e;
	}, {});
}
function _t(e) {
	return new Set(H(e.map(function(e) {
		return e.tags;
	})));
}
//#endregion
//#region ../../node_modules/xstate/es/State.js
function vt(e, t) {
	if (e === t) return !0;
	if (e === void 0 || t === void 0) return !1;
	if (G(e) || G(t)) return e === t;
	var n = Object.keys(e), r = Object.keys(t);
	return n.length === r.length && n.every(function(n) {
		return vt(e[n], t[n]);
	});
}
function yt(e) {
	return typeof e != "object" || !e ? !1 : "value" in e && "_event" in e;
}
function bt(e, t) {
	var n = e.exec;
	return f(f({}, e), { exec: n === void 0 ? void 0 : function() {
		return n(t.context, t.event, {
			action: e,
			state: t,
			_event: t._event
		});
	} });
}
var xt = /* @__PURE__ */ function() {
	function e(e) {
		var t = this;
		this.actions = [], this.activities = P, this.meta = {}, this.events = [], this.value = e.value, this.context = e.context, this._event = e._event, this._sessionid = e._sessionid, this.event = this._event.data, this.historyValue = e.historyValue, this.history = e.history, this.actions = e.actions || [], this.activities = e.activities || P, this.meta = gt(e.configuration), this.events = e.events || [], this.matches = this.matches.bind(this), this.toStrings = this.toStrings.bind(this), this.configuration = e.configuration, this.transitions = e.transitions, this.children = e.children, this.done = !!e.done, this.tags = (Array.isArray(e.tags) ? new Set(e.tags) : e.tags) ?? /* @__PURE__ */ new Set(), this.machine = e.machine, Object.defineProperty(this, "nextEvents", { get: function() {
			return mt(t.configuration);
		} });
	}
	return e.from = function(t, n) {
		return t instanceof e ? t.context === n ? t : new e({
			value: t.value,
			context: n,
			_event: t._event,
			_sessionid: null,
			historyValue: t.historyValue,
			history: t.history,
			actions: [],
			activities: t.activities,
			meta: {},
			events: [],
			configuration: [],
			transitions: [],
			children: {}
		}) : new e({
			value: t,
			context: n,
			_event: De,
			_sessionid: null,
			historyValue: void 0,
			history: void 0,
			actions: [],
			activities: void 0,
			meta: void 0,
			events: [],
			configuration: [],
			transitions: [],
			children: {}
		});
	}, e.create = function(t) {
		return new e(t);
	}, e.inert = function(t, n) {
		if (t instanceof e) {
			if (!t.actions.length) return t;
			var r = De;
			return new e({
				value: t.value,
				context: n,
				_event: r,
				_sessionid: null,
				historyValue: t.historyValue,
				history: t.history,
				activities: t.activities,
				configuration: t.configuration,
				transitions: [],
				children: {}
			});
		}
		return e.from(t, n);
	}, e.prototype.toStrings = function(e, t) {
		var n = this;
		if (e === void 0 && (e = this.value), t === void 0 && (t = "."), G(e)) return [e];
		var r = Object.keys(e);
		return r.concat.apply(r, g([], h(r.map(function(r) {
			return n.toStrings(e[r], t).map(function(e) {
				return r + t + e;
			});
		})), !1));
	}, e.prototype.toJSON = function() {
		var e = this;
		e.configuration, e.transitions;
		var t = e.tags;
		return e.machine, f(f({}, p(e, [
			"configuration",
			"transitions",
			"tags",
			"machine"
		])), { tags: Array.from(t) });
	}, e.prototype.matches = function(e) {
		return I(e, this.value);
	}, e.prototype.hasTag = function(e) {
		return this.tags.has(e);
	}, e.prototype.can = function(e) {
		this.machine;
		var t = this.machine?.getTransitionData(this, e);
		return !!t?.transitions.length && t.transitions.some(function(e) {
			return e.target !== void 0 || e.actions.length;
		});
	}, e;
}(), St = { deferEvents: !1 }, Ct = /* @__PURE__ */ function() {
	function e(e) {
		this.processingEvent = !1, this.queue = [], this.initialized = !1, this.options = f(f({}, St), e);
	}
	return e.prototype.initialize = function(e) {
		if (this.initialized = !0, e) {
			if (!this.options.deferEvents) {
				this.schedule(e);
				return;
			}
			this.process(e);
		}
		this.flushEvents();
	}, e.prototype.schedule = function(e) {
		if (!this.initialized || this.processingEvent) {
			this.queue.push(e);
			return;
		}
		if (this.queue.length !== 0) throw Error("Event queue should be empty when it is not processing events");
		this.process(e), this.flushEvents();
	}, e.prototype.clear = function() {
		this.queue = [];
	}, e.prototype.flushEvents = function() {
		for (var e = this.queue.shift(); e;) this.process(e), e = this.queue.shift();
	}, e.prototype.process = function(e) {
		this.processingEvent = !0;
		try {
			e();
		} catch (e) {
			throw this.clear(), e;
		} finally {
			this.processingEvent = !1;
		}
	}, e;
}(), wt = /* @__PURE__ */ new Map(), Tt = 0, Et = {
	bookId: function() {
		return `x:${Tt++}`;
	},
	register: function(e, t) {
		return wt.set(e, t), e;
	},
	get: function(e) {
		return wt.get(e);
	},
	free: function(e) {
		wt.delete(e);
	}
};
//#endregion
//#region ../../node_modules/xstate/es/devTools.js
function Dt() {
	if (typeof globalThis < "u") return globalThis;
	if (typeof self < "u") return self;
	if (typeof window < "u") return window;
	if (typeof global < "u") return global;
}
function Ot() {
	var e = Dt();
	if (e && "__xstate__" in e) return e.__xstate__;
}
function kt(e) {
	if (Dt()) {
		var t = Ot();
		t && t.register(e);
	}
}
//#endregion
//#region ../../node_modules/xstate/es/behaviors.js
function At(e, t) {
	t === void 0 && (t = {});
	var n = e.initialState, r = /* @__PURE__ */ new Set(), i = [], a = !1, o = function() {
		if (!a) {
			for (a = !0; i.length > 0;) {
				var t = i.shift();
				n = e.transition(n, t, c), r.forEach(function(e) {
					return e.next(n);
				});
			}
			a = !1;
		}
	}, s = at({
		id: t.id,
		send: function(e) {
			i.push(e), o();
		},
		getSnapshot: function() {
			return n;
		},
		subscribe: function(e, t, i) {
			var a = Te(e, t, i);
			return r.add(a), a.next(n), { unsubscribe: function() {
				r.delete(a);
			} };
		}
	}), c = {
		parent: t.parent,
		self: s,
		id: t.id || "anonymous",
		observers: r
	};
	return n = e.start ? e.start(c) : n, s;
}
//#endregion
//#region ../../node_modules/xstate/es/interpreter.js
var jt = {
	sync: !1,
	autoForward: !1
}, Y;
(function(e) {
	e[e.NotStarted = 0] = "NotStarted", e[e.Running = 1] = "Running", e[e.Stopped = 2] = "Stopped";
})(Y ||= {});
var Mt = /* @__PURE__ */ function() {
	function e(t, n) {
		var r = this;
		n === void 0 && (n = e.defaultOptions), this.machine = t, this.delayedEventsMap = {}, this.listeners = /* @__PURE__ */ new Set(), this.contextListeners = /* @__PURE__ */ new Set(), this.stopListeners = /* @__PURE__ */ new Set(), this.doneListeners = /* @__PURE__ */ new Set(), this.eventListeners = /* @__PURE__ */ new Set(), this.sendListeners = /* @__PURE__ */ new Set(), this.initialized = !1, this.status = Y.NotStarted, this.children = /* @__PURE__ */ new Map(), this.forwardTo = /* @__PURE__ */ new Set(), this.init = this.start, this.send = function(e, t) {
			if (he(e)) return r.batch(e), r.state;
			var n = J(be(e, t));
			if (r.status === Y.Stopped) return r.state;
			if (r.status !== Y.Running && !r.options.deferEvents) throw Error(`Event "${n.name}" was sent to uninitialized service "${r.machine.id}". Make sure .start() is called for this service, or set { deferEvents: true } in the service options.
Event: ${JSON.stringify(n.data)}`);
			return r.scheduler.schedule(function() {
				r.forward(n);
				var e = r.nextState(n);
				r.update(e, n);
			}), r._state;
		}, this.sendTo = function(e, t) {
			var n = r.parent && (t === v.Parent || r.parent.id === t), i = n ? r.parent : G(t) ? r.children.get(t) || Et.get(t) : q(t) ? t : void 0;
			if (!i) {
				if (!n) throw Error(`Unable to send event to child '${t}' from service '${r.id}'.`);
				return;
			}
			"machine" in i ? i.send(f(f({}, e), {
				name: e.name === A ? `${Ke(r.id)}` : e.name,
				origin: r.sessionId
			})) : i.send(e.data);
		};
		var i = f(f({}, e.defaultOptions), n), a = i.clock, o = i.logger, s = i.parent, c = i.id, l = c === void 0 ? t.id : c;
		this.id = l, this.logger = o, this.clock = a, this.parent = s, this.options = i, this.scheduler = new Ct({ deferEvents: this.options.deferEvents }), this.sessionId = Et.bookId();
	}
	return Object.defineProperty(e.prototype, "initialState", {
		get: function() {
			var e = this;
			return this._initialState ? this._initialState : Qe(this, function() {
				return e._initialState = e.machine.initialState, e._initialState;
			});
		},
		enumerable: !1,
		configurable: !0
	}), Object.defineProperty(e.prototype, "state", {
		get: function() {
			return this._state;
		},
		enumerable: !1,
		configurable: !0
	}), e.prototype.execute = function(e, t) {
		var n, r;
		try {
			for (var i = m(e.actions), a = i.next(); !a.done; a = i.next()) {
				var o = a.value;
				this.exec(o, e, t);
			}
		} catch (e) {
			n = { error: e };
		} finally {
			try {
				a && !a.done && (r = i.return) && r.call(i);
			} finally {
				if (n) throw n.error;
			}
		}
	}, e.prototype.update = function(e, t) {
		var n, r, i, a, o, s, c, l, u = this;
		if (e._sessionid = this.sessionId, this._state = e, this.options.execute && this.execute(this.state), this.children.forEach(function(e) {
			u.state.children[e.id] = e;
		}), this.devTools && this.devTools.send(t.data, e), e.event) try {
			for (var d = m(this.eventListeners), f = d.next(); !f.done; f = d.next()) {
				var p = f.value;
				p(e.event);
			}
		} catch (e) {
			n = { error: e };
		} finally {
			try {
				f && !f.done && (r = d.return) && r.call(d);
			} finally {
				if (n) throw n.error;
			}
		}
		try {
			for (var h = m(this.listeners), g = h.next(); !g.done; g = h.next()) {
				var p = g.value;
				p(e, e.event);
			}
		} catch (e) {
			i = { error: e };
		} finally {
			try {
				g && !g.done && (a = h.return) && a.call(h);
			} finally {
				if (i) throw i.error;
			}
		}
		try {
			for (var _ = m(this.contextListeners), v = _.next(); !v.done; v = _.next()) {
				var y = v.value;
				y(this.state.context, this.state.history ? this.state.history.context : void 0);
			}
		} catch (e) {
			o = { error: e };
		} finally {
			try {
				v && !v.done && (s = _.return) && s.call(_);
			} finally {
				if (o) throw o.error;
			}
		}
		var b = ht(e.configuration || [], this.machine);
		if (this.state.configuration && b) {
			var x = e.configuration.find(function(e) {
				return e.type === "final" && e.parent === u.machine;
			}), S = x && x.doneData ? se(x.doneData, e.context, t) : void 0;
			try {
				for (var C = m(this.doneListeners), w = C.next(); !w.done; w = C.next()) {
					var p = w.value;
					p(Ge(this.id, S));
				}
			} catch (e) {
				c = { error: e };
			} finally {
				try {
					w && !w.done && (l = C.return) && l.call(C);
				} finally {
					if (c) throw c.error;
				}
			}
			this.stop();
		}
	}, e.prototype.onTransition = function(e) {
		return this.listeners.add(e), this.status === Y.Running && e(this.state, this.state.event), this;
	}, e.prototype.subscribe = function(e, t, n) {
		var r = this;
		if (!e) return { unsubscribe: function() {} };
		var i, a = n;
		return typeof e == "function" ? i = e : (i = e.next.bind(e), a = e.complete.bind(e)), this.listeners.add(i), this.status !== Y.NotStarted && i(this.state), a && (this.status === Y.Stopped ? a() : this.onDone(a)), { unsubscribe: function() {
			i && r.listeners.delete(i), a && r.doneListeners.delete(a);
		} };
	}, e.prototype.onEvent = function(e) {
		return this.eventListeners.add(e), this;
	}, e.prototype.onSend = function(e) {
		return this.sendListeners.add(e), this;
	}, e.prototype.onChange = function(e) {
		return this.contextListeners.add(e), this;
	}, e.prototype.onStop = function(e) {
		return this.stopListeners.add(e), this;
	}, e.prototype.onDone = function(e) {
		return this.doneListeners.add(e), this;
	}, e.prototype.off = function(e) {
		return this.listeners.delete(e), this.eventListeners.delete(e), this.sendListeners.delete(e), this.stopListeners.delete(e), this.doneListeners.delete(e), this.contextListeners.delete(e), this;
	}, e.prototype.start = function(e) {
		var t = this;
		if (this.status === Y.Running) return this;
		this.machine._init(), Et.register(this.sessionId, this), this.initialized = !0, this.status = Y.Running;
		var n = e === void 0 ? this.initialState : Qe(this, function() {
			return yt(e) ? t.machine.resolveState(e) : t.machine.resolveState(xt.from(e, t.machine.context));
		});
		return this.options.devTools && this.attachDev(), this.scheduler.initialize(function() {
			t.update(n, De);
		}), this;
	}, e.prototype.stop = function() {
		var e, t, n, r, i, a, o, s, c, l, u = this;
		try {
			for (var d = m(this.listeners), f = d.next(); !f.done; f = d.next()) {
				var p = f.value;
				this.listeners.delete(p);
			}
		} catch (t) {
			e = { error: t };
		} finally {
			try {
				f && !f.done && (t = d.return) && t.call(d);
			} finally {
				if (e) throw e.error;
			}
		}
		try {
			for (var _ = m(this.stopListeners), v = _.next(); !v.done; v = _.next()) {
				var p = v.value;
				p(), this.stopListeners.delete(p);
			}
		} catch (e) {
			n = { error: e };
		} finally {
			try {
				v && !v.done && (r = _.return) && r.call(_);
			} finally {
				if (n) throw n.error;
			}
		}
		try {
			for (var y = m(this.contextListeners), b = y.next(); !b.done; b = y.next()) {
				var p = b.value;
				this.contextListeners.delete(p);
			}
		} catch (e) {
			i = { error: e };
		} finally {
			try {
				b && !b.done && (a = y.return) && a.call(y);
			} finally {
				if (i) throw i.error;
			}
		}
		try {
			for (var x = m(this.doneListeners), S = x.next(); !S.done; S = x.next()) {
				var p = S.value;
				this.doneListeners.delete(p);
			}
		} catch (e) {
			o = { error: e };
		} finally {
			try {
				S && !S.done && (s = x.return) && s.call(x);
			} finally {
				if (o) throw o.error;
			}
		}
		if (!this.initialized) return this;
		g([], h(this.state.configuration), !1).sort(function(e, t) {
			return t.order - e.order;
		}).forEach(function(e) {
			var t, n;
			try {
				for (var r = m(e.definition.exit), i = r.next(); !i.done; i = r.next()) {
					var a = i.value;
					u.exec(a, u.state);
				}
			} catch (e) {
				t = { error: e };
			} finally {
				try {
					i && !i.done && (n = r.return) && n.call(r);
				} finally {
					if (t) throw t.error;
				}
			}
		}), this.children.forEach(function(e) {
			W(e.stop) && e.stop();
		}), this.children.clear();
		try {
			for (var C = m(Object.keys(this.delayedEventsMap)), w = C.next(); !w.done; w = C.next()) {
				var T = w.value;
				this.clock.clearTimeout(this.delayedEventsMap[T]);
			}
		} catch (e) {
			c = { error: e };
		} finally {
			try {
				w && !w.done && (l = C.return) && l.call(C);
			} finally {
				if (c) throw c.error;
			}
		}
		return this.scheduler.clear(), this.scheduler = new Ct({ deferEvents: this.options.deferEvents }), this.initialized = !1, this.status = Y.Stopped, this._initialState = void 0, Et.free(this.sessionId), this;
	}, e.prototype.batch = function(e) {
		var t = this;
		if (!(this.status === Y.NotStarted && this.options.deferEvents) && this.status !== Y.Running) throw Error(`${e.length} event(s) were sent to uninitialized service "${this.machine.id}". Make sure .start() is called for this service, or set { deferEvents: true } in the service options.`);
		this.scheduler.schedule(function() {
			var n, r, i = t.state, a = !1, o = [], s = function(e) {
				var n = J(e);
				t.forward(n), i = Qe(t, function() {
					return t.machine.transition(i, n);
				}), o.push.apply(o, g([], h(i.actions.map(function(e) {
					return bt(e, i);
				})), !1)), a ||= !!i.changed;
			};
			try {
				for (var c = m(e), l = c.next(); !l.done; l = c.next()) {
					var u = l.value;
					s(u);
				}
			} catch (e) {
				n = { error: e };
			} finally {
				try {
					l && !l.done && (r = c.return) && r.call(c);
				} finally {
					if (n) throw n.error;
				}
			}
			i.changed = a, i.actions = o, t.update(i, J(e[e.length - 1]));
		});
	}, e.prototype.sender = function(e) {
		return this.send.bind(this, e);
	}, e.prototype.nextState = function(e) {
		var t = this, n = J(e);
		if (n.name.indexOf(k) === 0 && !this.state.nextEvents.some(function(e) {
			return e.indexOf(k) === 0;
		})) throw n.data.data;
		return Qe(this, function() {
			return t.machine.transition(t.state, n);
		});
	}, e.prototype.forward = function(e) {
		var t, n;
		try {
			for (var r = m(this.forwardTo), i = r.next(); !i.done; i = r.next()) {
				var a = i.value, o = this.children.get(a);
				if (!o) throw Error(`Unable to forward event '${e}' from interpreter '${this.id}' to nonexistant child '${a}'.`);
				o.send(e);
			}
		} catch (e) {
			t = { error: e };
		} finally {
			try {
				i && !i.done && (n = r.return) && n.call(r);
			} finally {
				if (t) throw t.error;
			}
		}
	}, e.prototype.defer = function(e) {
		var t = this;
		this.delayedEventsMap[e.id] = this.clock.setTimeout(function() {
			e.to ? t.sendTo(e._event, e.to) : t.send(e._event);
		}, e.delay);
	}, e.prototype.cancel = function(e) {
		this.clock.clearTimeout(this.delayedEventsMap[e]), delete this.delayedEventsMap[e];
	}, e.prototype.exec = function(e, t, n) {
		n === void 0 && (n = this.machine.options.actions);
		var r = t.context, i = t._event, a = e.exec || Oe(e.type, n), o = W(a) ? a : a ? a.exec : e.exec;
		if (o) try {
			return o(r, i.data, {
				action: e,
				state: this.state,
				_event: i
			});
		} catch (e) {
			throw this.parent && this.parent.send({
				type: "xstate.error",
				data: e
			}), e;
		}
		switch (e.type) {
			case S:
				var s = e;
				if (typeof s.delay == "number") {
					this.defer(s);
					return;
				} else s.to ? this.sendTo(s._event, s.to) : this.send(s._event);
				break;
			case C:
				this.cancel(e.sendId);
				break;
			case y:
				if (this.status !== Y.Running) return;
				var c = e.activity;
				if (!this.state.activities[c.id || c.type]) break;
				if (c.type === _.Invoke) {
					var l = we(c.src), u = this.machine.options.services ? this.machine.options.services[l.type] : void 0, d = c.id, f = c.data, p = "autoForward" in c ? c.autoForward : !!c.forward;
					if (!u) return;
					var m = f ? se(f, r, i) : void 0;
					if (typeof u == "string") return;
					var h = W(u) ? u(r, i.data, {
						data: m,
						src: l,
						meta: c.meta
					}) : u;
					if (!h) return;
					var g = void 0;
					ve(h) && (h = m ? h.withContext(m) : h, g = { autoForward: p }), this.spawn(h, d, g);
				} else this.spawnActivity(c);
				break;
			case b:
				this.stopChild(e.activity.id);
				break;
			case E:
				var v = e.label, x = e.value;
				v ? this.logger(v, x) : this.logger(x);
				break;
			default: break;
		}
	}, e.prototype.removeChild = function(e) {
		var t;
		this.children.delete(e), this.forwardTo.delete(e), (t = this.state) == null || delete t.children[e];
	}, e.prototype.stopChild = function(e) {
		var t = this.children.get(e);
		t && (this.removeChild(e), W(t.stop) && t.stop());
	}, e.prototype.spawn = function(e, t, n) {
		if (le(e)) return this.spawnPromise(Promise.resolve(e), t);
		if (W(e)) return this.spawnCallback(e, t);
		if (it(e)) return this.spawnActor(e, t);
		if (_e(e)) return this.spawnObservable(e, t);
		if (ve(e)) return this.spawnMachine(e, f(f({}, n), { id: t }));
		if (ue(e)) return this.spawnBehavior(e, t);
		throw Error(`Unable to spawn entity "${t}" of type "${typeof e}".`);
	}, e.prototype.spawnMachine = function(t, n) {
		var r = this;
		n === void 0 && (n = {});
		var i = new e(t, f(f({}, this.options), {
			parent: this,
			id: n.id || t.id
		})), a = f(f({}, jt), n);
		a.sync && i.onTransition(function(e) {
			r.send(j, {
				state: e,
				id: i.id
			});
		});
		var o = i;
		return this.children.set(i.id, o), a.autoForward && this.forwardTo.add(i.id), i.onDone(function(e) {
			r.removeChild(i.id), r.send(J(e, { origin: i.id }));
		}).start(), o;
	}, e.prototype.spawnBehavior = function(e, t) {
		var n = At(e, {
			id: t,
			parent: this
		});
		return this.children.set(t, n), n;
	}, e.prototype.spawnPromise = function(e, t) {
		var n, r = this, i = !1, a;
		e.then(function(e) {
			i || (a = e, r.removeChild(t), r.send(J(Ge(t, e), { origin: t })));
		}, function(e) {
			if (!i) {
				r.removeChild(t);
				var n = Ke(t, e);
				try {
					r.send(J(n, { origin: t }));
				} catch {
					r.devTools && r.devTools.send(n, r.state), r.machine.strict && r.stop();
				}
			}
		});
		var o = (n = {
			id: t,
			send: function() {},
			subscribe: function(t, n, r) {
				var i = Te(t, n, r), a = !1;
				return e.then(function(e) {
					a || (i.next(e), !a && i.complete());
				}, function(e) {
					a || i.error(e);
				}), { unsubscribe: function() {
					return a = !0;
				} };
			},
			stop: function() {
				i = !0;
			},
			toJSON: function() {
				return { id: t };
			},
			getSnapshot: function() {
				return a;
			}
		}, n[K] = function() {
			return this;
		}, n);
		return this.children.set(t, o), o;
	}, e.prototype.spawnCallback = function(e, t) {
		var n, r = this, i = !1, a = /* @__PURE__ */ new Set(), o = /* @__PURE__ */ new Set(), s, c = function(e) {
			s = e, o.forEach(function(t) {
				return t(e);
			}), !i && r.send(J(e, { origin: t }));
		}, l;
		try {
			l = e(c, function(e) {
				a.add(e);
			});
		} catch (e) {
			this.send(Ke(t, e));
		}
		if (le(l)) return this.spawnPromise(l, t);
		var u = (n = {
			id: t,
			send: function(e) {
				return a.forEach(function(t) {
					return t(e);
				});
			},
			subscribe: function(e) {
				var t = Te(e);
				return o.add(t.next), { unsubscribe: function() {
					o.delete(t.next);
				} };
			},
			stop: function() {
				i = !0, W(l) && l();
			},
			toJSON: function() {
				return { id: t };
			},
			getSnapshot: function() {
				return s;
			}
		}, n[K] = function() {
			return this;
		}, n);
		return this.children.set(t, u), u;
	}, e.prototype.spawnObservable = function(e, t) {
		var n, r = this, i, a = e.subscribe(function(e) {
			i = e, r.send(J(e, { origin: t }));
		}, function(e) {
			r.removeChild(t), r.send(J(Ke(t, e), { origin: t }));
		}, function() {
			r.removeChild(t), r.send(J(Ge(t), { origin: t }));
		}), o = (n = {
			id: t,
			send: function() {},
			subscribe: function(t, n, r) {
				return e.subscribe(t, n, r);
			},
			stop: function() {
				return a.unsubscribe();
			},
			getSnapshot: function() {
				return i;
			},
			toJSON: function() {
				return { id: t };
			}
		}, n[K] = function() {
			return this;
		}, n);
		return this.children.set(t, o), o;
	}, e.prototype.spawnActor = function(e, t) {
		return this.children.set(t, e), e;
	}, e.prototype.spawnActivity = function(e) {
		var t = this.machine.options && this.machine.options.activities ? this.machine.options.activities[e.type] : void 0;
		if (t) {
			var n = t(this.state.context, e);
			this.spawnEffect(e.id, n);
		}
	}, e.prototype.spawnEffect = function(e, t) {
		var n;
		this.children.set(e, (n = {
			id: e,
			send: function() {},
			subscribe: function() {
				return { unsubscribe: function() {} };
			},
			stop: t || void 0,
			getSnapshot: function() {},
			toJSON: function() {
				return { id: e };
			}
		}, n[K] = function() {
			return this;
		}, n));
	}, e.prototype.attachDev = function() {
		var e = Dt();
		if (this.options.devTools && e) {
			if (e.__REDUX_DEVTOOLS_EXTENSION__) {
				var t = typeof this.options.devTools == "object" ? this.options.devTools : void 0;
				this.devTools = e.__REDUX_DEVTOOLS_EXTENSION__.connect(f(f({
					name: this.id,
					autoPause: !0,
					stateSanitizer: function(e) {
						return {
							value: e.value,
							context: e.context,
							actions: e.actions
						};
					}
				}, t), { features: f({
					jump: !1,
					skip: !1
				}, t ? t.features : void 0) }), this.machine), this.devTools.init(this.state);
			}
			kt(this);
		}
	}, e.prototype.toJSON = function() {
		return { id: this.id };
	}, e.prototype[K] = function() {
		return this;
	}, e.prototype.getSnapshot = function() {
		return this.status === Y.NotStarted ? this.initialState : this._state;
	}, e.defaultOptions = {
		execute: !0,
		deferEvents: !0,
		clock: {
			setTimeout: function(e, t) {
				return setTimeout(e, t);
			},
			clearTimeout: function(e) {
				return clearTimeout(e);
			}
		},
		logger: /* @__PURE__ */ console.log.bind(console),
		devTools: !1
	}, e.interpret = Ft, e;
}(), Nt = function(e) {
	return G(e) ? f(f({}, jt), { name: e }) : f(f(f({}, jt), { name: ye() }), e);
};
function Pt(e, t) {
	var n = Nt(t);
	return $e(function(t) {
		return t ? t.spawn(e, n.name, n) : nt(e, n.name);
	});
}
function Ft(e, t) {
	return new Mt(e, t);
}
//#endregion
//#region ../../node_modules/xstate/es/invokeUtils.js
function It(e) {
	if (typeof e == "string") {
		var t = { type: e };
		return t.toString = function() {
			return e;
		}, t;
	}
	return e;
}
function Lt(e) {
	return f(f({ type: O }, e), { toJSON: function() {
		return e.onDone, e.onError, f(f({}, p(e, ["onDone", "onError"])), {
			type: O,
			src: It(e.src)
		});
	} });
}
//#endregion
//#region ../../node_modules/xstate/es/StateNode.js
var Rt = "", zt = "#", Bt = "*", Vt = {}, Ht = function(e) {
	return e[0] === zt;
}, Ut = function() {
	return {
		actions: {},
		guards: {},
		services: {},
		activities: {},
		delays: {}
	};
}, Wt = /* @__PURE__ */ function() {
	function e(t, n, r, i) {
		var a = this;
		r === void 0 && (r = "context" in t ? t.context : void 0), this.config = t, this._context = r, this.order = -1, this.__xstatenode = !0, this.__cache = {
			events: void 0,
			relativeValue: /* @__PURE__ */ new Map(),
			initialStateValue: void 0,
			initialState: void 0,
			on: void 0,
			transitions: void 0,
			candidates: {},
			delayedTransitions: void 0
		}, this.idMap = {}, this.tags = [], this.options = Object.assign(Ut(), n), this.parent = i?.parent, this.key = this.config.key || i?.key || this.config.id || "(machine)", this.machine = this.parent ? this.parent.machine : this, this.path = this.parent ? this.parent.path.concat(this.key) : [], this.delimiter = this.config.delimiter || (this.parent ? this.parent.delimiter : "."), this.id = this.config.id || g([this.machine.key], h(this.path), !1).join(this.delimiter), this.version = this.parent ? this.parent.version : this.config.version, this.type = this.config.type || (this.config.parallel ? "parallel" : this.config.states && Object.keys(this.config.states).length ? "compound" : this.config.history ? "history" : "atomic"), this.schema = this.parent ? this.machine.schema : this.config.schema ?? {}, this.description = this.config.description, this.initial = this.config.initial, this.states = this.config.states ? ne(this.config.states, function(t, n) {
			var r, i = new e(t, {}, void 0, {
				parent: a,
				key: n
			});
			return Object.assign(a.idMap, f((r = {}, r[i.id] = i, r), i.idMap)), i;
		}) : Vt;
		var o = 0;
		function s(e) {
			var t, n;
			e.order = o++;
			try {
				for (var r = m(st(e)), i = r.next(); !i.done; i = r.next()) {
					var a = i.value;
					s(a);
				}
			} catch (e) {
				t = { error: e };
			} finally {
				try {
					i && !i.done && (n = r.return) && n.call(r);
				} finally {
					if (t) throw t.error;
				}
			}
		}
		s(this), this.history = this.config.history === !0 ? "shallow" : this.config.history || !1, this._transient = !!this.config.always || (this.config.on ? Array.isArray(this.config.on) ? this.config.on.some(function(e) {
			return e.event === Rt;
		}) : Rt in this.config.on : !1), this.strict = !!this.config.strict, this.onEntry = U(this.config.entry || this.config.onEntry).map(function(e) {
			return ke(e);
		}), this.onExit = U(this.config.exit || this.config.onExit).map(function(e) {
			return ke(e);
		}), this.meta = this.config.meta, this.doneData = this.type === "final" ? this.config.data : void 0, this.invoke = U(this.config.invoke).map(function(e, t) {
			var n, r;
			if (ve(e)) {
				var i = Ee(a.id, t);
				return a.machine.options.services = f((n = {}, n[i] = e, n), a.machine.options.services), Lt({
					src: i,
					id: i
				});
			} else if (G(e.src)) {
				var i = e.id || Ee(a.id, t);
				return Lt(f(f({}, e), {
					id: i,
					src: e.src
				}));
			} else if (ve(e.src) || W(e.src)) {
				var i = e.id || Ee(a.id, t);
				return a.machine.options.services = f((r = {}, r[i] = e.src, r), a.machine.options.services), Lt(f(f({ id: i }, e), { src: i }));
			} else {
				var o = e.src;
				return Lt(f(f({ id: Ee(a.id, t) }, e), { src: o }));
			}
		}), this.activities = U(this.config.activities).concat(this.invoke).map(function(e) {
			return je(e);
		}), this.transition = this.transition.bind(this), this.tags = U(this.config.tags);
	}
	return e.prototype._init = function() {
		this.__cache.transitions || ct(this).forEach(function(e) {
			return e.on;
		});
	}, e.prototype.withConfig = function(t, n) {
		var r = this.options, i = r.actions, a = r.activities, o = r.guards, s = r.services, c = r.delays;
		return new e(this.config, {
			actions: f(f({}, i), t.actions),
			activities: f(f({}, a), t.activities),
			guards: f(f({}, o), t.guards),
			services: f(f({}, s), t.services),
			delays: f(f({}, c), t.delays)
		}, n ?? this.context);
	}, e.prototype.withContext = function(t) {
		return new e(this.config, this.options, t);
	}, Object.defineProperty(e.prototype, "context", {
		get: function() {
			return W(this._context) ? this._context() : this._context;
		},
		enumerable: !1,
		configurable: !0
	}), Object.defineProperty(e.prototype, "definition", {
		get: function() {
			return {
				id: this.id,
				key: this.key,
				version: this.version,
				context: this.context,
				type: this.type,
				initial: this.initial,
				history: this.history,
				states: ne(this.states, function(e) {
					return e.definition;
				}),
				on: this.on,
				transitions: this.transitions,
				entry: this.onEntry,
				exit: this.onExit,
				activities: this.activities || [],
				meta: this.meta,
				order: this.order || -1,
				data: this.doneData,
				invoke: this.invoke,
				description: this.description,
				tags: this.tags
			};
		},
		enumerable: !1,
		configurable: !0
	}), e.prototype.toJSON = function() {
		return this.definition;
	}, Object.defineProperty(e.prototype, "on", {
		get: function() {
			if (this.__cache.on) return this.__cache.on;
			var e = this.transitions;
			return this.__cache.on = e.reduce(function(e, t) {
				return e[t.eventType] = e[t.eventType] || [], e[t.eventType].push(t), e;
			}, {});
		},
		enumerable: !1,
		configurable: !0
	}), Object.defineProperty(e.prototype, "after", {
		get: function() {
			return this.__cache.delayedTransitions || (this.__cache.delayedTransitions = this.getDelayedTransitions(), this.__cache.delayedTransitions);
		},
		enumerable: !1,
		configurable: !0
	}), Object.defineProperty(e.prototype, "transitions", {
		get: function() {
			return this.__cache.transitions || (this.__cache.transitions = this.formatTransitions(), this.__cache.transitions);
		},
		enumerable: !1,
		configurable: !0
	}), e.prototype.getCandidates = function(e) {
		if (this.__cache.candidates[e]) return this.__cache.candidates[e];
		var t = e === Rt, n = this.transitions.filter(function(n) {
			var r = n.eventType === e;
			return t ? r : r || n.eventType === Bt;
		});
		return this.__cache.candidates[e] = n, n;
	}, e.prototype.getDelayedTransitions = function() {
		var e = this, t = this.config.after;
		if (!t) return [];
		var n = function(t, n) {
			var r = Ue(W(t) ? `${e.id}:delay[${n}]` : t, e.id);
			return e.onEntry.push(Pe(r, { delay: t })), e.onExit.push(Re(r)), r;
		};
		return (he(t) ? t.map(function(e, t) {
			var r = n(e.delay, t);
			return f(f({}, e), { event: r });
		}) : H(Object.keys(t).map(function(e, r) {
			var i = t[e], a = G(i) ? { target: i } : i, o = isNaN(+e) ? e : +e, s = n(o, r);
			return U(a).map(function(e) {
				return f(f({}, e), {
					event: s,
					delay: o
				});
			});
		}))).map(function(t) {
			var n = t.delay;
			return f(f({}, e.formatTransition(t)), { delay: n });
		});
	}, e.prototype.getStateNodes = function(e) {
		var t, n = this;
		if (!e) return [];
		var r = e instanceof xt ? e.value : B(e, this.delimiter);
		if (G(r)) {
			var i = this.getStateNode(r).initial;
			return i === void 0 ? [this, this.states[r]] : this.getStateNodes((t = {}, t[r] = i, t));
		}
		var a = Object.keys(r), o = [this];
		return o.push.apply(o, g([], h(H(a.map(function(e) {
			return n.getStateNode(e).getStateNodes(r[e]);
		}))), !1)), o;
	}, e.prototype.handles = function(e) {
		var t = L(e);
		return this.events.includes(t);
	}, e.prototype.resolveState = function(e) {
		var t = e instanceof xt ? e : xt.create(e), n = Array.from(lt([], this.getStateNodes(t.value)));
		return new xt(f(f({}, t), {
			value: this.resolve(t.value),
			configuration: n,
			done: ht(n, this),
			tags: _t(n),
			machine: this.machine
		}));
	}, e.prototype.transitionLeafNode = function(e, t, n) {
		var r = this.getStateNode(e).next(t, n);
		return !r || !r.transitions.length ? this.next(t, n) : r;
	}, e.prototype.transitionCompoundNode = function(e, t, n) {
		var r = Object.keys(e), i = this.getStateNode(r[0])._transition(e[r[0]], t, n);
		return !i || !i.transitions.length ? this.next(t, n) : i;
	}, e.prototype.transitionParallelNode = function(e, t, n) {
		var r, i, a = {};
		try {
			for (var o = m(Object.keys(e)), s = o.next(); !s.done; s = o.next()) {
				var c = s.value, l = e[c];
				if (l) {
					var u = this.getStateNode(c)._transition(l, t, n);
					u && (a[c] = u);
				}
			}
		} catch (e) {
			r = { error: e };
		} finally {
			try {
				s && !s.done && (i = o.return) && i.call(o);
			} finally {
				if (r) throw r.error;
			}
		}
		var d = Object.keys(a).map(function(e) {
			return a[e];
		}), f = H(d.map(function(e) {
			return e.transitions;
		}));
		if (!d.some(function(e) {
			return e.transitions.length > 0;
		})) return this.next(t, n);
		var p = H(d.map(function(e) {
			return e.entrySet;
		})), h = H(Object.keys(a).map(function(e) {
			return a[e].configuration;
		}));
		return {
			transitions: f,
			entrySet: p,
			exitSet: H(d.map(function(e) {
				return e.exitSet;
			})),
			configuration: h,
			source: t,
			actions: H(Object.keys(a).map(function(e) {
				return a[e].actions;
			}))
		};
	}, e.prototype._transition = function(e, t, n) {
		return G(e) ? this.transitionLeafNode(e, t, n) : Object.keys(e).length === 1 ? this.transitionCompoundNode(e, t, n) : this.transitionParallelNode(e, t, n);
	}, e.prototype.getTransitionData = function(e, t) {
		return this._transition(e.value, e, J(t));
	}, e.prototype.next = function(e, t) {
		var n, r, i = this, a = t.name, o = [], s = [], c;
		try {
			for (var l = m(this.getCandidates(a)), u = l.next(); !u.done; u = l.next()) {
				var d = u.value, f = d.cond, p = d.in, _ = e.context, v = p ? G(p) && Ht(p) ? e.matches(B(this.getStateNodeById(p).path, this.delimiter)) : I(B(p, this.delimiter), re(this.path.slice(0, -2))(e.value)) : !0, y = !1;
				try {
					y = !f || Ce(this.machine, f, _, t, e);
				} catch (e) {
					throw Error(`Unable to evaluate guard '${f.name || f.type}' in transition for event '${a}' in state node '${this.id}':
${e.message}`);
				}
				if (y && v) {
					d.target !== void 0 && (s = d.target), o.push.apply(o, g([], h(d.actions), !1)), c = d;
					break;
				}
			}
		} catch (e) {
			n = { error: e };
		} finally {
			try {
				u && !u.done && (r = l.return) && r.call(l);
			} finally {
				if (n) throw n.error;
			}
		}
		if (c) {
			if (!s.length) return {
				transitions: [c],
				entrySet: [],
				exitSet: [],
				configuration: e.value ? [this] : [],
				source: e,
				actions: o
			};
			var b = H(s.map(function(t) {
				return i.getRelativeStateNodes(t, e.historyValue);
			})), x = !!c.internal, S = x ? [] : H(b.map(function(e) {
				return i.nodesFromChild(e);
			}));
			return {
				transitions: [c],
				entrySet: S,
				exitSet: x ? [] : [this],
				configuration: b,
				source: e,
				actions: o
			};
		}
	}, e.prototype.nodesFromChild = function(e) {
		if (e.escapes(this)) return [];
		for (var t = [], n = e; n && n !== this;) t.push(n), n = n.parent;
		return t.push(this), t;
	}, e.prototype.escapes = function(e) {
		if (this === e) return !1;
		for (var t = this.parent; t;) {
			if (t === e) return !1;
			t = t.parent;
		}
		return !0;
	}, e.prototype.getActions = function(e, t, n, r) {
		var i, a, o, s, c = lt([], r ? this.getStateNodes(r.value) : [this]), l = e.configuration.length ? lt(c, e.configuration) : c;
		try {
			for (var u = m(l), d = u.next(); !d.done; d = u.next()) {
				var f = d.value;
				pt(c, f) || e.entrySet.push(f);
			}
		} catch (e) {
			i = { error: e };
		} finally {
			try {
				d && !d.done && (a = u.return) && a.call(u);
			} finally {
				if (i) throw i.error;
			}
		}
		try {
			for (var p = m(c), _ = p.next(); !_.done; _ = p.next()) {
				var f = _.value;
				(!pt(l, f) || pt(e.exitSet, f.parent)) && e.exitSet.push(f);
			}
		} catch (e) {
			o = { error: e };
		} finally {
			try {
				_ && !_.done && (s = p.return) && s.call(p);
			} finally {
				if (o) throw o.error;
			}
		}
		var v = H(e.entrySet.map(function(r) {
			var i = [];
			if (r.type !== "final") return i;
			var a = r.parent;
			if (!a.parent) return i;
			i.push(We(r.id, r.doneData), We(a.id, r.doneData ? se(r.doneData, t, n) : void 0));
			var o = a.parent;
			return o.type === "parallel" && st(o).every(function(t) {
				return ht(e.configuration, t);
			}) && i.push(We(o.id)), i;
		}));
		e.exitSet.sort(function(e, t) {
			return t.order - e.order;
		}), e.entrySet.sort(function(e, t) {
			return e.order - t.order;
		});
		var y = new Set(e.entrySet), b = new Set(e.exitSet), x = h([H(Array.from(y).map(function(e) {
			return g(g([], h(e.activities.map(function(e) {
				return ze(e);
			})), !1), h(e.onEntry), !1);
		})).concat(v.map(Me)), H(Array.from(b).map(function(e) {
			return g(g([], h(e.onExit), !1), h(e.activities.map(function(e) {
				return Be(e);
			})), !1);
		}))], 2), S = x[0], C = x[1];
		return Ae(C.concat(e.actions).concat(S), this.machine.options.actions);
	}, e.prototype.transition = function(e, t, n) {
		e === void 0 && (e = this.initialState);
		var r = J(t), i;
		if (e instanceof xt) i = n === void 0 ? e : this.resolveState(xt.from(e, n));
		else {
			var a = G(e) ? this.resolve(te(this.getResolvedPath(e))) : this.resolve(e), o = n ?? this.machine.context;
			i = this.resolveState(xt.from(a, o));
		}
		if (this.strict && !this.events.includes(r.name) && !ce(r.name)) throw Error(`Machine '${this.id}' does not accept event '${r.name}'`);
		var s = this._transition(i.value, i, r) || {
			transitions: [],
			configuration: [],
			entrySet: [],
			exitSet: [],
			source: i,
			actions: []
		}, c = lt([], this.getStateNodes(i.value));
		return s.configuration = g([], h(s.configuration.length ? lt(c, s.configuration) : c), !1), this.resolveTransition(s, i, i.context, r);
	}, e.prototype.resolveRaisedTransition = function(e, t, n) {
		var r, i = e.actions;
		return e = this.transition(e, t), e._event = n, e.event = n.data, (r = e.actions).unshift.apply(r, g([], h(i), !1)), e;
	}, e.prototype.resolveTransition = function(e, t, n, r) {
		var i, a, o = this;
		r === void 0 && (r = De);
		var s = e.configuration, c = !t || e.transitions.length > 0, l = c ? ft(this.machine, s) : void 0, u = t ? t.historyValue ? t.historyValue : e.source ? this.machine.historyValue(t.value) : void 0 : void 0, d = this.getActions(e, n, r, t), p = t ? f({}, t.activities) : {};
		try {
			for (var g = m(d), _ = g.next(); !_.done; _ = g.next()) {
				var C = _.value;
				C.type === y ? p[C.activity.id || C.activity.type] = C : C.type === b && (p[C.activity.id || C.activity.type] = !1);
			}
		} catch (e) {
			i = { error: e };
		} finally {
			try {
				_ && !_.done && (a = g.return) && a.call(g);
			} finally {
				if (i) throw i.error;
			}
		}
		var T = h(Xe(this, t, n, r, d, this.machine.config.preserveActionOrder), 2), E = T[0], D = T[1], k = h(de(E, function(e) {
			return e.type === x || e.type === S && e.to === v.Internal;
		}), 2), A = k[0], M = k[1], N = E.filter(function(e) {
			return e.type === y && e.activity?.type === O;
		}).reduce(function(e, t) {
			return e[t.activity.id] = tt(t.activity, o.machine, D, r), e;
		}, t ? f({}, t.children) : {}), P = c ? e.configuration : t ? t.configuration : [], ee = ht(P, this), F = new xt({
			value: l || t.value,
			context: D,
			_event: r,
			_sessionid: t ? t._sessionid : null,
			historyValue: l ? u ? pe(u, l) : void 0 : t ? t.historyValue : void 0,
			history: !l || e.source ? t : void 0,
			actions: l ? M : [],
			activities: l ? p : t ? t.activities : {},
			events: [],
			configuration: P,
			transitions: e.transitions,
			children: N,
			done: ee,
			tags: _t(P),
			machine: this
		}), I = n !== D;
		F.changed = r.name === j || I;
		var L = F.history;
		L && delete L.history;
		var R = !ee && (this._transient || s.some(function(e) {
			return e._transient;
		}));
		if (!c && (!R || r.name === Rt)) return F;
		var z = F;
		if (!ee) for (R && (z = this.resolveRaisedTransition(z, { type: w }, r)); A.length;) {
			var B = A.shift();
			z = this.resolveRaisedTransition(z, B._event, r);
		}
		var te = z.changed || (L ? !!z.actions.length || I || typeof L.value != typeof z.value || !vt(z.value, L.value) : void 0);
		return z.changed = te, z.history = L, z;
	}, e.prototype.getStateNode = function(e) {
		if (Ht(e)) return this.machine.getStateNodeById(e);
		if (!this.states) throw Error(`Unable to retrieve child state '${e}' from '${this.id}'; no child states exist.`);
		var t = this.states[e];
		if (!t) throw Error(`Child state '${e}' does not exist on '${this.id}'`);
		return t;
	}, e.prototype.getStateNodeById = function(e) {
		var t = Ht(e) ? e.slice(zt.length) : e;
		if (t === this.id) return this;
		var n = this.machine.idMap[t];
		if (!n) throw Error(`Child state node '#${t}' does not exist on machine '${this.id}'`);
		return n;
	}, e.prototype.getStateNodeByPath = function(e) {
		if (typeof e == "string" && Ht(e)) try {
			return this.getStateNodeById(e.slice(1));
		} catch {}
		for (var t = R(e, this.delimiter).slice(), n = this; t.length;) {
			var r = t.shift();
			if (!r.length) break;
			n = n.getStateNode(r);
		}
		return n;
	}, e.prototype.resolve = function(e) {
		var t, n = this;
		if (!e) return this.initialStateValue || Vt;
		switch (this.type) {
			case "parallel": return ne(this.initialStateValue, function(t, r) {
				return t ? n.getStateNode(r).resolve(e[r] || t) : Vt;
			});
			case "compound":
				if (G(e)) {
					var r = this.getStateNode(e);
					return r.type === "parallel" || r.type === "compound" ? (t = {}, t[e] = r.initialStateValue, t) : e;
				}
				return Object.keys(e).length ? ne(e, function(e, t) {
					return e ? n.getStateNode(t).resolve(e) : Vt;
				}) : this.initialStateValue || {};
			default: return e || Vt;
		}
	}, e.prototype.getResolvedPath = function(e) {
		if (Ht(e)) {
			var t = this.machine.idMap[e.slice(zt.length)];
			if (!t) throw Error(`Unable to find state node '${e}'`);
			return t.path;
		}
		return R(e, this.delimiter);
	}, Object.defineProperty(e.prototype, "initialStateValue", {
		get: function() {
			var e;
			if (this.__cache.initialStateValue) return this.__cache.initialStateValue;
			var t;
			if (this.type === "parallel") t = V(this.states, function(e) {
				return e.initialStateValue || Vt;
			}, function(e) {
				return e.type !== "history";
			});
			else if (this.initial !== void 0) {
				if (!this.states[this.initial]) throw Error(`Initial state '${this.initial}' not found on '${this.key}'`);
				t = ot(this.states[this.initial]) ? this.initial : (e = {}, e[this.initial] = this.states[this.initial].initialStateValue, e);
			} else t = {};
			return this.__cache.initialStateValue = t, this.__cache.initialStateValue;
		},
		enumerable: !1,
		configurable: !0
	}), e.prototype.getInitialState = function(e, t) {
		this._init();
		var n = this.getStateNodes(e);
		return this.resolveTransition({
			configuration: n,
			entrySet: n,
			exitSet: [],
			transitions: [],
			source: void 0,
			actions: []
		}, void 0, t ?? this.machine.context, void 0);
	}, Object.defineProperty(e.prototype, "initialState", {
		get: function() {
			var e = this.initialStateValue;
			if (!e) throw Error(`Cannot retrieve initial state from simple state '${this.id}'.`);
			return this.getInitialState(e);
		},
		enumerable: !1,
		configurable: !0
	}), Object.defineProperty(e.prototype, "target", {
		get: function() {
			var e;
			if (this.type === "history") {
				var t = this.config;
				e = G(t.target) && Ht(t.target) ? te(this.machine.getStateNodeById(t.target).path.slice(this.path.length - 1)) : t.target;
			}
			return e;
		},
		enumerable: !1,
		configurable: !0
	}), e.prototype.getRelativeStateNodes = function(e, t, n) {
		return n === void 0 && (n = !0), n ? e.type === "history" ? e.resolveHistory(t) : e.initialStateNodes : [e];
	}, Object.defineProperty(e.prototype, "initialStateNodes", {
		get: function() {
			var e = this;
			return ot(this) || this.type === "compound" && !this.initial ? [this] : H(ae(this.initialStateValue).map(function(t) {
				return e.getFromRelativePath(t);
			}));
		},
		enumerable: !1,
		configurable: !0
	}), e.prototype.getFromRelativePath = function(e) {
		if (!e.length) return [this];
		var t = h(e), n = t[0], r = t.slice(1);
		if (!this.states) throw Error(`Cannot retrieve subPath '${n}' from node with no states`);
		var i = this.getStateNode(n);
		if (i.type === "history") return i.resolveHistory();
		if (!this.states[n]) throw Error(`Child state '${n}' does not exist on '${this.id}'`);
		return this.states[n].getFromRelativePath(r);
	}, e.prototype.historyValue = function(e) {
		if (Object.keys(this.states).length) return {
			current: e || this.initialStateValue,
			states: V(this.states, function(t, n) {
				if (!e) return t.historyValue();
				var r = G(e) ? void 0 : e[n];
				return t.historyValue(r || t.initialStateValue);
			}, function(e) {
				return !e.history;
			})
		};
	}, e.prototype.resolveHistory = function(e) {
		var t = this;
		if (this.type !== "history") return [this];
		var n = this.parent;
		if (!e) {
			var r = this.target;
			return r ? H(ae(r).map(function(e) {
				return n.getFromRelativePath(e);
			})) : n.initialStateNodes;
		}
		var i = ie(n.path, "states")(e).current;
		return G(i) ? [n.getStateNode(i)] : H(ae(i).map(function(e) {
			return t.history === "deep" ? n.getFromRelativePath(e) : [n.states[e[0]]];
		}));
	}, Object.defineProperty(e.prototype, "stateIds", {
		get: function() {
			var e = this, t = H(Object.keys(this.states).map(function(t) {
				return e.states[t].stateIds;
			}));
			return [this.id].concat(t);
		},
		enumerable: !1,
		configurable: !0
	}), Object.defineProperty(e.prototype, "events", {
		get: function() {
			var e, t, n, r;
			if (this.__cache.events) return this.__cache.events;
			var i = this.states, a = new Set(this.ownEvents);
			if (i) try {
				for (var o = m(Object.keys(i)), s = o.next(); !s.done; s = o.next()) {
					var c = i[s.value];
					if (c.states) try {
						for (var l = (n = void 0, m(c.events)), u = l.next(); !u.done; u = l.next()) {
							var d = u.value;
							a.add(`${d}`);
						}
					} catch (e) {
						n = { error: e };
					} finally {
						try {
							u && !u.done && (r = l.return) && r.call(l);
						} finally {
							if (n) throw n.error;
						}
					}
				}
			} catch (t) {
				e = { error: t };
			} finally {
				try {
					s && !s.done && (t = o.return) && t.call(o);
				} finally {
					if (e) throw e.error;
				}
			}
			return this.__cache.events = Array.from(a);
		},
		enumerable: !1,
		configurable: !0
	}), Object.defineProperty(e.prototype, "ownEvents", {
		get: function() {
			var e = new Set(this.transitions.filter(function(e) {
				return !(!e.target && !e.actions.length && e.internal);
			}).map(function(e) {
				return e.eventType;
			}));
			return Array.from(e);
		},
		enumerable: !1,
		configurable: !0
	}), e.prototype.resolveTarget = function(e) {
		var t = this;
		if (e !== void 0) return e.map(function(e) {
			if (!G(e)) return e;
			var n = e[0] === t.delimiter;
			if (n && !t.parent) return t.getStateNodeByPath(e.slice(1));
			var r = n ? t.key + e : e;
			if (t.parent) try {
				return t.parent.getStateNodeByPath(r);
			} catch (e) {
				throw Error(`Invalid transition definition for state node '${t.id}':
${e.message}`);
			}
			else return t.getStateNodeByPath(r);
		});
	}, e.prototype.formatTransition = function(e) {
		var t = this, n = Se(e.target), r = "internal" in e ? e.internal : n ? n.some(function(e) {
			return G(e) && e[0] === t.delimiter;
		}) : !0, i = this.machine.options.guards, a = this.resolveTarget(n), o = f(f({}, e), {
			actions: Ae(U(e.actions)),
			cond: ge(e.cond, i),
			target: a,
			source: this,
			internal: r,
			eventType: e.event,
			toJSON: function() {
				return f(f({}, o), {
					target: o.target ? o.target.map(function(e) {
						return `#${e.id}`;
					}) : void 0,
					source: `#${t.id}`
				});
			}
		});
		return o;
	}, e.prototype.formatTransitions = function() {
		var e, t, n = this, r;
		if (!this.config.on) r = [];
		else if (Array.isArray(this.config.on)) r = this.config.on;
		else {
			var i = this.config.on, a = Bt, o = i[a], s = o === void 0 ? [] : o, c = p(i, [typeof a == "symbol" ? a : a + ""]);
			r = H(Object.keys(c).map(function(e) {
				return xe(e, c[e]);
			}).concat(xe(Bt, s)));
		}
		var l = this.config.always ? xe("", this.config.always) : [], u = this.config.onDone ? xe(String(We(this.id)), this.config.onDone) : [], d = H(this.invoke.map(function(e) {
			var t = [];
			return e.onDone && t.push.apply(t, g([], h(xe(String(Ge(e.id)), e.onDone)), !1)), e.onError && t.push.apply(t, g([], h(xe(String(Ke(e.id)), e.onError)), !1)), t;
		})), f = this.after, _ = H(g(g(g(g([], h(u), !1), h(d), !1), h(r), !1), h(l), !1).map(function(e) {
			return U(e).map(function(e) {
				return n.formatTransition(e);
			});
		}));
		try {
			for (var v = m(f), y = v.next(); !y.done; y = v.next()) {
				var b = y.value;
				_.push(b);
			}
		} catch (t) {
			e = { error: t };
		} finally {
			try {
				y && !y.done && (t = v.return) && t.call(v);
			} finally {
				if (e) throw e.error;
			}
		}
		return _;
	}, e;
}();
//#endregion
//#region ../../node_modules/xstate/es/Machine.js
function Gt(e, t) {
	return new Wt(e, t);
}
//#endregion
//#region ../../node_modules/xstate/es/index.js
var X = He, Kt = Pe, qt = Ie, Jt = Je;
//#endregion
//#region ../../node_modules/is-plain-object/dist/is-plain-object.mjs
function Yt(e) {
	return Object.prototype.toString.call(e) === "[object Object]";
}
function Xt(e) {
	var t, n;
	return Yt(e) === !1 ? !1 : (t = e.constructor, t === void 0 ? !0 : (n = t.prototype, !(Yt(n) === !1 || n.hasOwnProperty("isPrototypeOf") === !1)));
}
//#endregion
//#region ../../node_modules/object-path-immutable/esm/object-path-immutable.js
var Zt = /* @__PURE__ */ u((/* @__PURE__ */ s(((e, t) => {
	(function(e, n) {
		/*istanbul ignore next:cant test*/
		typeof t == "object" && typeof t.exports == "object" ? t.exports = n() : e.objectPath = n();
	})(e, function() {
		var e = Object.prototype.toString;
		function t(e, t) {
			return e == null ? !1 : Object.prototype.hasOwnProperty.call(e, t);
		}
		function n(e) {
			if (!e || a(e) && e.length === 0) return !0;
			if (typeof e != "string") {
				for (var n in e) if (t(e, n)) return !1;
				return !0;
			}
			return !1;
		}
		function r(t) {
			return e.call(t);
		}
		function i(e) {
			return typeof e == "object" && r(e) === "[object Object]";
		}
		var a = Array.isArray || function(t) {
			/*istanbul ignore next:cant test*/
			return e.call(t) === "[object Array]";
		};
		function o(e) {
			return typeof e == "boolean" || r(e) === "[object Boolean]";
		}
		function s(e) {
			var t = parseInt(e);
			return t.toString() === e ? t : e;
		}
		function c(e) {
			e ||= {};
			var r = function(e) {
				return Object.keys(r).reduce(function(t, n) {
					return n === "create" || typeof r[n] == "function" && (t[n] = r[n].bind(r, e)), t;
				}, {});
			}, c = e.includeInheritedProps ? function() {
				return !0;
			} : function(e, n) {
				return typeof n == "number" && Array.isArray(e) || t(e, n);
			};
			function l(e, t) {
				if (c(e, t)) return e[t];
			}
			var u = e.includeInheritedProps ? function(e, t) {
				typeof t != "string" && typeof t != "number" && (t = String(t));
				var n = l(e, t);
				if (t === "__proto__" || t === "prototype" || t === "constructor" && typeof n == "function") throw Error("For security reasons, object's magic properties cannot be set");
				return n;
			} : function(e, t) {
				return l(e, t);
			};
			function d(e, t, n, r) {
				if (typeof t == "number" && (t = [t]), !t || t.length === 0) return e;
				if (typeof t == "string") return d(e, t.split(".").map(s), n, r);
				var i = t[0], a = u(e, i);
				return t.length === 1 ? ((a === void 0 || !r) && (e[i] = n), a) : (a === void 0 && (typeof t[1] == "number" ? e[i] = [] : e[i] = {}), d(e[i], t.slice(1), n, r));
			}
			return r.has = function(n, r) {
				if (typeof r == "number" ? r = [r] : typeof r == "string" && (r = r.split(".")), !r || r.length === 0) return !!n;
				for (var i = 0; i < r.length; i++) {
					var o = s(r[i]);
					if (typeof o == "number" && a(n) && o < n.length || (e.includeInheritedProps ? o in Object(n) : t(n, o))) n = n[o];
					else return !1;
				}
				return !0;
			}, r.ensureExists = function(e, t, n) {
				return d(e, t, n, !0);
			}, r.set = function(e, t, n, r) {
				return d(e, t, n, r);
			}, r.insert = function(e, t, n, i) {
				var o = r.get(e, t);
				i = ~~i, a(o) || (o = [], r.set(e, t, o)), o.splice(i, 0, n);
			}, r.empty = function(e, t) {
				if (!n(t) && e != null) {
					var s, l;
					if (s = r.get(e, t)) {
						if (typeof s == "string") return r.set(e, t, "");
						if (o(s)) return r.set(e, t, !1);
						if (typeof s == "number") return r.set(e, t, 0);
						if (a(s)) s.length = 0;
						else if (i(s)) for (l in s) c(s, l) && delete s[l];
						else return r.set(e, t, null);
					}
				}
			}, r.push = function(e, t) {
				var n = r.get(e, t);
				a(n) || (n = [], r.set(e, t, n)), n.push.apply(n, Array.prototype.slice.call(arguments, 2));
			}, r.coalesce = function(e, t, n) {
				for (var i, a = 0, o = t.length; a < o; a++) if ((i = r.get(e, t[a])) !== void 0) return i;
				return n;
			}, r.get = function(e, t, n) {
				if (typeof t == "number" && (t = [t]), !t || t.length === 0) return e;
				if (e == null) return n;
				if (typeof t == "string") return r.get(e, t.split("."), n);
				var i = s(t[0]), a = u(e, i);
				return a === void 0 ? n : t.length === 1 ? a : r.get(e[i], t.slice(1), n);
			}, r.del = function(e, t) {
				if (typeof t == "number" && (t = [t]), e == null || n(t)) return e;
				if (typeof t == "string") return r.del(e, t.split("."));
				var i = s(t[0]);
				if (u(e, i), !c(e, i)) return e;
				if (t.length === 1) a(e) ? e.splice(i, 1) : delete e[i];
				else return r.del(e[i], t.slice(1));
				return e;
			}, r;
		}
		var l = c();
		return l.create = c, l.withInheritedProps = c({ includeInheritedProps: !0 }), l;
	});
})))()), Qt = Object.prototype.hasOwnProperty;
function $t(e) {
	if (en(e)) return !1;
	if (!e || nn(e) && e.length === 0) return !0;
	if (!tn(e)) {
		for (var t in e) if (Qt.call(e, t)) return !1;
		return !0;
	}
	return !1;
}
function en(e) {
	return typeof e == "number";
}
function tn(e) {
	return typeof e == "string";
}
function nn(e) {
	return Array.isArray(e);
}
function rn(e, t) {
	for (var n in t) Qt.call(t, n) && (e[n] = t[n]);
	return e;
}
function an(e) {
	var t = parseInt(e);
	return t.toString() === e ? t : e;
}
function on(e, t, n) {
	return e == null ? t ? n ? [] : {} : e : nn(e) ? e.slice() : rn({}, e);
}
function sn(e, t) {
	if (e !== t && Xt(e) && Xt(t)) {
		var n = {};
		for (var r in e) Qt.call(e, r) && (Qt.call(t, r) ? n[r] = sn(e[r], t[r]) : n[r] = e[r]);
		for (r in t) Qt.call(t, r) && (n[r] = sn(e[r], t[r]));
		return n;
	}
	return t;
}
function cn(e, t, n, r) {
	if (en(n) && (n = [n]), $t(n)) return t;
	if (tn(n)) return cn(e, t, n.split(".").map(an), r);
	var i = n[0];
	return (!e || e === t) && (e = on(t, !0, en(i))), n.length === 1 ? r(e, i) : (t != null && (t = t[i]), e[i] = cn(e[i], t, n.slice(1), r), e);
}
var ln = {};
ln.set = function(e, t, n, r) {
	return $t(n) ? r : cn(e, t, n, function(e, t) {
		return e[t] = r, e;
	});
}, ln.update = function(e, t, n, r) {
	return $t(n) ? r(on(t)) : cn(e, t, n, function(e, t) {
		return e[t] = r(e[t]), e;
	});
}, ln.push = function(e, t, n) {
	var r = Array.prototype.slice.call(arguments, 3);
	return $t(n) ? nn(t) ? t.concat(r) : r : cn(e, t, n, function(e, t) {
		return nn(e[t]) ? e[t] = e[t].concat(r) : e[t] = r, e;
	});
}, ln.insert = function(e, t, n, r, i) {
	if (i = ~~i, $t(n)) {
		if (!nn(t)) return [r];
		var a = t.slice(0, i);
		return a.push(r), a.concat(t.slice(i));
	}
	return cn(e, t, n, function(e, t) {
		var a = e[t];
		if (!nn(a)) {
			if (a != null && a !== void 0) throw Error("Expected " + n + "to be an array. Instead got " + typeof n);
			a = [];
		}
		var o = a.slice(0, i);
		return o.push(r), e[t] = o.concat(a.slice(i)), e;
	});
}, ln.del = function(e, t, n) {
	if (!$t(n)) return cn(e, t, n, function(e, t) {
		return Array.isArray(e) ? e[t] !== void 0 && e.splice(t, 1) : Qt.call(e, t) && delete e[t], e;
	});
}, ln.assign = function(e, t, n, r) {
	return $t(n) ? $t(r) ? t : rn(on(t), r) : cn(e, t, n, function(e, t) {
		r = Object(r);
		var n = on(e[t], !0);
		return rn(n, r), e[t] = n, e;
	});
}, ln.merge = function(e, t, n, r) {
	return $t(n) ? $t(r) ? t : sn(t, r) : cn(e, t, n, function(e, t) {
		return r = Object(r), e[t] = sn(e[t], r), e;
	});
};
var un = ln.set.bind(null, null), dn = ln.update.bind(null, null);
ln.push.bind(null, null), ln.insert.bind(null, null), ln.del.bind(null, null), ln.assign.bind(null, null), ln.merge.bind(null, null);
var fn = Zt.default.get, Z = [];
for (let e = 0; e < 256; ++e) Z.push((e + 256).toString(16).slice(1));
function pn(e, t = 0) {
	return (Z[e[t + 0]] + Z[e[t + 1]] + Z[e[t + 2]] + Z[e[t + 3]] + "-" + Z[e[t + 4]] + Z[e[t + 5]] + "-" + Z[e[t + 6]] + Z[e[t + 7]] + "-" + Z[e[t + 8]] + Z[e[t + 9]] + "-" + Z[e[t + 10]] + Z[e[t + 11]] + Z[e[t + 12]] + Z[e[t + 13]] + Z[e[t + 14]] + Z[e[t + 15]]).toLowerCase();
}
//#endregion
//#region ../../node_modules/uuid/dist/rng.js
var mn = new Uint8Array(16);
function hn() {
	return crypto.getRandomValues(mn);
}
//#endregion
//#region ../../node_modules/uuid/dist/v4.js
function gn(e, t, n) {
	return !t && !e && crypto.randomUUID ? crypto.randomUUID() : _n(e, t, n);
}
function _n(e, t, n) {
	e ||= {};
	let r = e.random ?? e.rng?.() ?? hn();
	if (r.length < 16) throw Error("Random bytes length must be >= 16");
	if (r[6] = r[6] & 15 | 64, r[8] = r[8] & 63 | 128, t) {
		if (n ||= 0, n < 0 || n + 16 > t.length) throw RangeError(`UUID byte range ${n}:${n + 15} is out of buffer bounds`);
		for (let e = 0; e < 16; ++e) t[n + e] = r[e];
		return t;
	}
	return pn(r);
}
//#endregion
//#region src/core/constants.js
var vn = /* @__PURE__ */ u((/* @__PURE__ */ s(((e, t) => {
	var n = 200, r = "__lodash_hash_undefined__", i = 1, a = 2, o = 9007199254740991, s = "[object Arguments]", c = "[object Array]", l = "[object AsyncFunction]", u = "[object Boolean]", d = "[object Date]", f = "[object Error]", p = "[object Function]", m = "[object GeneratorFunction]", h = "[object Map]", g = "[object Number]", _ = "[object Null]", v = "[object Object]", y = "[object Promise]", b = "[object Proxy]", x = "[object RegExp]", S = "[object Set]", C = "[object String]", w = "[object Symbol]", T = "[object Undefined]", E = "[object WeakMap]", D = "[object ArrayBuffer]", O = "[object DataView]", k = "[object Float32Array]", A = "[object Float64Array]", j = "[object Int8Array]", M = "[object Int16Array]", N = "[object Int32Array]", P = "[object Uint8Array]", ee = "[object Uint8ClampedArray]", F = "[object Uint16Array]", I = "[object Uint32Array]", L = /[\\^$.*+?()[\]{}|]/g, R = /^\[object .+?Constructor\]$/, z = /^(?:0|[1-9]\d*)$/, B = {};
	B[k] = B[A] = B[j] = B[M] = B[N] = B[P] = B[ee] = B[F] = B[I] = !0, B[s] = B[c] = B[D] = B[u] = B[O] = B[d] = B[f] = B[p] = B[h] = B[g] = B[v] = B[x] = B[S] = B[C] = B[E] = !1;
	var te = typeof global == "object" && global && global.Object === Object && global, ne = typeof self == "object" && self && self.Object === Object && self, V = te || ne || Function("return this")(), re = typeof e == "object" && e && !e.nodeType && e, ie = re && typeof t == "object" && t && !t.nodeType && t, ae = ie && ie.exports === re, H = ae && te.process, oe = function() {
		try {
			return H && H.binding && H.binding("util");
		} catch {}
	}(), U = oe && oe.isTypedArray;
	function se(e, t) {
		for (var n = -1, r = e == null ? 0 : e.length, i = 0, a = []; ++n < r;) {
			var o = e[n];
			t(o, n, e) && (a[i++] = o);
		}
		return a;
	}
	function ce(e, t) {
		for (var n = -1, r = t.length, i = e.length; ++n < r;) e[i + n] = t[n];
		return e;
	}
	function le(e, t) {
		for (var n = -1, r = e == null ? 0 : e.length; ++n < r;) if (t(e[n], n, e)) return !0;
		return !1;
	}
	function ue(e, t) {
		for (var n = -1, r = Array(e); ++n < e;) r[n] = t(n);
		return r;
	}
	function de(e) {
		return function(t) {
			return e(t);
		};
	}
	function fe(e, t) {
		return e.has(t);
	}
	function pe(e, t) {
		return e?.[t];
	}
	function me(e) {
		var t = -1, n = Array(e.size);
		return e.forEach(function(e, r) {
			n[++t] = [r, e];
		}), n;
	}
	function he(e, t) {
		return function(n) {
			return e(t(n));
		};
	}
	function W(e) {
		var t = -1, n = Array(e.size);
		return e.forEach(function(e) {
			n[++t] = e;
		}), n;
	}
	var G = Array.prototype, ge = Function.prototype, _e = Object.prototype, K = V["__core-js_shared__"], ve = ge.toString, q = _e.hasOwnProperty, ye = function() {
		var e = /[^.]+$/.exec(K && K.keys && K.keys.IE_PROTO || "");
		return e ? "Symbol(src)_1." + e : "";
	}(), be = _e.toString, J = RegExp("^" + ve.call(q).replace(L, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"), xe = ae ? V.Buffer : void 0, Se = V.Symbol, Ce = V.Uint8Array, we = _e.propertyIsEnumerable, Te = G.splice, Ee = Se ? Se.toStringTag : void 0, De = Object.getOwnPropertySymbols, Oe = xe ? xe.isBuffer : void 0, ke = he(Object.keys, Object), Ae = jt(V, "DataView"), je = jt(V, "Map"), Me = jt(V, "Promise"), Ne = jt(V, "Set"), Pe = jt(V, "WeakMap"), Fe = jt(Object, "create"), Ie = zt(Ae), Le = zt(je), Re = zt(Me), ze = zt(Ne), Be = zt(Pe), Ve = Se ? Se.prototype : void 0, He = Ve ? Ve.valueOf : void 0;
	function Ue(e) {
		var t = -1, n = e == null ? 0 : e.length;
		for (this.clear(); ++t < n;) {
			var r = e[t];
			this.set(r[0], r[1]);
		}
	}
	function We() {
		this.__data__ = Fe ? Fe(null) : {}, this.size = 0;
	}
	function Ge(e) {
		var t = this.has(e) && delete this.__data__[e];
		return this.size -= +!!t, t;
	}
	function Ke(e) {
		var t = this.__data__;
		if (Fe) {
			var n = t[e];
			return n === r ? void 0 : n;
		}
		return q.call(t, e) ? t[e] : void 0;
	}
	function qe(e) {
		var t = this.__data__;
		return Fe ? t[e] !== void 0 : q.call(t, e);
	}
	function Je(e, t) {
		var n = this.__data__;
		return this.size += +!this.has(e), n[e] = Fe && t === void 0 ? r : t, this;
	}
	Ue.prototype.clear = We, Ue.prototype.delete = Ge, Ue.prototype.get = Ke, Ue.prototype.has = qe, Ue.prototype.set = Je;
	function Ye(e) {
		var t = -1, n = e == null ? 0 : e.length;
		for (this.clear(); ++t < n;) {
			var r = e[t];
			this.set(r[0], r[1]);
		}
	}
	function Xe() {
		this.__data__ = [], this.size = 0;
	}
	function Ze(e) {
		var t = this.__data__, n = _t(t, e);
		return n < 0 ? !1 : (n == t.length - 1 ? t.pop() : Te.call(t, n, 1), --this.size, !0);
	}
	function Qe(e) {
		var t = this.__data__, n = _t(t, e);
		return n < 0 ? void 0 : t[n][1];
	}
	function $e(e) {
		return _t(this.__data__, e) > -1;
	}
	function et(e, t) {
		var n = this.__data__, r = _t(n, e);
		return r < 0 ? (++this.size, n.push([e, t])) : n[r][1] = t, this;
	}
	Ye.prototype.clear = Xe, Ye.prototype.delete = Ze, Ye.prototype.get = Qe, Ye.prototype.has = $e, Ye.prototype.set = et;
	function tt(e) {
		var t = -1, n = e == null ? 0 : e.length;
		for (this.clear(); ++t < n;) {
			var r = e[t];
			this.set(r[0], r[1]);
		}
	}
	function nt() {
		this.size = 0, this.__data__ = {
			hash: new Ue(),
			map: new (je || Ye)(),
			string: new Ue()
		};
	}
	function rt(e) {
		var t = At(this, e).delete(e);
		return this.size -= +!!t, t;
	}
	function it(e) {
		return At(this, e).get(e);
	}
	function at(e) {
		return At(this, e).has(e);
	}
	function ot(e, t) {
		var n = At(this, e), r = n.size;
		return n.set(e, t), this.size += n.size == r ? 0 : 1, this;
	}
	tt.prototype.clear = nt, tt.prototype.delete = rt, tt.prototype.get = it, tt.prototype.has = at, tt.prototype.set = ot;
	function st(e) {
		var t = -1, n = e == null ? 0 : e.length;
		for (this.__data__ = new tt(); ++t < n;) this.add(e[t]);
	}
	function ct(e) {
		return this.__data__.set(e, r), this;
	}
	function lt(e) {
		return this.__data__.has(e);
	}
	st.prototype.add = st.prototype.push = ct, st.prototype.has = lt;
	function ut(e) {
		var t = this.__data__ = new Ye(e);
		this.size = t.size;
	}
	function dt() {
		this.__data__ = new Ye(), this.size = 0;
	}
	function ft(e) {
		var t = this.__data__, n = t.delete(e);
		return this.size = t.size, n;
	}
	function pt(e) {
		return this.__data__.get(e);
	}
	function mt(e) {
		return this.__data__.has(e);
	}
	function ht(e, t) {
		var r = this.__data__;
		if (r instanceof Ye) {
			var i = r.__data__;
			if (!je || i.length < n - 1) return i.push([e, t]), this.size = ++r.size, this;
			r = this.__data__ = new tt(i);
		}
		return r.set(e, t), this.size = r.size, this;
	}
	ut.prototype.clear = dt, ut.prototype.delete = ft, ut.prototype.get = pt, ut.prototype.has = mt, ut.prototype.set = ht;
	function gt(e, t) {
		var n = Ht(e), r = !n && Vt(e), i = !n && !r && Wt(e), a = !n && !r && !i && Yt(e), o = n || r || i || a, s = o ? ue(e.length, String) : [], c = s.length;
		for (var l in e) (t || q.call(e, l)) && !(o && (l == "length" || i && (l == "offset" || l == "parent") || a && (l == "buffer" || l == "byteLength" || l == "byteOffset") || Pt(l, c))) && s.push(l);
		return s;
	}
	function _t(e, t) {
		for (var n = e.length; n--;) if (Bt(e[n][0], t)) return n;
		return -1;
	}
	function vt(e, t, n) {
		var r = t(e);
		return Ht(e) ? r : ce(r, n(e));
	}
	function yt(e) {
		return e == null ? e === void 0 ? T : _ : Ee && Ee in Object(e) ? Y(e) : Rt(e);
	}
	function bt(e) {
		return Jt(e) && yt(e) == s;
	}
	function xt(e, t, n, r, i) {
		return e === t ? !0 : e == null || t == null || !Jt(e) && !Jt(t) ? e !== e && t !== t : St(e, t, n, r, xt, i);
	}
	function St(e, t, n, r, a, o) {
		var l = Ht(e), u = Ht(t), d = l ? c : Nt(e), f = u ? c : Nt(t);
		d = d == s ? v : d, f = f == s ? v : f;
		var p = d == v, m = f == v, h = d == f;
		if (h && Wt(e)) {
			if (!Wt(t)) return !1;
			l = !0, p = !1;
		}
		if (h && !p) return o ||= new ut(), l || Yt(e) ? Et(e, t, n, r, a, o) : Dt(e, t, d, n, r, a, o);
		if (!(n & i)) {
			var g = p && q.call(e, "__wrapped__"), _ = m && q.call(t, "__wrapped__");
			if (g || _) {
				var y = g ? e.value() : e, b = _ ? t.value() : t;
				return o ||= new ut(), a(y, b, n, r, o);
			}
		}
		return h ? (o ||= new ut(), Ot(e, t, n, r, a, o)) : !1;
	}
	function Ct(e) {
		return !qt(e) || It(e) ? !1 : (X(e) ? J : R).test(zt(e));
	}
	function wt(e) {
		return Jt(e) && Kt(e.length) && !!B[yt(e)];
	}
	function Tt(e) {
		if (!Lt(e)) return ke(e);
		var t = [];
		for (var n in Object(e)) q.call(e, n) && n != "constructor" && t.push(n);
		return t;
	}
	function Et(e, t, n, r, o, s) {
		var c = n & i, l = e.length, u = t.length;
		if (l != u && !(c && u > l)) return !1;
		var d = s.get(e);
		if (d && s.get(t)) return d == t;
		var f = -1, p = !0, m = n & a ? new st() : void 0;
		for (s.set(e, t), s.set(t, e); ++f < l;) {
			var h = e[f], g = t[f];
			if (r) var _ = c ? r(g, h, f, t, e, s) : r(h, g, f, e, t, s);
			if (_ !== void 0) {
				if (_) continue;
				p = !1;
				break;
			}
			if (m) {
				if (!le(t, function(e, t) {
					if (!fe(m, t) && (h === e || o(h, e, n, r, s))) return m.push(t);
				})) {
					p = !1;
					break;
				}
			} else if (!(h === g || o(h, g, n, r, s))) {
				p = !1;
				break;
			}
		}
		return s.delete(e), s.delete(t), p;
	}
	function Dt(e, t, n, r, o, s, c) {
		switch (n) {
			case O:
				if (e.byteLength != t.byteLength || e.byteOffset != t.byteOffset) return !1;
				e = e.buffer, t = t.buffer;
			case D: return !(e.byteLength != t.byteLength || !s(new Ce(e), new Ce(t)));
			case u:
			case d:
			case g: return Bt(+e, +t);
			case f: return e.name == t.name && e.message == t.message;
			case x:
			case C: return e == t + "";
			case h: var l = me;
			case S:
				var p = r & i;
				if (l ||= W, e.size != t.size && !p) return !1;
				var m = c.get(e);
				if (m) return m == t;
				r |= a, c.set(e, t);
				var _ = Et(l(e), l(t), r, o, s, c);
				return c.delete(e), _;
			case w: if (He) return He.call(e) == He.call(t);
		}
		return !1;
	}
	function Ot(e, t, n, r, a, o) {
		var s = n & i, c = kt(e), l = c.length;
		if (l != kt(t).length && !s) return !1;
		for (var u = l; u--;) {
			var d = c[u];
			if (!(s ? d in t : q.call(t, d))) return !1;
		}
		var f = o.get(e);
		if (f && o.get(t)) return f == t;
		var p = !0;
		o.set(e, t), o.set(t, e);
		for (var m = s; ++u < l;) {
			d = c[u];
			var h = e[d], g = t[d];
			if (r) var _ = s ? r(g, h, d, t, e, o) : r(h, g, d, e, t, o);
			if (!(_ === void 0 ? h === g || a(h, g, n, r, o) : _)) {
				p = !1;
				break;
			}
			m ||= d == "constructor";
		}
		if (p && !m) {
			var v = e.constructor, y = t.constructor;
			v != y && "constructor" in e && "constructor" in t && !(typeof v == "function" && v instanceof v && typeof y == "function" && y instanceof y) && (p = !1);
		}
		return o.delete(e), o.delete(t), p;
	}
	function kt(e) {
		return vt(e, Xt, Mt);
	}
	function At(e, t) {
		var n = e.__data__;
		return Ft(t) ? n[typeof t == "string" ? "string" : "hash"] : n.map;
	}
	function jt(e, t) {
		var n = pe(e, t);
		return Ct(n) ? n : void 0;
	}
	function Y(e) {
		var t = q.call(e, Ee), n = e[Ee];
		try {
			e[Ee] = void 0;
			var r = !0;
		} catch {}
		var i = be.call(e);
		return r && (t ? e[Ee] = n : delete e[Ee]), i;
	}
	var Mt = De ? function(e) {
		return e == null ? [] : (e = Object(e), se(De(e), function(t) {
			return we.call(e, t);
		}));
	} : Zt, Nt = yt;
	(Ae && Nt(new Ae(/* @__PURE__ */ new ArrayBuffer(1))) != O || je && Nt(new je()) != h || Me && Nt(Me.resolve()) != y || Ne && Nt(new Ne()) != S || Pe && Nt(new Pe()) != E) && (Nt = function(e) {
		var t = yt(e), n = t == v ? e.constructor : void 0, r = n ? zt(n) : "";
		if (r) switch (r) {
			case Ie: return O;
			case Le: return h;
			case Re: return y;
			case ze: return S;
			case Be: return E;
		}
		return t;
	});
	function Pt(e, t) {
		return t ??= o, !!t && (typeof e == "number" || z.test(e)) && e > -1 && e % 1 == 0 && e < t;
	}
	function Ft(e) {
		var t = typeof e;
		return t == "string" || t == "number" || t == "symbol" || t == "boolean" ? e !== "__proto__" : e === null;
	}
	function It(e) {
		return !!ye && ye in e;
	}
	function Lt(e) {
		var t = e && e.constructor;
		return e === (typeof t == "function" && t.prototype || _e);
	}
	function Rt(e) {
		return be.call(e);
	}
	function zt(e) {
		if (e != null) {
			try {
				return ve.call(e);
			} catch {}
			try {
				return e + "";
			} catch {}
		}
		return "";
	}
	function Bt(e, t) {
		return e === t || e !== e && t !== t;
	}
	var Vt = bt(function() {
		return arguments;
	}()) ? bt : function(e) {
		return Jt(e) && q.call(e, "callee") && !we.call(e, "callee");
	}, Ht = Array.isArray;
	function Ut(e) {
		return e != null && Kt(e.length) && !X(e);
	}
	var Wt = Oe || Qt;
	function Gt(e, t) {
		return xt(e, t);
	}
	function X(e) {
		if (!qt(e)) return !1;
		var t = yt(e);
		return t == p || t == m || t == l || t == b;
	}
	function Kt(e) {
		return typeof e == "number" && e > -1 && e % 1 == 0 && e <= o;
	}
	function qt(e) {
		var t = typeof e;
		return e != null && (t == "object" || t == "function");
	}
	function Jt(e) {
		return typeof e == "object" && !!e;
	}
	var Yt = U ? de(U) : wt;
	function Xt(e) {
		return Ut(e) ? gt(e) : Tt(e);
	}
	function Zt() {
		return [];
	}
	function Qt() {
		return !1;
	}
	t.exports = Gt;
})))(), 1), yn = "EXPERIENCE_STARTED", bn = "SHOW", xn = "STOP_EXPERIENCE", Sn = {
	NAVIGATION: "navigation",
	COMPLETED: "completed",
	DISMISSED: "dismissed",
	ERROR: "error"
}, Cn = "EXTENDED_EVENT", wn = "START_STEP", Tn = "STOP_STEP", En = "UPDATE_STEP", Dn = "SET_STEP_CONTAINER_TARGET", On = "UPDATE_STEP_CONTENT", kn = "RECOVER_STEP", An = "AUTO_RECOVER_STEP", jn = "PARENT_RECOVER_STEP", Mn = "ERROR", Nn = "STEP_INTERACTION", Pn = "STEP_SEEN", Fn = "UPDATE_ROOT_STYLE", In = "RELOAD", Ln = "STEP_STOPPED", Rn = "EXPERIENCE_DISMISSED", zn = "EXPERIENCE_SNOOZED", Bn = "FORWARD_TO_PARENT", Vn = "TRANSITION_TO_END", Hn = "ACTIONS_STARTED", Un = "ACTIONS_FINISHED", Wn = "experience.begin", Gn = "experience.end", Kn = "step.prebegin", qn = "step.begin", Jn = "step.prerender", Yn = "step.postrender", Xn = "step.end", Zn = "step.error", Qn = "step.container_change", $n = "RUN_HOOKS", er = "RUN_HOOKS_DONE", tr = "START_THEME_REMOVAL_LISTENER", nr = "STOP_THEME_REMOVAL_LISTENER", rr = "GLOBAL_CONTAINER_REMOVED", ir = "STEP_CONTAINER_REMOVED", ar = "appcues-experience-container", or = "APPCUES-EXPERIENCE-CONTAINER", sr = "APPCUES-EXPERIENCE-CONTAINER-BUILDER", cr = "data-appcues-container-id", lr = "RUN_TRAITS_DONE", ur = "RUN_TRAITS_ERROR", dr = "BIND_ACTIONS_ERROR", fr = (() => {
	let e = /* @__PURE__ */ new Map(), t = (t) => {
		let { observerInstance: n } = e.get(t);
		if (n) return;
		let r = {
			childList: !0,
			subtree: !0
		}, i = new MutationObserver((...n) => {
			let { callbacks: r } = e.get(t);
			r.forEach((e) => e(...n));
		});
		i.observe(t, r);
		let { callbacks: a } = e.get(t);
		e.set(t, {
			callbacks: a,
			observerInstance: i
		});
	}, n = (t, n) => {
		let r = e.get(t);
		if (r) {
			let { callbacks: i, observerInstance: a } = r, o = i.filter((e) => e !== n);
			if (o.length > 0) {
				e.set(t, {
					callbacks: o,
					observerInstance: a
				});
				return;
			}
			a.disconnect(), e.delete(t);
		}
	};
	return (r, i) => {
		let { callbacks: a = [], observerInstance: o = null } = e.get(r) ?? {};
		return e.set(r, {
			observerInstance: o,
			callbacks: [...a, i]
		}), t(r), () => n(r, i);
	};
})(), pr = (e, ...t) => {
	t.forEach((t) => e.addEventListener(t, (e) => {
		e.stopPropagation();
	}));
}, mr = "|shadow-root|", hr = "|iframe|", gr = (e, t) => {
	try {
		return e.includes(mr) || e.includes("|iframe|") ? e.split(mr).flatMap((e) => e.split("|iframe|")).reduce((e, n) => e === null ? [...t.querySelectorAll(n)] : e.flatMap((e) => e.shadowRoot ? [...e.shadowRoot.querySelectorAll(n)] : e.tagName === "IFRAME" ? [...e.contentDocument.querySelectorAll(n)] : []), null) ?? [] : t.querySelectorAll(e);
	} catch {
		return [];
	}
}, _r = (e, t) => {
	let n = gr(e, t);
	return n.length > 0 ? n[0] : null;
}, vr = (e) => `appcues-container-${e}`, yr = (e, t, n) => {
	try {
		if (e.contentDocument && e.contentDocument.body && e.contentDocument.body.children.length > 0) {
			if (n()) return;
			t(e.contentDocument.body);
		} else e.addEventListener("load", () => {
			try {
				let r = e.contentDocument;
				if (!r || !r.body || n()) return;
				t(r.body);
			} catch {}
		}, { once: !0 });
	} catch {}
}, br = (e, t) => {
	e.forEach((e) => {
		e.type === "childList" && e.addedNodes.forEach((e) => {
			e.nodeType === 1 && e.tagName === "IFRAME" && t(e);
		});
	});
}, xr = ({ getTarget: e, onInserted: t, getWindowReference: n }) => {
	let r = n().document, i = [], a = () => {
		i.forEach((e) => e()), i = [];
	}, o = () => {
		let n = e();
		return n.length === 1 ? (t(n[0]), a(), !0) : !1;
	};
	if (o()) return () => {};
	let s = (e) => {
		e.some((e) => e.addedNodes.length > 0) && (br(e, (e) => {
			yr(e, (e) => i.push(fr(e, s)), o);
		}), o());
	};
	i.push(fr(r.body, s));
	let c, l = r.createNodeIterator(r.body, NodeFilter.SHOW_ELEMENT, (e) => e.shadowRoot && e.nodeName !== "APPCUES-EXPERIENCE-CONTAINER" && e.nodeName !== "APPCUES-EXPERIENCE-CONTAINER-BUILDER" ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_REJECT);
	for (; (c = l.nextNode()) !== null;) i.push(fr(c.shadowRoot, s));
	let u, d = r.createNodeIterator(r.body, NodeFilter.SHOW_ELEMENT, (e) => e.tagName === "IFRAME" ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_REJECT);
	for (; (u = d.nextNode()) !== null;) yr(u, (e) => i.push(fr(e, s)), o);
	return () => a();
}, Sr = ({ getTarget: e, onRemoved: t, getWindowReference: n }) => {
	let r = n().document, [i] = e(), a, o = (n) => {
		if (!n.some((e) => e.removedNodes.length > 0)) return;
		let r = e(), o = i ? r[0] !== i : !1;
		[i] = r, (r.length === 0 || o || !i.isConnected) && (t(), a());
	};
	return a = i && i.getRootNode().nodeType === Node.DOCUMENT_FRAGMENT_NODE ? fr(i.getRootNode(), o) : fr(r.body, o), () => a();
}, Cr = (e) => {
	let t = 0;
	for (let n = 0; n < e.length && !(e[n].nodeName !== "APPCUES-EXPERIENCE-CONTAINER" || e[n].nodeName !== "APPCUES-EXPERIENCE-CONTAINER-BUILDER"); n++) t = n;
	return e.slice(t + 1);
}, wr = (e, t = document) => {
	try {
		let n = e.match(/^((body\s(>?\s?))?)(?<tagName>[\da-z]+):nth-child\((?<index>\d+)\)(?<remainingSelector>.*)/i), r = t.body.firstChild?.nodeName === "APPCUES-EXPERIENCE-CONTAINER" || t.body.firstChild?.nodeName === "APPCUES-EXPERIENCE-CONTAINER-BUILDER";
		if (!n || !r) return [];
		let { tagName: i, index: a, remainingSelector: o } = n.groups, s = Number.parseInt(a, 10) - 1, c = Cr([...t.body.children]), l = c[s]?.nodeName === i.toUpperCase() ? c[s] : null;
		return o ? l ? gr(`* ${o}`, l) : [] : [l];
	} catch (e) {
		return console.log(e), [];
	}
}, Tr = (e, { step: t, stepContainer: n, checkOutsideContainer: r, getWindowReference: i }) => {
	let a = vr(t.id), o = [];
	if (r) {
		let t = i().document, n = wr(e, t), r = n.length > 0 ? n : gr(e, t.documentElement);
		r.length > 0 && (o = [...o, ...r]);
	}
	if (!n) return o;
	let s = _r(`[${cr}=${a}]`, n);
	return s &&= gr(e, s), s ??= [], s.length > 0 && (o = [...o, ...s]), o;
}, Er = [
	"keypress",
	"keydown",
	"keyup",
	"click",
	"dblclick",
	"input",
	"change",
	"submit"
], Dr = ({ accountId: e, id: t, theme: n, getWindowReference: r }) => {
	let i = r().document.createElement(ar);
	return n && i.setAttribute("themeId", n), i.setAttribute("accountId", e), i.setAttribute("id", vr(t)), pr(i, ...Er), i;
}, Or = (e) => ({ experience: t }) => {
	let { theme: n, themeSystem: r, accountId: i, id: a } = t;
	if (!i) return;
	let o = e("getWindowReference"), s = o().document, c = Dr({
		accountId: i,
		id: a,
		...!r && { theme: n },
		getWindowReference: o
	});
	s.body.append(c);
}, kr = (e) => ({ experience: t }) => {
	let n = e("getWindowReference")().document;
	gr(`#${vr(t.id)}`, n.documentElement).forEach((e) => n.body.removeChild(e));
}, Ar = ({ getRoot: e }) => {
	let t = e();
	t.parentElement && t.remove();
}, jr = ({ getRoot: e }) => Ye([{
	cond: "hasCustomContainer",
	actions: [() => {
		Ar({ getRoot: e });
	}]
}]), Mr = (e) => ({ experience: t }) => (n, r) => {
	r(({ type: r }) => {
		if (r !== "START_THEME_REMOVAL_LISTENER") return;
		let i = e("getWindowReference"), a = i().document, o = vr(t.id);
		Sr({
			getTarget: () => gr(`#${o}`, a.documentElement),
			onRemoved: () => {
				n(rr);
			},
			getWindowReference: i
		});
	});
}, Nr = ({ getRoot: e, getWindowReference: t }) => () => (n, r) => {
	let i;
	r(({ type: r }) => {
		if (r === "STOP_THEME_REMOVAL_LISTENER" && i) {
			i();
			return;
		}
		r === "START_THEME_REMOVAL_LISTENER" && (i && i(), i = Sr({
			getTarget: () => [e()],
			onRemoved: () => {
				n(ir);
			},
			getWindowReference: t
		}));
	});
}, Pr = Kt(tr, { to: "themeRemovalService" }), Fr = Kt(nr, { to: "themeRemovalService" }), Ir = /* @__PURE__ */ s(((e, t) => {
	(function() {
		function e(e, t, n) {
			return e.call.apply(e.bind, arguments);
		}
		function n(e, t, n) {
			if (!e) throw Error();
			if (2 < arguments.length) {
				var r = Array.prototype.slice.call(arguments, 2);
				return function() {
					var n = Array.prototype.slice.call(arguments);
					return Array.prototype.unshift.apply(n, r), e.apply(t, n);
				};
			}
			return function() {
				return e.apply(t, arguments);
			};
		}
		function r(t, i, a) {
			return r = Function.prototype.bind && Function.prototype.bind.toString().indexOf("native code") != -1 ? e : n, r.apply(null, arguments);
		}
		var i = Date.now || function() {
			return +/* @__PURE__ */ new Date();
		};
		function a(e, t) {
			this.a = e, this.o = t || e, this.c = this.o.document;
		}
		var o = !!window.FontFace;
		function s(e, t, n, r) {
			if (t = e.c.createElement(t), n) for (var i in n) n.hasOwnProperty(i) && (i == "style" ? t.style.cssText = n[i] : t.setAttribute(i, n[i]));
			return r && t.appendChild(e.c.createTextNode(r)), t;
		}
		function c(e, t, n) {
			e = e.c.getElementsByTagName(t)[0], e ||= document.documentElement, e.insertBefore(n, e.lastChild);
		}
		function l(e) {
			e.parentNode && e.parentNode.removeChild(e);
		}
		function u(e, t, n) {
			t ||= [], n ||= [];
			for (var r = e.className.split(/\s+/), i = 0; i < t.length; i += 1) {
				for (var a = !1, o = 0; o < r.length; o += 1) if (t[i] === r[o]) {
					a = !0;
					break;
				}
				a || r.push(t[i]);
			}
			for (t = [], i = 0; i < r.length; i += 1) {
				for (a = !1, o = 0; o < n.length; o += 1) if (r[i] === n[o]) {
					a = !0;
					break;
				}
				a || t.push(r[i]);
			}
			e.className = t.join(" ").replace(/\s+/g, " ").replace(/^\s+|\s+$/, "");
		}
		function d(e, t) {
			for (var n = e.className.split(/\s+/), r = 0, i = n.length; r < i; r++) if (n[r] == t) return !0;
			return !1;
		}
		function f(e) {
			return e.o.location.hostname || e.a.location.hostname;
		}
		function p(e, t, n) {
			function r() {
				u && i && a && (u(l), u = null);
			}
			t = s(e, "link", {
				rel: "stylesheet",
				href: t,
				media: "all"
			});
			var i = !1, a = !0, l = null, u = n || null;
			o ? (t.onload = function() {
				i = !0, r();
			}, t.onerror = function() {
				i = !0, l = Error("Stylesheet failed to load"), r();
			}) : setTimeout(function() {
				i = !0, r();
			}, 0), c(e, "head", t);
		}
		function m(e, t, n, r) {
			var i = e.c.getElementsByTagName("head")[0];
			if (i) {
				var a = s(e, "script", { src: t }), o = !1;
				return a.onload = a.onreadystatechange = function() {
					o || this.readyState && this.readyState != "loaded" && this.readyState != "complete" || (o = !0, n && n(null), a.onload = a.onreadystatechange = null, a.parentNode.tagName == "HEAD" && i.removeChild(a));
				}, i.appendChild(a), setTimeout(function() {
					o || (o = !0, n && n(Error("Script load timeout")));
				}, r || 5e3), a;
			}
			return null;
		}
		function h() {
			this.a = 0, this.c = null;
		}
		function g(e) {
			return e.a++, function() {
				e.a--, v(e);
			};
		}
		function _(e, t) {
			e.c = t, v(e);
		}
		function v(e) {
			e.a == 0 && e.c && (e.c(), e.c = null);
		}
		function y(e) {
			this.a = e || "-";
		}
		y.prototype.c = function(e) {
			for (var t = [], n = 0; n < arguments.length; n++) t.push(arguments[n].replace(/[\W_]+/g, "").toLowerCase());
			return t.join(this.a);
		};
		function b(e, t) {
			this.c = e, this.f = 4, this.a = "n";
			var n = (t || "n4").match(/^([nio])([1-9])$/i);
			n && (this.a = n[1], this.f = parseInt(n[2], 10));
		}
		function x(e) {
			return w(e) + " " + (e.f + "00") + " 300px " + S(e.c);
		}
		function S(e) {
			var t = [];
			e = e.split(/,\s*/);
			for (var n = 0; n < e.length; n++) {
				var r = e[n].replace(/['"]/g, "");
				r.indexOf(" ") != -1 || /^\d/.test(r) ? t.push("'" + r + "'") : t.push(r);
			}
			return t.join(",");
		}
		function C(e) {
			return e.a + e.f;
		}
		function w(e) {
			var t = "normal";
			return e.a === "o" ? t = "oblique" : e.a === "i" && (t = "italic"), t;
		}
		function T(e) {
			var t = 4, n = "n", r = null;
			return e && ((r = e.match(/(normal|oblique|italic)/i)) && r[1] && (n = r[1].substr(0, 1).toLowerCase()), (r = e.match(/([1-9]00|normal|bold)/i)) && r[1] && (/bold/i.test(r[1]) ? t = 7 : /[1-9]00/.test(r[1]) && (t = parseInt(r[1].substr(0, 1), 10)))), n + t;
		}
		function E(e, t) {
			this.c = e, this.f = e.o.document.documentElement, this.h = t, this.a = new y("-"), this.j = !1 !== t.events, this.g = !1 !== t.classes;
		}
		function D(e) {
			e.g && u(e.f, [e.a.c("wf", "loading")]), k(e, "loading");
		}
		function O(e) {
			if (e.g) {
				var t = d(e.f, e.a.c("wf", "active")), n = [], r = [e.a.c("wf", "loading")];
				t || n.push(e.a.c("wf", "inactive")), u(e.f, n, r);
			}
			k(e, "inactive");
		}
		function k(e, t, n) {
			e.j && e.h[t] && (n ? e.h[t](n.c, C(n)) : e.h[t]());
		}
		function A() {
			this.c = {};
		}
		function j(e, t, n) {
			var r = [], i;
			for (i in t) if (t.hasOwnProperty(i)) {
				var a = e.c[i];
				a && r.push(a(t[i], n));
			}
			return r;
		}
		function M(e, t) {
			this.c = e, this.f = t, this.a = s(this.c, "span", { "aria-hidden": "true" }, this.f);
		}
		function N(e) {
			c(e.c, "body", e.a);
		}
		function P(e) {
			return "display:block;position:absolute;top:-9999px;left:-9999px;font-size:300px;width:auto;height:auto;line-height:normal;margin:0;padding:0;font-variant:normal;white-space:nowrap;font-family:" + S(e.c) + ";" + ("font-style:" + w(e) + ";font-weight:" + (e.f + "00") + ";");
		}
		function ee(e, t, n, r, i, a) {
			this.g = e, this.j = t, this.a = r, this.c = n, this.f = i || 3e3, this.h = a || void 0;
		}
		ee.prototype.start = function() {
			var e = this.c.o.document, t = this, n = i(), r = new Promise(function(r, a) {
				function o() {
					i() - n >= t.f ? a() : e.fonts.load(x(t.a), t.h).then(function(e) {
						1 <= e.length ? r() : setTimeout(o, 25);
					}, function() {
						a();
					});
				}
				o();
			}), a = null, o = new Promise(function(e, n) {
				a = setTimeout(n, t.f);
			});
			Promise.race([o, r]).then(function() {
				a &&= (clearTimeout(a), null), t.g(t.a);
			}, function() {
				t.j(t.a);
			});
		};
		function F(e, t, n, r, i, a, o) {
			this.v = e, this.B = t, this.c = n, this.a = r, this.s = o || "BESbswy", this.f = {}, this.w = i || 3e3, this.u = a || null, this.m = this.j = this.h = this.g = null, this.g = new M(this.c, this.s), this.h = new M(this.c, this.s), this.j = new M(this.c, this.s), this.m = new M(this.c, this.s), e = new b(this.a.c + ",serif", C(this.a)), e = P(e), this.g.a.style.cssText = e, e = new b(this.a.c + ",sans-serif", C(this.a)), e = P(e), this.h.a.style.cssText = e, e = new b("serif", C(this.a)), e = P(e), this.j.a.style.cssText = e, e = new b("sans-serif", C(this.a)), e = P(e), this.m.a.style.cssText = e, N(this.g), N(this.h), N(this.j), N(this.m);
		}
		var I = {
			D: "serif",
			C: "sans-serif"
		}, L = null;
		function R() {
			if (L === null) {
				var e = /AppleWebKit\/([0-9]+)(?:\.([0-9]+))/.exec(window.navigator.userAgent);
				L = !!e && (536 > parseInt(e[1], 10) || parseInt(e[1], 10) === 536 && 11 >= parseInt(e[2], 10));
			}
			return L;
		}
		F.prototype.start = function() {
			this.f.serif = this.j.a.offsetWidth, this.f["sans-serif"] = this.m.a.offsetWidth, this.A = i(), B(this);
		};
		function z(e, t, n) {
			for (var r in I) if (I.hasOwnProperty(r) && t === e.f[I[r]] && n === e.f[I[r]]) return !0;
			return !1;
		}
		function B(e) {
			var t = e.g.a.offsetWidth, n = e.h.a.offsetWidth, r;
			(r = t === e.f.serif && n === e.f["sans-serif"]) || (r = R() && z(e, t, n)), r ? i() - e.A >= e.w ? R() && z(e, t, n) && (e.u === null || e.u.hasOwnProperty(e.a.c)) ? ne(e, e.v) : ne(e, e.B) : te(e) : ne(e, e.v);
		}
		function te(e) {
			setTimeout(r(function() {
				B(this);
			}, e), 50);
		}
		function ne(e, t) {
			setTimeout(r(function() {
				l(this.g.a), l(this.h.a), l(this.j.a), l(this.m.a), t(this.a);
			}, e), 0);
		}
		function V(e, t, n) {
			this.c = e, this.a = t, this.f = 0, this.m = this.j = !1, this.s = n;
		}
		var re = null;
		V.prototype.g = function(e) {
			var t = this.a;
			t.g && u(t.f, [t.a.c("wf", e.c, C(e).toString(), "active")], [t.a.c("wf", e.c, C(e).toString(), "loading"), t.a.c("wf", e.c, C(e).toString(), "inactive")]), k(t, "fontactive", e), this.m = !0, ie(this);
		}, V.prototype.h = function(e) {
			var t = this.a;
			if (t.g) {
				var n = d(t.f, t.a.c("wf", e.c, C(e).toString(), "active")), r = [], i = [t.a.c("wf", e.c, C(e).toString(), "loading")];
				n || r.push(t.a.c("wf", e.c, C(e).toString(), "inactive")), u(t.f, r, i);
			}
			k(t, "fontinactive", e), ie(this);
		};
		function ie(e) {
			--e.f == 0 && e.j && (e.m ? (e = e.a, e.g && u(e.f, [e.a.c("wf", "active")], [e.a.c("wf", "loading"), e.a.c("wf", "inactive")]), k(e, "active")) : O(e.a));
		}
		function ae(e) {
			this.j = e, this.a = new A(), this.h = 0, this.f = this.g = !0;
		}
		ae.prototype.load = function(e) {
			this.c = new a(this.j, e.context || this.j), this.g = !1 !== e.events, this.f = !1 !== e.classes, oe(this, new E(this.c, e), e);
		};
		function H(e, t, n, i, a) {
			var o = --e.h == 0;
			(e.f || e.g) && setTimeout(function() {
				var e = a || null, s = i || {};
				if (n.length === 0 && o) O(t.a);
				else {
					t.f += n.length, o && (t.j = o);
					var c, l = [];
					for (c = 0; c < n.length; c++) {
						var d = n[c], f = s[d.c], p = t.a, m = d;
						if (p.g && u(p.f, [p.a.c("wf", m.c, C(m).toString(), "loading")]), k(p, "fontloading", m), p = null, re === null) if (window.FontFace) {
							var m = /Gecko.*Firefox\/(\d+)/.exec(window.navigator.userAgent), h = /OS X.*Version\/10\..*Safari/.exec(window.navigator.userAgent) && /Apple/.exec(window.navigator.vendor);
							re = m ? 42 < parseInt(m[1], 10) : !h;
						} else re = !1;
						p = re ? new ee(r(t.g, t), r(t.h, t), t.c, d, t.s, f) : new F(r(t.g, t), r(t.h, t), t.c, d, t.s, e, f), l.push(p);
					}
					for (c = 0; c < l.length; c++) l[c].start();
				}
			}, 0);
		}
		function oe(e, t, n) {
			var r = [], i = n.timeout;
			D(t);
			var r = j(e.a, n, e.c), a = new V(e.c, t, i);
			for (e.h = r.length, t = 0, n = r.length; t < n; t++) r[t].load(function(t, n, r) {
				H(e, a, t, n, r);
			});
		}
		function U(e, t) {
			this.c = e, this.a = t;
		}
		U.prototype.load = function(e) {
			function t() {
				if (a["__mti_fntLst" + r]) {
					var n = a["__mti_fntLst" + r](), i = [], o;
					if (n) for (var s = 0; s < n.length; s++) {
						var c = n[s].fontfamily;
						n[s].fontStyle != null && n[s].fontWeight != null ? (o = n[s].fontStyle + n[s].fontWeight, i.push(new b(c, o))) : i.push(new b(c));
					}
					e(i);
				} else setTimeout(function() {
					t();
				}, 50);
			}
			var n = this, r = n.a.projectId, i = n.a.version;
			if (r) {
				var a = n.c.o;
				m(this.c, (n.a.api || "https://fast.fonts.net/jsapi") + "/" + r + ".js" + (i ? "?v=" + i : ""), function(i) {
					i ? e([]) : (a["__MonotypeConfiguration__" + r] = function() {
						return n.a;
					}, t());
				}).id = "__MonotypeAPIScript__" + r;
			} else e([]);
		};
		function se(e, t) {
			this.c = e, this.a = t;
		}
		se.prototype.load = function(e) {
			var t, n, r = this.a.urls || [], i = this.a.families || [], a = this.a.testStrings || {}, o = new h();
			for (t = 0, n = r.length; t < n; t++) p(this.c, r[t], g(o));
			var s = [];
			for (t = 0, n = i.length; t < n; t++) if (r = i[t].split(":"), r[1]) for (var c = r[1].split(","), l = 0; l < c.length; l += 1) s.push(new b(r[0], c[l]));
			else s.push(new b(r[0]));
			_(o, function() {
				e(s, a);
			});
		};
		function ce(e, t) {
			e ? this.c = e : this.c = le, this.a = [], this.f = [], this.g = t || "";
		}
		var le = "https://fonts.googleapis.com/css";
		function ue(e, t) {
			for (var n = t.length, r = 0; r < n; r++) {
				var i = t[r].split(":");
				i.length == 3 && e.f.push(i.pop());
				var a = "";
				i.length == 2 && i[1] != "" && (a = ":"), e.a.push(i.join(a));
			}
		}
		function de(e) {
			if (e.a.length == 0) throw Error("No fonts to load!");
			if (e.c.indexOf("kit=") != -1) return e.c;
			for (var t = e.a.length, n = [], r = 0; r < t; r++) n.push(e.a[r].replace(/ /g, "+"));
			return t = e.c + "?family=" + n.join("%7C"), 0 < e.f.length && (t += "&subset=" + e.f.join(",")), 0 < e.g.length && (t += "&text=" + encodeURIComponent(e.g)), t;
		}
		function fe(e) {
			this.f = e, this.a = [], this.c = {};
		}
		var pe = {
			latin: "BESbswy",
			"latin-ext": "çöüğş",
			cyrillic: "йяЖ",
			greek: "αβΣ",
			khmer: "កខគ",
			Hanuman: "កខគ"
		}, me = {
			thin: "1",
			extralight: "2",
			"extra-light": "2",
			ultralight: "2",
			"ultra-light": "2",
			light: "3",
			regular: "4",
			book: "4",
			medium: "5",
			"semi-bold": "6",
			semibold: "6",
			"demi-bold": "6",
			demibold: "6",
			bold: "7",
			"extra-bold": "8",
			extrabold: "8",
			"ultra-bold": "8",
			ultrabold: "8",
			black: "9",
			heavy: "9",
			l: "3",
			r: "4",
			b: "7"
		}, he = {
			i: "i",
			italic: "i",
			n: "n",
			normal: "n"
		}, W = /^(thin|(?:(?:extra|ultra)-?)?light|regular|book|medium|(?:(?:semi|demi|extra|ultra)-?)?bold|black|heavy|l|r|b|[1-9]00)?(n|i|normal|italic)?$/;
		function G(e) {
			for (var t = e.f.length, n = 0; n < t; n++) {
				var r = e.f[n].split(":"), i = r[0].replace(/\+/g, " "), a = ["n4"];
				if (2 <= r.length) {
					var o, s = r[1];
					if (o = [], s) for (var s = s.split(","), c = s.length, l = 0; l < c; l++) {
						var u = s[l];
						if (u.match(/^[\w-]+$/)) {
							var d = W.exec(u.toLowerCase());
							if (d == null) u = "";
							else {
								if (u = d[2], u = u == null || u == "" ? "n" : he[u], d = d[1], d == null || d == "") d = "4";
								else var f = me[d], d = f || (isNaN(d) ? "4" : d.substr(0, 1));
								u = [u, d].join("");
							}
						} else u = "";
						u && o.push(u);
					}
					0 < o.length && (a = o), r.length == 3 && (r = r[2], o = [], r = r ? r.split(",") : o, 0 < r.length && (r = pe[r[0]]) && (e.c[i] = r));
				}
				for (e.c[i] || (r = pe[i]) && (e.c[i] = r), r = 0; r < a.length; r += 1) e.a.push(new b(i, a[r]));
			}
		}
		function ge(e, t) {
			this.c = e, this.a = t;
		}
		var _e = {
			Arimo: !0,
			Cousine: !0,
			Tinos: !0
		};
		ge.prototype.load = function(e) {
			var t = new h(), n = this.c, r = new ce(this.a.api, this.a.text), i = this.a.families;
			ue(r, i);
			var a = new fe(i);
			G(a), p(n, de(r), g(t)), _(t, function() {
				e(a.a, a.c, _e);
			});
		};
		function K(e, t) {
			this.c = e, this.a = t;
		}
		K.prototype.load = function(e) {
			var t = this.a.id, n = this.c.o;
			t ? m(this.c, (this.a.api || "https://use.typekit.net") + "/" + t + ".js", function(t) {
				if (t) e([]);
				else if (n.Typekit && n.Typekit.config && n.Typekit.config.fn) {
					t = n.Typekit.config.fn;
					for (var r = [], i = 0; i < t.length; i += 2) for (var a = t[i], o = t[i + 1], s = 0; s < o.length; s++) r.push(new b(a, o[s]));
					try {
						n.Typekit.load({
							events: !1,
							classes: !1,
							async: !0
						});
					} catch {}
					e(r);
				}
			}, 2e3) : e([]);
		};
		function ve(e, t) {
			this.c = e, this.f = t, this.a = [];
		}
		ve.prototype.load = function(e) {
			var t = this.f.id, n = this.c.o, r = this;
			t ? (n.__webfontfontdeckmodule__ ||= {}, n.__webfontfontdeckmodule__[t] = function(t, n) {
				for (var i = 0, a = n.fonts.length; i < a; ++i) {
					var o = n.fonts[i];
					r.a.push(new b(o.name, T("font-weight:" + o.weight + ";font-style:" + o.style)));
				}
				e(r.a);
			}, m(this.c, (this.f.api || "https://f.fontdeck.com/s/css/js/") + f(this.c) + "/" + t + ".js", function(t) {
				t && e([]);
			})) : e([]);
		};
		var q = new ae(window);
		q.a.c.custom = function(e, t) {
			return new se(t, e);
		}, q.a.c.fontdeck = function(e, t) {
			return new ve(t, e);
		}, q.a.c.monotype = function(e, t) {
			return new U(t, e);
		}, q.a.c.typekit = function(e, t) {
			return new K(t, e);
		}, q.a.c.google = function(e, t) {
			return new ge(t, e);
		};
		var ye = { load: r(q.load, q) };
		t !== void 0 && t.exports ? t.exports = ye : (window.WebFont = ye, window.WebFontConfig && q.load(window.WebFontConfig));
	})();
})), Lr = /* @__PURE__ */ s(((e, t) => {
	function n(e, t) {
		var n = t && t.cache ? t.cache : f, r = t && t.serializer ? t.serializer : u;
		return (t && t.strategy ? t.strategy : s)(e, {
			cache: n,
			serializer: r
		});
	}
	function r(e) {
		return e == null || typeof e == "number" || typeof e == "boolean";
	}
	function i(e, t, n, i) {
		var a = r(i) ? i : n(i), o = t.get(a);
		return o === void 0 && (o = e.call(this, i), t.set(a, o)), o;
	}
	function a(e, t, n) {
		var r = Array.prototype.slice.call(arguments, 3), i = n(r), a = t.get(i);
		return a === void 0 && (a = e.apply(this, r), t.set(i, a)), a;
	}
	function o(e, t, n, r, i) {
		return n.bind(t, e, r, i);
	}
	function s(e, t) {
		var n = e.length === 1 ? i : a;
		return o(e, this, n, t.cache.create(), t.serializer);
	}
	function c(e, t) {
		var n = a;
		return o(e, this, n, t.cache.create(), t.serializer);
	}
	function l(e, t) {
		var n = i;
		return o(e, this, n, t.cache.create(), t.serializer);
	}
	function u() {
		return JSON.stringify(arguments);
	}
	function d() {
		this.cache = Object.create(null);
	}
	d.prototype.has = function(e) {
		return e in this.cache;
	}, d.prototype.get = function(e) {
		return this.cache[e];
	}, d.prototype.set = function(e, t) {
		this.cache[e] = t;
	};
	var f = { create: function() {
		return new d();
	} };
	t.exports = n, t.exports.strategies = {
		variadic: c,
		monadic: l
	};
})), Rr = /* @__PURE__ */ u(Ir(), 1), zr = /* @__PURE__ */ u(Lr(), 1), Br = window.AppcuesBundleSettings?.VERSION === "dev" ? "https://fast.appcues.com/v1" : window.AppcuesBundleSettings?.GENERIC_BUNDLE_DOMAIN ? `${window.AppcuesBundleSettings.GENERIC_BUNDLE_DOMAIN}/v1` : "https://fast.appcues.com/v1", Vr = 9999, Hr = {
	fastBaseUrl: null,
	useAssetsPath: !1
}, Ur = (e = {}) => {
	Hr = {
		...Hr,
		...e
	};
}, Wr = () => Hr.fastBaseUrl ?? Br, Gr = () => Hr.useAssetsPath;
//#endregion
//#region src/lib/url.js
function Kr(e) {
	return e.replace(/\/+$/, "");
}
//#endregion
//#region src/api.js
var qr = (0, zr.default)((e, t) => {
	let n = Wr();
	if (Gr()) {
		let t = Kr(n);
		return fetch(`${t}/themes/${encodeURIComponent(e)}.json`).then((e) => e.json());
	}
	return fetch(`${n}/accounts/${t}/styles/${e}`).then((e) => e.json());
}, { serializer: ([e, t]) => `${e}:${t}:${Gr()}` }), Jr = (e, t) => {
	let n = { classes: !1 };
	t != null && (n.custom = { urls: [t.general.headerFontUrl, t.general.bodyFontUrl] }), e && (n.typekit = { id: e }), Object.keys(n).length > 1 && Rr.default.load(n);
}, Yr = (e, t, n) => {
	if (!e) return;
	let r = (n.ownerDocument || document).createElement("style");
	r.innerHTML = `${e}`, t && r.classList.add(`theme-${t}`), n.shadowRoot.prepend(r);
}, Xr = async (e) => {
	let t = e.getAttribute("themeId"), { globalStyling: n, theme: r, typekitId: i } = await qr(t, e.getAttribute("accountId")).catch(() => {}) ?? {
		globalStyling: "",
		theme: {},
		typekitId: ""
	};
	Jr(r?.json?.typekitId ?? i, r?.json), Yr(r?.css, t, e), Yr(n, t, e);
}, Zr = async (e, t) => {
	await Xr(e), t && e.shadowRoot.querySelectorAll(`.theme-${t}`).forEach((e) => e.remove());
}, Qr = X({ step: ({ step: e }, t) => ({
	...e,
	virtualizedContent: t.virtualizedContent
}) }), $r = (e) => X({ step: (t, n) => ({
	stepConfig: n.stepConfig,
	virtualizedContent: e(n.stepConfig)
}) }), ei = X({
	experience: (e, t) => t.experience,
	step: ({ step: e }, t) => ({
		...e,
		...t.stepConfig
	})
}), ti = qt(yn), ni = qt(({ step: e, stopReason: t }) => ({
	type: Ln,
	id: e.id,
	reason: t
})), ri = (e, { styles: t, getRoot: n }) => {
	let r = n();
	r && Object.entries(t).forEach(([e, t]) => {
		e.startsWith("--") ? r.style.setProperty(e, t) : r.style[e] = t;
	});
}, ii = (e) => (t) => {
	let { theme: n, themeSystem: r, id: i } = t.experience;
	if (r || !n) return;
	let a = e("getWindowReference")().document.documentElement.querySelector(`#${vr(i)}`), o = a.getAttribute("themeId");
	a?.setAttribute("themeId", n), Zr(a, o);
}, ai = (e) => X({ step: ({ step: t }) => {
	if (t.type !== "tooltip" || t.contentType === "application/json") return t;
	let n = Object.entries(t.actions).filter(([, e]) => e.find((e) => e.on === "click")).map(([e]) => e), r = t.traits.filter(({ config: e }) => e.targetId).map(({ config: e }) => e.targetId);
	return {
		...t,
		virtualizedContent: e(t, {
			interactiveEls: n,
			focusableEls: r
		})
	};
} }), oi = Ye([{
	cond: (e, t) => t.errorEvent?.type === ir,
	actions: [Me({
		type: An,
		isAutoRecoverEvent: !0
	})]
}]), si = X({ actionsRunning: !0 }), ci = X({ actionsRunning: !1 }), li = (e, t) => {
	let n = t.changedExperienceTraits && t.changedExperienceTraits.changedTraits.length > 0, r = t.changedExperienceTraits && (t.changedExperienceTraits.addedTraits.length > 0 || t.changedExperienceTraits.removedTraits.length > 0), i = t.changedStepTraits && t.changedStepTraits.changedTraits.length > 0, a = t.changedStepTraits && (t.changedStepTraits.addedTraits.length > 0 || t.changedStepTraits.removedTraits.length > 0);
	return r || a ? !1 : !!(n || i);
}, ui = "There is already a key registered with this name", di = "Key name should be string and callback a valid function", fi = () => {
	let e = /* @__PURE__ */ new Map(), t = (t) => e.get(t);
	return {
		getCallback: t,
		registerCallback: (n, r) => {
			if (t(n) && console.info(`${ui}: ${n}, the callback will be replaced by the new one`), typeof n != "string" || typeof r != "function") throw TypeError(di);
			e.set(n, r);
		}
	};
}, pi = ({ getTrait: e, trait: t, ...n }) => {
	let r = e(t.type);
	r && r(n, t.config ?? {});
}, { getCallback: mi, registerCallback: Q } = fi(), hi = (e = 21) => crypto.getRandomValues(new Uint8Array(e)).reduce((e, t) => (t &= 63, t < 36 ? e += t.toString(36) : t < 62 ? e += (t - 26).toString(36).toUpperCase() : t > 62 ? e += "-" : e += "_", e), ""), gi = ({ experience: e, callback: t, step: n, findId: r, getContainer: i, getWindowReference: a, sendToExperience: o }) => {
	let s = (e, { forwardToParent: r = !1 } = {}) => {
		let s = ({ type: e, ...n }) => t(r ? {
			...n,
			eventType: e,
			type: Bn
		} : {
			type: e,
			...n
		}), c = (e) => r && o ? o(e) : s(e);
		return {
			querySelector: (e) => Tr(e, {
				step: n,
				checkOutsideContainer: !1,
				stepContainer: i(),
				getWindowReference: a
			}),
			start: () => c({
				type: wn,
				id: e.id
			}),
			stop: (t, n) => {
				c({
					type: Tn,
					id: e.id,
					onStopped: t,
					reason: n
				});
			},
			setStepContainerTarget: (t) => {
				s({
					type: Dn,
					id: e.id,
					container: t
				});
			},
			recover: ({ errorId: t }) => {
				s({
					type: kn,
					id: e.id,
					errorId: t
				});
			},
			dismissExperience: () => s({ type: Rn }),
			snoozeExperience: () => s({ type: zn }),
			seen: () => s({
				type: Pn,
				id: e.id
			}),
			getConfig: () => e,
			interaction: (t, n) => s({
				type: Nn,
				id: e.id,
				interactionType: t,
				interactionData: n
			}),
			extendedEvent: (t, n) => s({
				type: Cn,
				id: e.id,
				name: t,
				...n
			})
		};
	}, c = e.steps.map((e) => s(e, { forwardToParent: !!n }));
	return n ? {
		getRootNodeId: () => r(n.virtualizedContent),
		steps: c,
		step: s(n, { forwardToParent: !1 })
	} : {
		getRootNodeId: () => r(n.virtualizedContent),
		steps: c
	};
}, _i = ({ experience: e, step: t, overrideStyle: n, getContainer: r, getRoot: i, callback: a, get: o, getAction: s = () => null, handleNavigation: c }) => {
	let { findId: l } = o("vNodeHandlers"), u = o("getWindowReference"), d = o("getExperienceSend"), f = gi({
		experience: e,
		step: t,
		callback: a,
		findId: l,
		getContainer: r,
		getWindowReference: u,
		sendToExperience: typeof d == "function" ? d(e.id) : void 0
	}), p = (e) => {
		let t = hi();
		return console.info("error reported:", e), a({
			type: Mn,
			message: e,
			errorId: t
		}), t;
	}, m = () => a(xn), h = () => e.id, g = {
		getContainer: r,
		querySelector: (e) => Tr(e, {
			step: t,
			checkOutsideContainer: !0,
			stepContainer: r(),
			getWindowReference: u
		}),
		reportError: p,
		onElementInserted: (e) => xr({
			...e,
			getWindowReference: u
		}),
		onElementRemoved: (e) => Sr({
			...e,
			getWindowReference: u
		}),
		...f,
		stopExperience: m,
		getExperienceId: h,
		getWindowReference: u,
		sendEvent: o("sendEvent"),
		sendCustomEvent: o("sendCustomEvent"),
		showFlow: (t) => o("showFlow")({
			campaignId: e.campaignId ?? null,
			tacticId: e.tacticId ?? null,
			...t
		}),
		updateUserProfile: o("updateUserProfile"),
		handleNavigation: (n) => c({
			...n,
			experienceId: e.id,
			stepId: t.id,
			campaignId: e.campaignId ?? null,
			tacticId: e.tacticId ?? null
		}),
		getAction: (n) => s(`${e.id}.${n}`) ?? s(`${t.id}.${n}`) ?? s(n)
	};
	return n ? {
		updateStyle: (e, r) => {
			n(e, r), a({
				type: En,
				id: t.id
			});
		},
		updateRootStyle: (e, t = {}) => {
			a({
				type: Fn,
				styles: e,
				options: t,
				getRoot: i
			});
		},
		...g
	} : g;
}, vi = "formData.", yi = "a, button, video, input, textarea, select, form", bi = (e, t) => {
	if (t.startsWith(vi)) {
		let n = t.replace(vi, "");
		return new FormData(e.target).get(n);
	}
	return fn(e, t);
}, { getCallback: xi, registerCallback: Si } = fi(), Ci = (e, t, n) => {
	let r = {
		target: t.target,
		detail: t.detail
	};
	return Object.entries(e).reduce((e, [t, n]) => {
		let i = bi(r, t);
		return i ? un(e, n, i) : e;
	}, n);
}, wi = ({ step: e, experience: t, overrideStyle: n, getContainer: r, callback: i, get: a }) => {
	let o = a("getWindowReference"), s = [], c = [], l = (e) => {
		try {
			return [...gr(e, o().document.documentElement)];
		} catch {
			return [];
		}
	}, u = (o, c) => {
		if (o.length === 0) return;
		let l = {};
		c.forEach(({ on: n, type: r, config: i, allowedKeys: a, mapEventToConfig: o }) => {
			if (!i?.external || n.startsWith("hooks/")) return;
			let s = xi(`${t.id}.${r}`) ?? xi(`${e.id}.${r}`) ?? xi(r);
			l[n] || (l[n] = []), s && l[n].push([
				s,
				i,
				a,
				o
			]);
		}), Object.entries(l).forEach(([c, l]) => {
			let u = (o) => {
				i({ type: Hn });
				let s = _i({
					experience: t,
					step: e,
					overrideStyle: n,
					getContainer: r,
					callback: i,
					get: a,
					getAction: xi
				});
				try {
					l.forEach(([e, t, n, r]) => {
						n && !n.includes(o.code) || e(r ? {
							...t,
							...Ci(r, o, t)
						} : t, s);
					});
				} catch {
					s.reportError("something bad happened while running an action.");
				} finally {
					i({ type: Un });
				}
			};
			o.forEach((e) => {
				e.addEventListener(c, u), s.push({
					el: e,
					event: c,
					handler: u
				});
			});
		});
	};
	return Object.entries(e.actions ?? {}).forEach(([e, t]) => {
		if (!t.some((e) => e.config?.external)) return;
		let n = l(e);
		if (n.length > 0) {
			u(n, t);
			return;
		}
		let r = xr({
			getTarget: () => l(e),
			onInserted: () => {
				u(l(e), t);
			},
			getWindowReference: o
		});
		c.push(r);
	}), () => {
		s.forEach(({ el: e, event: t, handler: n }) => e.removeEventListener(t, n)), c.forEach((e) => e());
	};
}, Ti = ({ overrideStyle: e, getContainer: t }, n) => () => (r, i) => {
	let a = () => {};
	return i(({ type: i, step: o, experience: s }) => {
		if (i === "RUN_TRAITS_DONE") {
			a();
			try {
				let { findId: i, traverseTree: c, injectHandlers: l } = n("vNodeHandlers"), u = JSON.parse(JSON.stringify(o.virtualizedContent));
				c(u, (a) => {
					let c = i(a);
					if (!o.actions[c]) return;
					let u = {}, d = (i, a) => {
						r({ type: Hn });
						let c = _i({
							experience: s,
							step: o,
							overrideStyle: e,
							getContainer: t,
							callback: r,
							get: n,
							getAction: xi,
							handleNavigation: n("handleNavigation")
						});
						try {
							u[i].forEach(([e, t, n]) => {
								e(n && a ? {
									...t,
									...Ci(n, a, t)
								} : t, c);
							});
						} catch {
							c.reportError("something bad happened while running an action.");
						} finally {
							r({ type: Un });
						}
					}, f = {}, p = o.actions[c].reduce((e, { on: t, type: n, config: r, allowedKeys: i, mapEventToConfig: a, guardInteractiveChildren: c }) => {
						c && (f[t] = !0);
						let l = xi(`${s.id}.${n}`) ?? xi(`${o.id}.${n}`) ?? xi(n);
						return u[t] || (u[t] = []), l && u[t].push([
							l,
							r,
							a
						]), t.startsWith("hooks/") ? e.hook[t.replace("hooks/", "")] = () => d(t) : e.on[t] = (e) => {
							if (!(i && !i.includes(e.code))) {
								if (f[t]) {
									let t = e.target.closest(yi);
									if (t && t !== e.currentTarget) return;
								}
								e.preventDefault(), e.stopPropagation(), d(t, e);
							}
						}, e;
					}, {
						on: {},
						hook: {}
					});
					a = l(a, p);
				}), r({
					type: On,
					virtualizedContent: u
				}), a = wi({
					step: o,
					experience: s,
					overrideStyle: e,
					getContainer: t,
					callback: r,
					get: n
				});
			} catch (e) {
				console.error("[actions service] Error binding actions:", e), r(dr);
			}
		}
	}), () => a();
}, Ei = ({ addHook: e }) => (t) => (n) => {
	let { step: r } = t;
	try {
		r.traits.forEach((t) => pi({
			getTrait: mi,
			addHook: (n, r) => {
				e(n, {
					callback: r,
					traitId: t.id
				});
			},
			registerAction: (e, n) => {
				Si(`${r.id}.${t.type}.${e}`, n);
			},
			trait: t
		})), n(lr);
	} catch {
		n(ur);
	}
}, Di = ({ applyOverridesToVnode: e }) => {
	let t = {}, n = (e) => (n, r) => {
		t[n] || (t[n] = {}), t[n][e] || (t[n][e] = {}), t[n][e] = {
			...t[n][e],
			...r
		};
	}, r = (e) => t[e];
	return {
		createOverrideCallback: n,
		getOverrides: r,
		applyOverrides: X(({ step: t }) => ({ step: {
			...t,
			virtualizedContent: e(t.virtualizedContent, r)
		} })),
		clearOverrides: () => {
			t = {};
		}
	};
};
//#endregion
//#region ../../node_modules/snabbdom/build/htmldomapi.js
function Oi(e, t) {
	return document.createElement(e, t);
}
function ki(e, t, n) {
	return document.createElementNS(e, t, n);
}
function Ai() {
	return Gi(document.createDocumentFragment());
}
function ji(e) {
	return document.createTextNode(e);
}
function Mi(e) {
	return document.createComment(e);
}
function Ni(e, t, n) {
	if (Wi(e)) {
		let t = e;
		for (; t && Wi(t);) t = Gi(t).parent;
		e = t ?? e;
	}
	Wi(t) && (t = Gi(t, e)), n && Wi(n) && (n = Gi(n).firstChildNode), e.insertBefore(t, n);
}
function Pi(e, t) {
	e.removeChild(t);
}
function Fi(e, t) {
	Wi(t) && (t = Gi(t, e)), e.appendChild(t);
}
function Ii(e) {
	if (Wi(e)) {
		for (; e && Wi(e);) e = Gi(e).parent;
		return e ?? null;
	}
	return e.parentNode;
}
function Li(e) {
	if (Wi(e)) {
		let t = Gi(e), n = Ii(t);
		if (n && t.lastChildNode) {
			let e = Array.from(n.childNodes);
			return e[e.indexOf(t.lastChildNode) + 1] ?? null;
		}
		return null;
	}
	return e.nextSibling;
}
function Ri(e) {
	return e.tagName;
}
function zi(e, t) {
	e.textContent = t;
}
function Bi(e) {
	return e.textContent;
}
function Vi(e) {
	return e.nodeType === 1;
}
function Hi(e) {
	return e.nodeType === 3;
}
function Ui(e) {
	return e.nodeType === 8;
}
function Wi(e) {
	return e.nodeType === 11;
}
function Gi(e, t) {
	let n = e;
	return n.parent ??= t ?? null, n.firstChildNode ??= e.firstChild, n.lastChildNode ??= e.lastChild, n;
}
var Ki, qi = o((() => {
	Ki = {
		createElement: Oi,
		createElementNS: ki,
		createTextNode: ji,
		createDocumentFragment: Ai,
		createComment: Mi,
		insertBefore: Ni,
		removeChild: Pi,
		appendChild: Fi,
		parentNode: Ii,
		nextSibling: Li,
		tagName: Ri,
		setTextContent: zi,
		getTextContent: Bi,
		isElement: Vi,
		isText: Hi,
		isComment: Ui,
		isDocumentFragment: Wi
	};
}));
//#endregion
//#region ../../node_modules/snabbdom/build/vnode.js
function $(e, t, n, r, i) {
	return {
		sel: e,
		data: t,
		children: n,
		text: r,
		elm: i,
		key: t === void 0 ? void 0 : t.key
	};
}
var Ji = o((() => {}));
//#endregion
//#region ../../node_modules/snabbdom/build/is.js
function Yi(e) {
	return typeof e == "string" || typeof e == "number" || e instanceof String || e instanceof Number;
}
var Xi, Zi = o((() => {
	Xi = Array.isArray;
}));
//#endregion
//#region ../../node_modules/snabbdom/build/init.js
function Qi(e, t) {
	let n = e.key === t.key, r = e.data?.is === t.data?.is, i = e.sel === t.sel, a = !e.sel && e.sel === t.sel ? typeof e.text == typeof t.text : !0;
	return i && n && r && a;
}
function $i() {
	throw Error("The document fragment is not supported on this platform.");
}
function ea(e, t) {
	return e.isElement(t);
}
function ta(e, t) {
	return e.isDocumentFragment(t);
}
function na(e, t, n) {
	let r = {};
	for (let i = t; i <= n; ++i) {
		let t = e[i]?.key;
		t !== void 0 && (r[t] = i);
	}
	return r;
}
function ra(e, t, n) {
	let r = {
		create: [],
		update: [],
		remove: [],
		destroy: [],
		pre: [],
		post: []
	}, i = t === void 0 ? Ki : t;
	for (let t of aa) for (let n of e) {
		let e = n[t];
		e !== void 0 && r[t].push(e);
	}
	function a(e) {
		let t = e.id ? "#" + e.id : "", n = e.getAttribute("class"), r = n ? "." + n.split(" ").join(".") : "";
		return $(i.tagName(e).toLowerCase() + t + r, {}, [], void 0, e);
	}
	function o(e) {
		return $(void 0, {}, [], void 0, e);
	}
	function s(e, t) {
		return function() {
			if (--t === 0) {
				let t = i.parentNode(e);
				t !== null && i.removeChild(t, e);
			}
		};
	}
	function c(e, t) {
		var a, o;
		let s, l = e.data, u = l?.hook;
		(a = u?.init) == null || a.call(u, e);
		let d = e.children, f = e.sel;
		if (f === "!") e.text ??= "", e.elm = i.createComment(e.text);
		else if (f === "") e.elm = i.createTextNode(e.text);
		else if (f !== void 0) {
			let n = f.indexOf("#"), a = f.indexOf(".", n), p = n > 0 ? n : f.length, m = a > 0 ? a : f.length, h = n !== -1 || a !== -1 ? f.slice(0, Math.min(p, m)) : f, g = l?.ns, _ = g === void 0 ? i.createElement(h, l) : i.createElementNS(g, h, l);
			for (e.elm = _, p < m && _.setAttribute("id", f.slice(p + 1, m)), a > 0 && _.setAttribute("class", f.slice(m + 1).replace(/\./g, " ")), s = 0; s < r.create.length; ++s) r.create[s](ia, e);
			if (Yi(e.text) && (!Xi(d) || d.length === 0) && i.appendChild(_, i.createTextNode(e.text)), Xi(d)) for (s = 0; s < d.length; ++s) {
				let e = d[s];
				e != null && i.appendChild(_, c(e, t));
			}
			u !== void 0 && ((o = u.create) == null || o.call(u, ia, e), u.insert !== void 0 && t.push(e));
		} else if (n?.experimental?.fragments && e.children) {
			for (e.elm = (i.createDocumentFragment ?? $i)(), s = 0; s < r.create.length; ++s) r.create[s](ia, e);
			for (s = 0; s < e.children.length; ++s) {
				let n = e.children[s];
				n != null && i.appendChild(e.elm, c(n, t));
			}
		} else e.elm = i.createTextNode(e.text);
		return e.elm;
	}
	function l(e, t, n, r, a, o) {
		for (; r <= a; ++r) {
			let a = n[r];
			a != null && i.insertBefore(e, c(a, o), t);
		}
	}
	function u(e) {
		var t, n;
		let i = e.data;
		if (i !== void 0) {
			(n = (t = i?.hook)?.destroy) == null || n.call(t, e);
			for (let t = 0; t < r.destroy.length; ++t) r.destroy[t](e);
			if (e.children !== void 0) for (let t = 0; t < e.children.length; ++t) {
				let n = e.children[t];
				n != null && typeof n != "string" && u(n);
			}
		}
	}
	function d(e, t, n, a) {
		for (; n <= a; ++n) {
			let a, o = t[n];
			if (o != null) if (o.sel !== void 0) {
				u(o), a = r.remove.length + 1;
				let e = s(o.elm, a);
				for (let t = 0; t < r.remove.length; ++t) r.remove[t](o, e);
				let t = o?.data?.hook?.remove;
				t === void 0 ? e() : t(o, e);
			} else o.children ? (u(o), d(e, o.children, 0, o.children.length - 1)) : i.removeChild(e, o.elm);
		}
	}
	function f(e, t, n, r) {
		let a = 0, o = 0, s = t.length - 1, u = t[0], f = t[s], m = n.length - 1, h = n[0], g = n[m], _, v, y, b;
		for (; a <= s && o <= m;) u == null ? u = t[++a] : f == null ? f = t[--s] : h == null ? h = n[++o] : g == null ? g = n[--m] : Qi(u, h) ? (p(u, h, r), u = t[++a], h = n[++o]) : Qi(f, g) ? (p(f, g, r), f = t[--s], g = n[--m]) : Qi(u, g) ? (p(u, g, r), i.insertBefore(e, u.elm, i.nextSibling(f.elm)), u = t[++a], g = n[--m]) : Qi(f, h) ? (p(f, h, r), i.insertBefore(e, f.elm, u.elm), f = t[--s], h = n[++o]) : (_ === void 0 && (_ = na(t, a, s)), v = _[h.key], v === void 0 ? (i.insertBefore(e, c(h, r), u.elm), h = n[++o]) : _[g.key] === void 0 ? (i.insertBefore(e, c(g, r), i.nextSibling(f.elm)), g = n[--m]) : (y = t[v], y.sel === h.sel ? (p(y, h, r), t[v] = void 0, i.insertBefore(e, y.elm, u.elm)) : i.insertBefore(e, c(h, r), u.elm), h = n[++o]));
		o <= m && (b = n[m + 1] == null ? null : n[m + 1].elm, l(e, b, n, o, m, r)), a <= s && d(e, t, a, s);
	}
	function p(e, t, n) {
		var a, o, s, c;
		let u = t.data?.hook;
		(a = u?.prepatch) == null || a.call(u, e, t);
		let p = t.elm = e.elm;
		if (e === t) return;
		if (t.data !== void 0 || t.text !== void 0 && t.text !== e.text) {
			t.data ??= {}, e.data ??= {};
			for (let n = 0; n < r.update.length; ++n) r.update[n](e, t);
			(s = (o = t.data?.hook)?.update) == null || s.call(o, e, t);
		}
		let m = e.children, h = t.children;
		t.text === void 0 ? m !== void 0 && h !== void 0 ? m !== h && f(p, m, h, n) : h === void 0 ? m === void 0 ? e.text !== void 0 && i.setTextContent(p, "") : d(p, m, 0, m.length - 1) : (e.text !== void 0 && i.setTextContent(p, ""), l(p, null, h, 0, h.length - 1, n)) : e.text !== t.text && (m !== void 0 && d(p, m, 0, m.length - 1), i.setTextContent(p, t.text)), (c = u?.postpatch) == null || c.call(u, e, t);
	}
	return function(e, t) {
		let n, s, l, u = [];
		for (n = 0; n < r.pre.length; ++n) r.pre[n]();
		for (ea(i, e) ? e = a(e) : ta(i, e) && (e = o(e)), Qi(e, t) ? p(e, t, u) : (s = e.elm, l = i.parentNode(s), c(t, u), l !== null && (i.insertBefore(l, t.elm, i.nextSibling(s)), d(l, [e], 0, 0))), n = 0; n < u.length; ++n) u[n].data.hook.insert(u[n]);
		for (n = 0; n < r.post.length; ++n) r.post[n]();
		return t;
	};
}
var ia, aa, oa = o((() => {
	Ji(), Zi(), qi(), ia = $("", {}, [], void 0, void 0), aa = [
		"create",
		"update",
		"remove",
		"destroy",
		"pre",
		"post"
	];
}));
//#endregion
//#region ../../node_modules/snabbdom/build/h.js
function sa(e, t, n) {
	if (e.ns = "http://www.w3.org/2000/svg", n !== "foreignObject" && t !== void 0) for (let e = 0; e < t.length; ++e) {
		let n = t[e];
		if (typeof n == "string") continue;
		let r = n.data;
		r !== void 0 && sa(r, n.children, n.sel);
	}
}
function ca(e, t, n) {
	let r = {}, i, a, o;
	if (n === void 0 ? t != null && (Xi(t) ? i = t : Yi(t) ? a = t.toString() : t && t.sel ? i = [t] : r = t) : (t !== null && (r = t), Xi(n) ? i = n : Yi(n) ? a = n.toString() : n && n.sel && (i = [n])), i !== void 0) for (o = 0; o < i.length; ++o) Yi(i[o]) && (i[o] = $(void 0, void 0, void 0, i[o], void 0));
	return e.startsWith("svg") && (e.length === 3 || e[3] === "." || e[3] === "#") && sa(r, i, e), $(e, r, i, a, void 0);
}
function la(e) {
	let t, n;
	if (Xi(e) ? t = e : Yi(t) ? n = e : t && t.sel && (t = [e]), t !== void 0) for (let e = 0; e < t.length; ++e) Yi(t[e]) && (t[e] = $(void 0, void 0, void 0, t[e], void 0));
	return $(void 0, {}, t, n, void 0);
}
var ua = o((() => {
	Ji(), Zi();
}));
//#endregion
//#region ../../node_modules/snabbdom/build/thunk.js
function da(e, t) {
	let n = t.data?.ns;
	e.data.fn = t.data.fn, e.data.args = t.data.args, t.data = e.data, t.children = e.children, t.text = e.text, t.elm = e.elm, n && sa(t.data, t.children, t.sel);
}
function fa(e) {
	let t = e.data;
	da(t.fn(...t.args), e);
}
function pa(e, t) {
	let n, r = e.data, i = t.data, a = r.args, o = i.args;
	if (r.fn !== i.fn || a.length !== o.length) {
		da(i.fn(...o), t);
		return;
	}
	for (n = 0; n < o.length; ++n) if (a[n] !== o[n]) {
		da(i.fn(...o), t);
		return;
	}
	da(e, t);
}
var ma, ha = o((() => {
	ua(), ma = function(e, t, n, r) {
		return r === void 0 && (r = n, n = t, t = void 0), ca(e, {
			key: t,
			hook: {
				init: fa,
				prepatch: pa
			},
			fn: n,
			args: r
		});
	};
}));
//#endregion
//#region ../../node_modules/snabbdom/build/helpers/attachto.js
function ga(e, t) {
	let n = e.data.attachData;
	t.data.attachData.placeholder = n.placeholder, t.data.attachData.real = n.real, e.elm = e.data.attachData.real;
}
function _a(e, t) {
	t.elm = t.data.attachData.placeholder;
}
function va(e) {
	e.elm !== void 0 && e.elm.parentNode.removeChild(e.elm), e.elm = e.data.attachData.real;
}
function ya(e, t) {
	let n = t.elm, r = t.data.attachData, i = document.createElement("span");
	t.elm = i, r.target.appendChild(n), r.real = n, r.placeholder = i;
}
function ba(e, t) {
	t.data === void 0 && (t.data = {}), t.data.hook === void 0 && (t.data.hook = {});
	let n = t.data, r = t.data.hook;
	return n.attachData = {
		target: e,
		placeholder: void 0,
		real: void 0
	}, r.create = ya, r.prepatch = ga, r.postpatch = _a, r.destroy = va, t;
}
var xa = o((() => {}));
//#endregion
//#region ../../node_modules/snabbdom/build/tovnode.js
function Sa(e) {
	return e.slice(5).replace(/-([a-z])/g, (e, t) => t.toUpperCase());
}
function Ca(e, t) {
	let n = t === void 0 ? Ki : t, r;
	if (n.isElement(e)) {
		let r = e.id ? "#" + e.id : "", i = e.getAttribute("class")?.match(/[^\t\r\n\f ]+/g), a = i ? "." + i.join(".") : "", o = n.tagName(e).toLowerCase() + r + a, s = {}, c = {}, l = {}, u = [], d, f, p, m = e.attributes, h = e.childNodes;
		for (f = 0, p = m.length; f < p; f++) d = m[f].nodeName, d.startsWith("data-") ? c[Sa(d)] = m[f].nodeValue || "" : d !== "id" && d !== "class" && (s[d] = m[f].nodeValue);
		for (f = 0, p = h.length; f < p; f++) u.push(Ca(h[f], t));
		return Object.keys(s).length > 0 && (l.attrs = s), Object.keys(c).length > 0 && (l.dataset = c), o.startsWith("svg") && (o.length === 3 || o[3] === "." || o[3] === "#") && sa(l, u, o), $(o, l, u, void 0, e);
	} else if (n.isText(e)) return r = n.getTextContent(e), $(void 0, void 0, void 0, r, e);
	else if (n.isComment(e)) return r = n.getTextContent(e), $("!", {}, [], r, e);
	else return $("", {}, [], void 0, e);
}
var wa = o((() => {
	ua(), Ji(), qi();
})), Ta = o((() => {}));
//#endregion
//#region ../../node_modules/snabbdom/build/modules/attributes.js
function Ea(e, t) {
	let n, r = t.elm, i = e.data.attrs, a = t.data.attrs;
	if (!(!i && !a) && i !== a) {
		for (n in i ||= {}, a ||= {}, a) {
			let e = a[n];
			i[n] !== e && (e === !0 ? r.setAttribute(n, "") : e === !1 ? r.removeAttribute(n) : n.charCodeAt(0) === ja ? n.charCodeAt(3) === Aa ? r.setAttributeNS(ka, n, e) : n.charCodeAt(5) === Aa ? n.charCodeAt(1) === Ma ? r.setAttributeNS(Oa, n, e) : r.setAttributeNS(Da, n, e) : r.setAttribute(n, e) : r.setAttribute(n, e));
		}
		for (n in i) n in a || r.removeAttribute(n);
	}
}
var Da, Oa, ka, Aa, ja, Ma, Na, Pa = o((() => {
	Da = "http://www.w3.org/1999/xlink", Oa = "http://www.w3.org/2000/xmlns/", ka = "http://www.w3.org/XML/1998/namespace", Aa = 58, ja = 120, Ma = 109, Na = {
		create: Ea,
		update: Ea
	};
}));
//#endregion
//#region ../../node_modules/snabbdom/build/modules/class.js
function Fa(e, t) {
	let n, r, i = t.elm, a = e.data.class, o = t.data.class;
	if (!(!a && !o) && a !== o) {
		for (r in a ||= {}, o ||= {}, a) a[r] && !Object.prototype.hasOwnProperty.call(o, r) && i.classList.remove(r);
		for (r in o) n = o[r], n !== a[r] && i.classList[n ? "add" : "remove"](r);
	}
}
var Ia, La = o((() => {
	Ia = {
		create: Fa,
		update: Fa
	};
}));
//#endregion
//#region ../../node_modules/snabbdom/build/modules/dataset.js
function Ra(e, t) {
	let n = t.elm, r = e.data.dataset, i = t.data.dataset, a;
	if (!r && !i || r === i) return;
	r ||= {}, i ||= {};
	let o = n.dataset;
	for (a in r) a in i || (o ? a in o && delete o[a] : n.removeAttribute("data-" + a.replace(za, "-$&").toLowerCase()));
	for (a in i) r[a] !== i[a] && (o ? o[a] = i[a] : n.setAttribute("data-" + a.replace(za, "-$&").toLowerCase(), i[a]));
}
var za, Ba, Va = o((() => {
	za = /[A-Z]/g, Ba = {
		create: Ra,
		update: Ra
	};
}));
//#endregion
//#region ../../node_modules/snabbdom/build/modules/eventlisteners.js
function Ha(e, t, n) {
	if (typeof e == "function") e.call(t, n, t);
	else if (typeof e == "object") for (let r = 0; r < e.length; r++) Ha(e[r], t, n);
}
function Ua(e, t) {
	let n = e.type, r = t.data.on;
	r && r[n] && Ha(r[n], t, e);
}
function Wa() {
	return function e(t) {
		Ua(t, e.vnode);
	};
}
function Ga(e, t) {
	let n = e.data.on, r = e.listener, i = e.elm, a = t && t.data.on, o = t && t.elm, s;
	if (n !== a) {
		if (n && r) if (a) for (s in n) a[s] || i.removeEventListener(s, r, !1);
		else for (s in n) i.removeEventListener(s, r, !1);
		if (a) {
			let r = t.listener = e.listener || Wa();
			if (r.vnode = t, n) for (s in a) n[s] || o.addEventListener(s, r, !1);
			else for (s in a) o.addEventListener(s, r, !1);
		}
	}
}
var Ka, qa = o((() => {
	Ka = {
		create: Ga,
		update: Ga,
		destroy: Ga
	};
}));
//#endregion
//#region ../../node_modules/snabbdom/build/modules/props.js
function Ja(e, t) {
	let n, r, i, a = t.elm, o = e.data.props, s = t.data.props;
	if (!(!o && !s) && o !== s) for (n in o ||= {}, s ||= {}, s) r = s[n], i = o[n], i !== r && (n !== "value" || a[n] !== r) && (a[n] = r);
}
var Ya, Xa = o((() => {
	Ya = {
		create: Ja,
		update: Ja
	};
}));
//#endregion
//#region ../../node_modules/snabbdom/build/modules/style.js
function Za(e, t, n) {
	ro(() => {
		e[t] = n;
	});
}
function Qa(e, t) {
	let n, r, i = t.elm, a = e.data.style, o = t.data.style;
	if (!a && !o || a === o) return;
	a ||= {}, o ||= {};
	let s = "delayed" in a;
	for (r in a) r in o || (r[0] === "-" && r[1] === "-" ? i.style.removeProperty(r) : i.style[r] = "");
	for (r in o) if (n = o[r], r === "delayed" && o.delayed) for (let e in o.delayed) n = o.delayed[e], (!s || n !== a.delayed[e]) && Za(i.style, e, n);
	else r !== "remove" && n !== a[r] && (r[0] === "-" && r[1] === "-" ? i.style.setProperty(r, n) : i.style[r] = n);
}
function $a(e) {
	let t, n, r = e.elm, i = e.data.style;
	if (!(!i || !(t = i.destroy))) for (n in t) r.style[n] = t[n];
}
function eo(e, t) {
	let n = e.data.style;
	if (!n || !n.remove) {
		t();
		return;
	}
	io ||= (e.elm.offsetLeft, !0);
	let r, i = e.elm, a = 0, o = n.remove, s = 0, c = [];
	for (r in o) c.push(r), i.style[r] = o[r];
	let l = getComputedStyle(i)["transition-property"].split(", ");
	for (; a < l.length; ++a) c.indexOf(l[a]) !== -1 && s++;
	i.addEventListener("transitionend", (e) => {
		e.target === i && --s, s === 0 && t();
	});
}
function to() {
	io = !1;
}
var no, ro, io, ao, oo = o((() => {
	no = typeof (window == null ? void 0 : window.requestAnimationFrame) == "function" ? window.requestAnimationFrame.bind(window) : setTimeout, ro = (e) => {
		no(() => {
			no(e);
		});
	}, io = !1, ao = {
		pre: to,
		create: Qa,
		update: Qa,
		destroy: $a,
		remove: eo
	};
}));
//#endregion
//#region ../../node_modules/snabbdom/build/jsx.js
function so(e, ...t) {
	let n = co(t, []);
	return n.length === 1 && !n[0].sel && n[0].text ? $(void 0, void 0, void 0, n[0].text, void 0) : $(void 0, e ?? {}, n, void 0, void 0);
}
function co(e, t) {
	for (let n of e) n != null && n !== !1 && n !== "" && (Array.isArray(n) ? co(n, t) : typeof n == "string" || typeof n == "number" || typeof n == "boolean" ? t.push($(void 0, void 0, void 0, String(n), void 0)) : t.push(n));
	return t;
}
function lo(e, t, ...n) {
	let r = co(n, []);
	return typeof e == "function" ? e(t, r) : r.length === 1 && !r[0].sel && r[0].text ? ca(e, t, r[0].text) : ca(e, t, r);
}
var uo = o((() => {
	Ji(), ua();
})), fo = /* @__PURE__ */ c({
	Fragment: () => so,
	array: () => Xi,
	attachTo: () => ba,
	attributesModule: () => Na,
	classModule: () => Ia,
	datasetModule: () => Ba,
	eventListenersModule: () => Ka,
	fragment: () => la,
	h: () => ca,
	htmlDomApi: () => Ki,
	init: () => ra,
	jsx: () => lo,
	primitive: () => Yi,
	propsModule: () => Ya,
	styleModule: () => ao,
	thunk: () => ma,
	toVNode: () => Ca,
	vnode: () => $
}), po = o((() => {
	qi(), oa(), ha(), Ji(), xa(), Zi(), wa(), ua(), Ta(), Pa(), La(), Va(), qa(), Xa(), oo(), uo();
}));
//#endregion
//#region src/core/lib/functions.js
po();
var mo = (...e) => (t) => e.reduce((e, t) => t(e), t), ho = (e) => e.reduce((e, { callback: t, context: n }) => e.then(() => t(n)), Promise.resolve()), go = ({ experience: e, onRender: t, onRenderReset: n, wrapContent: r, getWindowReference: i = () => window }) => {
	let a = null, o = null, s = () => {
		let t = i().document, n = vr(e.id);
		return t.documentElement.querySelector(`#${n}`);
	}, c = () => o ? o.shadowRoot : null, l = () => a ? a.shadowRoot : null, u = mo((e) => (l() !== null || c() !== null || (a = s()), e), r, ({ step: { virtualizedContent: e } }) => {
		t(c() ?? l(), e);
	});
	return {
		render: async (e) => new Promise((t) => {
			t(u(e));
		}),
		unmount: () => t(null, ca("!")),
		setContainer: (e, { container: t }) => {
			let { theme: n, themeSystem: r, accountId: a } = e.experience, { id: s } = e.step;
			o && o.remove(), o = Dr({
				accountId: a,
				id: s,
				...!r && { theme: n },
				getWindowReference: i
			}), t.parentNode.replaceChild(o, t);
		},
		resetRender: () => {
			a = null, o && o.remove(), o = null, n();
		},
		getContainer: () => c() ?? l() ?? s().shadowRoot,
		getRoot: () => o ?? s(),
		hasCustomContainer: (e, t) => t.type === "UPDATE_ROOT_STYLE" && t.options?.forceUpdate || !!c()
	};
}, _o = ({ container: e, nodes: t }, n = 0) => e.replace(/<% node %>/, t[n]), vo = (e) => e.replaceAll("//twemoji.maxcdn.com/2/svg/", "//cdn.jsdelivr.net/gh/twitter/twemoji@14.0.2/assets/svg/"), yo = (e) => e.split("_").map((e) => e.charAt(0).toUpperCase() + e.slice(1)).join(" "), bo = ({ experience: e, experienceInstanceId: t }, n) => ({
	experienceId: e.id,
	experienceName: e.name,
	experienceType: e.type,
	isCoreEvent: !0,
	localeName: e.context?.localeName || "default",
	localeId: e.context?.localeId || "default",
	...e.campaignId != null && { campaignId: e.campaignId },
	...e.tacticId != null && { tacticId: e.tacticId },
	timestamp: Date.now(),
	version: e.version,
	name: yo(n),
	experienceInstanceId: t
}), xo = ({ step: e }) => ({
	stepId: e.id,
	stepName: e.name,
	stepType: e.type
}), So = (e, t) => !e.blockedEvents[t.type], Co = (e) => {
	let t = (t) => {
		let n = "experience_started", r = bo(t, n);
		e("sendEvent")(n, r);
	}, n = (t) => {
		let n = "experience_completed", r = bo(t, n);
		e("sendEvent")(n, r);
	}, r = (t, { message: n }) => {
		let r = "experience_error", i = bo(t, r);
		e("sendEvent")(r, {
			...i,
			message: n
		});
	}, i = (t) => {
		let n = "experience_dismissed", r = bo(t, n), i = xo(t);
		e("sendEvent")(n, {
			...r,
			...i
		});
	}, a = (t) => {
		let n = "experience_snoozed", r = bo(t, n), i = xo(t);
		e("sendEvent")(n, {
			...r,
			...i
		});
	}, o = (t) => {
		let n = "step_seen", r = bo(t, n), i = xo(t);
		e("sendEvent")(n, {
			...r,
			...i
		});
	}, s = (t) => {
		let n = "step_completed", r = bo(t, n), i = xo(t);
		e("sendEvent")(n, {
			...r,
			...i
		});
	}, c = (t, n) => {
		let r = bo(t, n.name), i = xo(t), a = e("sendEvent"), { name: o, ...s } = n;
		a(o, {
			...r,
			...i,
			...s
		});
	}, l = (t, { interactionType: n, interactionData: r }) => {
		let i = "step_interaction", a = bo(t, i), o = xo(t);
		e("sendEvent")(i, {
			...a,
			...o,
			interactionType: n,
			interactionData: r
		});
	}, u = (t, { message: n, errorId: r }) => {
		let i = "step_error", a = bo(t, i), o = xo(t);
		e("sendEvent")(i, {
			...a,
			...o,
			message: n,
			errorId: r
		});
	}, d = (t, { errorId: n }) => {
		let r = "step_recovered", i = bo(t, r), a = xo(t);
		e("sendEvent")(r, {
			...i,
			...a,
			errorId: n
		});
	}, f = X((e, { type: t, name: n = "" }) => {
		let r = t === "EXTENDED_EVENT" ? n : t;
		return { blockedEvents: {
			...e.blockedEvents,
			[r]: !0
		} };
	});
	return {
		experienceActions: {
			experienceStarted: t,
			experienceError: r,
			experienceCompleted: n
		},
		stepActions: {
			experienceDismissed: i,
			experienceSnoozed: a,
			stepSeen: o,
			stepInteraction: l,
			stepError: u,
			stepRecovered: d,
			stepExtendedEvent: c,
			stepCompleted: s
		},
		helpers: {
			blockEvent: f,
			isEventEnabled: So
		}
	};
}, wo = Gt({
	initial: "waitingForAsyncEvents",
	context: { runHooksDone: !1 },
	states: {
		waitingForAsyncEvents: { on: {
			UPDATE_STEP: "update_step",
			ERROR: "error",
			RUN_HOOKS_DONE: {
				target: "",
				actions: X({ runHooksDone: !0 })
			}
		} },
		update_step: {
			always: [{
				target: "done",
				cond: (e) => e.runHooksDone,
				actions: [qt("RERENDER")]
			}],
			on: {
				UPDATE_STEP: "",
				ERROR: "error",
				RUN_HOOKS_DONE: {
					target: "done",
					actions: [X({ runHooksDone: !0 }), qt("RERENDER")]
				}
			}
		},
		error: {
			always: [{
				target: "done",
				cond: (e) => e.runHooksDone,
				actions: [qt("FORCE_ERROR")]
			}],
			on: {
				UPDATE_STEP: "",
				ERROR: "",
				RUN_HOOKS_DONE: {
					target: "done",
					actions: [X({ runHooksDone: !0 }), qt("FORCE_ERROR")]
				}
			}
		},
		done: { type: "final" }
	}
}), To = Gt({
	initial: "waitingForAsyncEvents",
	context: { runHooksDone: !1 },
	states: {
		waitingForAsyncEvents: { on: {
			RECOVER_STEP: "recover_step",
			RUN_HOOKS_DONE: {
				target: "",
				actions: X({ runHooksDone: !0 })
			}
		} },
		recover_step: {
			always: [{
				target: "done",
				cond: (e) => e.runHooksDone,
				actions: [qt("FORCE_RECOVER")]
			}],
			on: { RUN_HOOKS_DONE: {
				target: "done",
				actions: [X({ runHooksDone: !0 }), qt("FORCE_RECOVER")]
			} }
		},
		done: { type: "final" }
	}
}), Eo = {
	initial: "waiting_to_render",
	on: {
		SET_STEP_CONTAINER_TARGET: {
			actions: ["setContainer", "runStepContainerChangeHooks"],
			target: ""
		},
		UPDATE_ROOT_STYLE: {
			actions: "updateRootStyle",
			target: "",
			cond: "hasCustomContainer"
		},
		UPDATE_STEP_CONTENT: {
			actions: "setContent",
			target: ""
		},
		RUN_HOOKS_ERROR: "destroyed",
		BIND_ACTIONS_ERROR: "destroyed",
		STOP_STEP: [{
			cond: "hasPendingActions",
			target: "waitingPendingActions",
			actions: ["saveStopReason", "addStoppedCallback"],
			internal: !0
		}, {
			target: "running_end_hooks",
			actions: ["saveStopReason", "addStoppedCallback"]
		}],
		PARENT_RECOVER_STEP: {
			actions: ["stepRecovered", "clearStepErrorEmitted"],
			target: "rendering",
			internal: !0
		},
		EXPERIENCE_DISMISSED: {
			target: "",
			actions: ["experienceDismissed", qt({
				type: xn,
				reason: Sn.DISMISSED
			})]
		},
		EXPERIENCE_SNOOZED: {
			target: "",
			actions: ["experienceSnoozed", qt({
				type: xn,
				reason: Sn.DISMISSED
			})]
		},
		STEP_SEEN: {
			target: "",
			actions: ["queueStepSeen", "blockEvent"],
			cond: "isEventEnabled"
		},
		STEP_INTERACTION: {
			target: "",
			actions: ["stepInteraction"]
		},
		EXTENDED_EVENT: {
			actions: ["stepExtendedEvent", "blockEvent"],
			cond: "isEventEnabled"
		},
		RELOAD: [
			{
				target: "reload",
				actions: ["updateTheme", "updateStepContext"],
				cond: "didThemeChange"
			},
			{
				target: "reloading_traits",
				actions: [
					"setVirtualizedContent",
					"updateStepContext",
					"saveChangedStepTraits",
					"saveChangedExperienceTraits"
				],
				cond: "shouldOnlyReloadTraits"
			},
			{
				target: "reload",
				actions: ["setVirtualizedContent", "updateStepContext"],
				cond: "shouldStepReload"
			},
			{
				target: "rendering",
				internal: !0,
				actions: [
					"setVirtualizedContent",
					"updateStepContext",
					"rebindActions"
				],
				cond: "didContentChanged"
			}
		],
		[xn]: { actions: [qt(xn)] },
		FORWARD_TO_PARENT: [{
			actions: [qt((e, { eventType: t, ...n }) => ({
				...n,
				type: t
			}))],
			internal: !0
		}],
		ACTIONS_STARTED: {
			target: "",
			actions: "setActionsRunning",
			internal: !0
		},
		ACTIONS_FINISHED: {
			target: "",
			actions: "setActionsFinished",
			internal: !0
		}
	},
	invoke: [
		{
			id: "hooksService",
			src: "hooksService"
		},
		{
			id: "actionsService",
			src: "actionsService"
		},
		{
			id: "themeRemovalService",
			src: "themeRemovalService"
		}
	],
	states: {
		waiting_to_render: { on: { START_STEP: "running_traits" } },
		reload: {
			entry: [
				"removeCustomContainer",
				"unmount",
				"resetRender",
				"clearOverrides",
				"runStepEndHooks"
			],
			exit: ["removeStepHooks"],
			on: { RUN_HOOKS_DONE: {
				target: "running_traits",
				cond: "isHooksDoneEventEndType"
			} }
		},
		reloading_traits: {
			initial: "running_end_hooks",
			exit: ["clearChangedStepTraits", "clearChangedExperienceTraits"],
			onDone: {
				target: "rendering",
				actions: "ensuresElementsAreAccessible"
			},
			on: { ERROR: {
				target: "error",
				internal: !0,
				actions: "stepError"
			} },
			states: {
				running_end_hooks: {
					entry: ["runStepEndHooks"],
					on: { RUN_HOOKS_DONE: {
						target: "running_pre_begin_hooks",
						cond: "isHooksDoneEventEndType"
					} }
				},
				running_pre_begin_hooks: {
					entry: ["runStepPreBeginHooks"],
					exit: ["rebindActions"],
					on: { RUN_HOOKS_DONE: {
						target: "running_begin_hooks",
						cond: "isHooksDoneEventPreBeginType"
					} }
				},
				running_begin_hooks: {
					entry: ["runStepBeginHooks"],
					on: { RUN_HOOKS_DONE: {
						target: "done",
						cond: "isHooksDoneEventBeginType"
					} }
				},
				done: { type: "final" }
			}
		},
		running_traits: {
			invoke: { src: "runStepTraits" },
			on: {
				RUN_TRAITS_DONE: {
					target: "pre_begin",
					actions: "rebindActions"
				},
				RUN_TRAITS_ERROR: "destroyed"
			}
		},
		pre_begin: {
			entry: ["runStepPreBeginHooks"],
			on: {
				ERROR: {
					target: "error",
					internal: !0,
					actions: "reportStepErrorOnce"
				},
				RUN_HOOKS_DONE: {
					target: "begin",
					cond: "isHooksDoneEventPreBeginType"
				}
			}
		},
		begin: {
			entry: ["runStepBeginHooks"],
			on: {
				ERROR: {
					target: "error",
					internal: !0,
					actions: "reportStepErrorOnce"
				},
				RUN_HOOKS_DONE: {
					target: "rendering",
					actions: "ensuresElementsAreAccessible",
					cond: "isHooksDoneEventBeginType"
				}
			}
		},
		rendering: {
			initial: "pre-render",
			on: { STEP_CONTAINER_REMOVED: {
				target: "error",
				internal: !1
			} },
			states: {
				"pre-render": {
					entry: ["runStepPreRenderHooks"],
					on: { RUN_HOOKS_DONE: [{
						target: "render",
						actions: ["applyOverrides"],
						cond: "isHooksDoneEventPreRenderType"
					}] }
				},
				render: { invoke: {
					src: "render",
					onDone: [{
						target: "post-render",
						cond: "hasCustomContainer",
						actions: "startThemeRemovalListener"
					}, { target: "post-render" }]
				} },
				"post-render": {
					invoke: {
						id: "postRenderAsyncEventsHandler",
						src: wo
					},
					entry: ["runStepPostRenderHooks"],
					on: {
						FORCE_ERROR: "#error",
						RERENDER: "pre-render",
						UPDATE_STEP: {
							target: "",
							actions: [Jt("postRenderAsyncEventsHandler")]
						},
						ERROR: {
							target: "",
							actions: [
								Jt("postRenderAsyncEventsHandler"),
								"reportStepErrorOnce",
								"markErrorReported"
							]
						},
						RUN_HOOKS_DONE: {
							target: "",
							cond: "isHooksDoneEventPostRenderType",
							actions: [
								"notifyExperienceStarted",
								"commitPendingStepSeen",
								Jt("postRenderAsyncEventsHandler")
							]
						}
					}
				}
			}
		},
		running_end_hooks: {
			entry: ["runStepEndHooks"],
			on: {
				RUN_HOOKS_DONE: [{
					cond: "shouldFireStepCompletedEvent",
					target: "calling_stopped_callbacks",
					actions: [
						"removeCustomContainer",
						"unmount",
						"stepCompleted",
						"removeStepHooks"
					]
				}, {
					cond: "isHooksDoneEventEndType",
					target: "calling_stopped_callbacks",
					actions: [
						"removeCustomContainer",
						"unmount",
						"removeStepHooks"
					]
				}],
				RUN_HOOKS_ERROR: {
					target: "destroyed",
					actions: ["callStoppedCallbacks"]
				}
			}
		},
		calling_stopped_callbacks: {
			entry: ["callStoppedCallbacks", "deferTransitionToEnd"],
			on: { [Vn]: "end" }
		},
		end: {
			type: "final",
			entry: ["notifyStepStopped"]
		},
		error: {
			id: "error",
			invoke: [{
				id: "errorAsyncEventsHandler",
				src: To
			}],
			entry: [
				"unmount",
				"runStepErrorHooks",
				"stopThemeRemovalListener"
			],
			on: {
				RUN_HOOKS_DONE: {
					target: "",
					cond: "isHooksDoneEventErrorType",
					actions: [Jt("errorAsyncEventsHandler"), "autoRecover"]
				},
				RECOVER_STEP: {
					target: "",
					actions: [Jt("errorAsyncEventsHandler")]
				},
				FORCE_RECOVER: {
					target: "pre_begin",
					actions: [
						"resetRender",
						"stepRecovered",
						"clearStepErrorEmitted"
					]
				},
				AUTO_RECOVER_STEP: {
					target: "pre_begin",
					actions: ["resetRender", "clearStepErrorEmitted"],
					cond: "isAutoRecoverEvent"
				}
			}
		},
		destroyed: { entry: ["reportStepErrorOnce", "unmount"] },
		waitingPendingActions: { on: { ACTIONS_FINISHED: {
			target: "running_end_hooks",
			actions: "setActionsFinished"
		} } }
	}
}, Do = (e, { createStepHooks: t, createHooksService: n, experience: r, get: i, experienceInstanceId: a }) => {
	let { virtualizeContent: o, createVnodeTree: s, wrapContent: c, applyOverridesToVnode: l } = i("vNodeHandlers"), { makeElementsAccessible: u } = i("accessibilityHandlers"), { applyOverrides: d, createOverrideCallback: f, clearOverrides: p } = Di({ applyOverridesToVnode: l }), m = f("style"), h = i("getWindowReference"), { onRender: g, onRenderReset: _ } = i("createRenderListener")(), { render: v, unmount: y, setContainer: b, resetRender: x, getContainer: S, hasCustomContainer: C, getRoot: w } = go({
		experience: r,
		onRender: g,
		onRenderReset: _,
		wrapContent: c,
		getWindowReference: h
	}), { addHook: T, runStepPreBeginHooks: E, runStepBeginHooks: D, runStepPreRenderHooks: O, runStepPostRenderHooks: k, runStepEndHooks: A, runStepErrorHooks: j, removeStepHooks: M, runStepContainerChangeHooks: N } = t({
		step: e,
		overrideStyle: m
	}), P = Ei({ addHook: T }), ee = Ti({
		overrideStyle: m,
		getContainer: S,
		getRoot: w
	}, i), F = n({
		overrideStyle: m,
		getContainer: S,
		getRoot: w
	}, i), I = Nr({
		getRoot: w,
		getWindowReference: h
	}), L = ii(i), R = Co(i), z = (e) => e.contentType === "text/html" ? o(vo(_o(e.content))) : s(e.content);
	return Gt({
		...Eo,
		context: {
			id: `step-machine-${e.id}`,
			step: {
				...e,
				activeNodeIndex: 0,
				virtualizedContent: z(e)
			},
			experience: r,
			blockedEvents: {},
			pendingStepSeen: !1,
			errorReported: !1,
			stepErrorEmitted: !1,
			actionsRunning: !1,
			experienceInstanceId: a,
			stopReason: null,
			stoppedCallbacks: [],
			changedStepTraits: null,
			changedExperienceTraits: null
		}
	}, {
		actions: {
			setContent: Qr,
			updateRootStyle: ri,
			unmount: y,
			setContainer: b,
			updateTheme: L,
			resetRender: x,
			runStepPreBeginHooks: E,
			runStepBeginHooks: D,
			runStepPreRenderHooks: O,
			runStepPostRenderHooks: k,
			runStepEndHooks: A,
			runStepErrorHooks: j,
			runStepContainerChangeHooks: N,
			updateStepContext: ei,
			rebindActions: Kt((e) => ({
				type: lr,
				step: e.step,
				experience: e.experience
			}), { to: "actionsService" }),
			removeStepHooks: () => M(),
			clearOverrides: () => p(),
			setVirtualizedContent: $r(z),
			applyOverrides: d,
			startThemeRemovalListener: Pr,
			stopThemeRemovalListener: Fr,
			removeCustomContainer: jr({ getRoot: w }),
			ensuresElementsAreAccessible: ai(u),
			notifyExperienceStarted: ti,
			notifyStepStopped: ni,
			...R.stepActions,
			blockEvent: R.helpers.blockEvent,
			queueStepSeen: X({ pendingStepSeen: !0 }),
			markErrorReported: X({ errorReported: !0 }),
			markStepErrorEmitted: X({ stepErrorEmitted: !0 }),
			clearStepErrorEmitted: X({ stepErrorEmitted: !1 }),
			reportStepErrorOnce: Ye([{
				cond: (e) => !e.stepErrorEmitted,
				actions: ["stepError", "markStepErrorEmitted"]
			}]),
			commitPendingStepSeen: X((e) => (e.pendingStepSeen && !e.errorReported && R.stepActions.stepSeen(e), { pendingStepSeen: !1 })),
			autoRecover: oi,
			setActionsRunning: si,
			setActionsFinished: ci,
			saveStopReason: X({ stopReason: (e, t) => t.reason }),
			addStoppedCallback: X({ stoppedCallbacks: (e, t) => t.onStopped ? [...e.stoppedCallbacks, t.onStopped] : e.stoppedCallbacks }),
			callStoppedCallbacks: (e) => e.stoppedCallbacks.forEach((e) => {
				try {
					e();
				} catch {}
			}),
			deferTransitionToEnd: Kt({ type: Vn }, { delay: 0 }),
			saveChangedStepTraits: X({ changedStepTraits: (e, t) => t.changedStepTraits ?? null }),
			clearChangedStepTraits: X({ changedStepTraits: () => null }),
			saveChangedExperienceTraits: X({ changedExperienceTraits: (e, t) => t.changedExperienceTraits ?? null }),
			clearChangedExperienceTraits: X({ changedExperienceTraits: () => null })
		},
		services: {
			runStepTraits: P,
			render: v,
			hooksService: F,
			actionsService: ee,
			themeRemovalService: I
		},
		guards: {
			hasCustomContainer: C,
			isAutoRecoverEvent: (e, t) => t.isAutoRecoverEvent,
			isEventEnabled: R.helpers.isEventEnabled,
			didContentChanged: (e, t) => !(0, vn.default)(e.step.content, t.stepConfig.content),
			shouldOnlyReloadTraits: li,
			shouldStepReload: (e, t) => !(0, vn.default)(e.step.traits, t.stepConfig.traits) || !(0, vn.default)(e.step.actions, t.stepConfig.actions) || !(0, vn.default)(e.experience.traits, t.experience.traits),
			didThemeChange: (e, t) => e.experience.theme !== t.experience.theme,
			isHooksDoneEventPostRenderType: (e, t) => t.hookType === Yn,
			isHooksDoneEventPreRenderType: (e, t) => t.hookType === Jn,
			isHooksDoneEventPreBeginType: (e, t) => t.hookType === Kn,
			isHooksDoneEventBeginType: (e, t) => t.hookType === qn,
			isHooksDoneEventErrorType: (e, t) => t.hookType === Zn,
			isHooksDoneEventEndType: (e, t) => t.hookType === Xn,
			hasPendingActions: (e) => e.actionsRunning,
			shouldFireStepCompletedEvent: (e, t) => t.hookType === "step.end" && e.blockedEvents.STEP_SEEN && e.stopReason !== Sn.NAVIGATION && e.stopReason !== Sn.DISMISSED && e.stopReason !== Sn.ERROR
		}
	});
}, Oo = ({ createStepHooks: e, createHooksService: t, get: n }) => X({ stepMachines: ({ experience: r, experienceInstanceId: i }) => {
	let a = {
		experience: r,
		experienceInstanceId: i,
		createStepHooks: e,
		createHooksService: t,
		get: n
	};
	return r.steps.reduce((e, t) => (e[`${t.id}`] = Pt(Do(t, a), `step-machine - ${t.id}`), e), {});
} }), ko = ({ createStepHooks: e, createHooksService: t, get: n }) => X({ stepMachines: ({ experience: r, stepMachines: i }, a) => {
	let o = {
		experience: r,
		createStepHooks: e,
		createHooksService: t,
		get: n
	}, s = r.steps.find((e) => e.id === a.id);
	return s ? {
		...i,
		[`${a.id}`]: Pt(Do(s, o), `step-machine - ${a.id}`)
	} : i;
} }), Ao = (e) => (t, { id: n, ...r }) => {
	t.stepMachines[n]?.send({
		...r,
		type: e
	});
}, jo = Ao(wn), Mo = (e, t) => {
	let n = e.stepMachines[t.id];
	n && (n.state.done && t.onStopped ? t.onStopped() : n.send({
		...t,
		type: Tn
	}));
}, No = Ao(En), Po = Ao(Dn), Fo = Ao(jn), Io = Ao(On), Lo = (e, t) => {
	Object.values(e.stepMachines).forEach((e) => {
		e.send({
			type: Tn,
			reason: t.reason
		});
	});
}, Ro = (e = [], t = []) => {
	let n = new Map(e.map((e) => [e.id, e])), r = new Map(t.map((e) => [e.id, e]));
	return {
		addedTraits: t.filter((e) => {
			let t = n.get(e.id);
			return !t || t.type !== e.type;
		}),
		removedTraits: e.filter((e) => {
			let t = r.get(e.id);
			return !t || t.type !== e.type;
		}),
		changedTraits: t.filter((e) => {
			let t = n.get(e.id);
			return !t || t.type !== e.type ? !1 : !(0, vn.default)(t.config || {}, e.config || {});
		})
	};
}, zo = X((e, t) => {
	let n = Ro(e.experience.traits, t.experience.traits);
	return Object.entries(e.stepMachines).forEach(([r, i]) => {
		let a = e.experience.steps.find((e) => e.id === r), o = t.experience.steps.find((e) => e.id === r);
		if (!a || !o) return;
		let s = Ro(a.traits, o.traits);
		i.send({
			type: In,
			stepConfig: o,
			experience: t.experience,
			changedExperienceTraits: n,
			changedStepTraits: s
		});
	}), { experience: t.experience };
}), Bo = (e) => {
	Object.values(e.stepMachines).forEach((e) => {
		e.send({ type: ir });
	});
}, Vo = X({ experienceInstanceId: () => gn() }), Ho = X({ stepMachines: (e, t) => Object.entries(e.stepMachines).reduce((e, [n, r]) => (n !== t.id && (e[n] = r), e), {}) }), Uo = X({ experience: ({ experience: e }, t) => {
	let n = e.steps.findIndex((e) => e.id === t.id);
	return n === -1 ? e : dn(e, `steps.${n}.traits`, (e) => e.filter(({ once: e = !1 }) => !e));
} }), Wo = ({ addHook: e }) => ({ experience: t }) => (n) => {
	try {
		t.traits.forEach((n) => pi({
			getTrait: mi,
			trait: n,
			addHook: (t, r) => {
				e(t, {
					callback: r,
					traitId: n.id
				});
			},
			registerAction: (e, r) => Si(`${t.id}.${n.type}.${e}`, r)
		})), n(lr);
	} catch {
		n(ur);
	}
}, Go = (e, t) => (n, { callback: r, traitId: i }) => {
	let a = e();
	a.get(n) || a.set(n, []), t(n, [...a.get(n), {
		callback: r,
		traitId: i
	}]);
}, Ko = (e, t) => Kt((n, r) => {
	let i = t, a = r.changedExperienceTraits ?? n.changedExperienceTraits;
	a && (i = {
		...i,
		onlyExperienceTraits: a.changedTraits.filter((e) => e.id != null).map(({ id: e }) => e)
	});
	let o = r.changedStepTraits ?? n.changedStepTraits;
	return o && (i = {
		...i,
		onlyStepTraits: o.changedTraits.filter((e) => e.id != null).map(({ id: e }) => e)
	}), {
		type: $n,
		hookType: e,
		experience: n.experience,
		step: n.step,
		...i
	};
}, { to: "hooksService" }), qo = Ko(Wn), Jo = Ko(Gn), Yo = Ko(Kn), Xo = Ko(qn), Zo = Ko(Jn), Qo = Ko(Yn), $o = Ko(Xn), es = qe((e, t) => Ko(Zn, { errorEvent: t })), ts = Ko(Qn), ns = () => {
	let e = /* @__PURE__ */ new Map(), t = /* @__PURE__ */ new Map();
	return {
		addHook: Go(() => e, (t, n) => e.set(t, n)),
		createStepHooks: ({ step: e }) => (t.get(e.id) || t.set(e.id, /* @__PURE__ */ new Map()), {
			addHook: Go(() => t.get(e.id), (n, r) => t.get(e.id).set(n, r)),
			removeStepHooks: () => t.set(e.id, /* @__PURE__ */ new Map()),
			runStepPreBeginHooks: Yo,
			runStepBeginHooks: Xo,
			runStepPreRenderHooks: Zo,
			runStepPostRenderHooks: Qo,
			runStepEndHooks: $o,
			runStepErrorHooks: es,
			runStepContainerChangeHooks: ts
		}),
		createHooksService: (n = {}, r) => () => (i, a) => {
			a(async ({ type: a, hookType: o, experience: s, step: c, ...l }) => {
				if (a !== "RUN_HOOKS") return;
				let u = {
					experience: s,
					step: c,
					callback: i,
					get: r,
					getContainer: n.getContainer
				};
				[
					"step.prebegin",
					"step.begin",
					"step.container_change",
					"step.end"
				].includes(o) && (u = {
					...u,
					...n
				});
				let d = ({ callback: e, trait: t }) => ({
					callback: e,
					context: {
						..._i({
							...u,
							getAction: xi,
							handleNavigation: r("handleNavigation")
						}),
						getTraitConfig: () => t.config
					}
				}), f = (e.get(o) ?? []).filter(({ traitId: e }) => !l.onlyExperienceTraits || l.onlyExperienceTraits && l.onlyExperienceTraits.includes(e)).map((e) => d({
					...e,
					trait: (s.traits ?? []).find((t) => t.id === e.traitId)
				}));
				try {
					await ho(f), c && await ho((t.get(c.id)?.get(o) ?? []).filter(({ traitId: e }) => !l.onlyStepTraits || l.onlyStepTraits && l.onlyStepTraits.includes(e)).map((e) => d({
						...e,
						trait: (c.traits ?? []).find((t) => t.id === e.traitId)
					}))), i({
						type: er,
						hookType: o,
						...l
					});
				} catch {
					i("RUN_HOOKS_ERROR");
				}
			});
		},
		runExperienceBeginHooks: qo,
		runExperienceEndHooks: Jo
	};
}, rs = {
	id: "experience",
	initial: "idle",
	invoke: [{
		src: "hooksService",
		id: "hooksService"
	}, {
		id: "themeRemovalService",
		src: "globalThemeRemovalService"
	}],
	on: {
		RUN_HOOKS_ERROR: "destroyed",
		EXPERIENCE_STARTED: {
			target: "",
			actions: ["experienceStarted", "blockEvent"],
			cond: "isEventEnabled"
		},
		SHOW: "running-traits"
	},
	states: {
		idle: { on: { SHOW: [{
			target: "running-traits",
			actions: ["updateExperienceInstanceId"]
		}, { target: "destroyed" }] } },
		"running-traits": {
			invoke: { src: "runGlobalExperienceTraits" },
			on: {
				RUN_TRAITS_ERROR: "destroyed",
				RUN_TRAITS_DONE: "rendering-steps"
			}
		},
		"rendering-steps": {
			on: {
				STOP_EXPERIENCE: [{
					target: "end",
					actions: ["experienceCompleted", "stopSteps"],
					cond: "shouldFireCompletedEvent"
				}, {
					target: "end",
					actions: ["stopSteps"]
				}],
				START_STEP: [{
					target: "",
					cond: "doesStepInstanceExist",
					actions: "startStep"
				}, {
					target: "",
					actions: ["startStepMachine", "startStep"]
				}],
				STOP_STEP: {
					target: "",
					actions: "stopStep"
				},
				UPDATE_STEP: {
					target: "",
					actions: "updateStep"
				},
				SET_STEP_CONTAINER_TARGET: {
					target: "",
					actions: "setStepContainerTarget"
				},
				RECOVER_STEP: {
					target: "",
					actions: "recoverStep"
				},
				GLOBAL_CONTAINER_REMOVED: {
					target: "",
					actions: [
						"createGlobalThemeComponent",
						"startThemeRemovalListener",
						"notifyStepsContainerRemoved"
					]
				},
				UPDATE_STEP_CONTENT: {
					target: "",
					actions: "updateStepContent"
				},
				SHOW: {
					target: "",
					actions: ["reloadSteps"]
				},
				STEP_STOPPED: [
					{
						target: "end-final",
						cond: "areAllStepsStoppedFromError",
						actions: ["removeGlobalThemeComponent", "runExperienceEndHooks"]
					},
					{
						target: "end-final",
						cond: "areAllStepsStopped",
						actions: [
							"experienceCompleted",
							"removeGlobalThemeComponent",
							"runExperienceEndHooks"
						]
					},
					{
						target: "",
						actions: ["cleanStepMachines", "cleanRunOnceTraits"]
					}
				]
			},
			entry: [
				"createGlobalThemeComponent",
				"startStepMachines",
				"runExperienceBeginHooks",
				"startThemeRemovalListener"
			]
		},
		end: {
			entry: ["removeGlobalThemeComponent", "runExperienceEndHooks"],
			on: { [Ln]: {
				target: "end-final",
				cond: "areAllStepsStopped"
			} }
		},
		"end-final": { final: !0 },
		destroyed: {
			entry: "experienceError",
			type: "final"
		}
	}
}, is = (e, t) => {
	let { addHook: n, createStepHooks: r, createHooksService: i, runExperienceBeginHooks: a, runExperienceEndHooks: o } = ns(), s = i({}, t), c = Oo({
		createStepHooks: r,
		createHooksService: i,
		get: t
	}), l = ko({
		createStepHooks: r,
		createHooksService: i,
		get: t
	}), u = Wo({ addHook: n }), d = Co(t), f = Or(t), p = kr(t), m = Mr(t);
	return Gt({
		...rs,
		context: {
			experience: e,
			blockedEvents: {},
			experienceInstanceId: null
		}
	}, {
		actions: {
			startStep: jo,
			stopStep: Mo,
			updateStep: No,
			setStepContainerTarget: Po,
			recoverStep: Fo,
			startStepMachines: c,
			stopSteps: Lo,
			notifyStepsContainerRemoved: Bo,
			updateStepContent: Io,
			reloadSteps: zo,
			updateExperienceInstanceId: Vo,
			cleanStepMachines: Ho,
			startStepMachine: l,
			runExperienceBeginHooks: a,
			runExperienceEndHooks: o,
			createGlobalThemeComponent: f,
			removeGlobalThemeComponent: p,
			startThemeRemovalListener: Pr,
			cleanRunOnceTraits: Uo,
			...d.experienceActions,
			blockEvent: d.helpers.blockEvent
		},
		services: {
			runGlobalExperienceTraits: u,
			hooksService: s,
			globalThemeRemovalService: m
		},
		guards: {
			isEventEnabled: d.helpers.isEventEnabled,
			areAllStepsStopped: (e) => Object.values(e.stepMachines).every((e) => e.state.done),
			areAllStepsStoppedFromError: (e, t) => t.reason === Sn.ERROR && Object.values(e.stepMachines).every((e) => e.state.done),
			doesStepInstanceExist: (e, t) => e.stepMachines?.[t.id] !== void 0,
			shouldFireCompletedEvent: (e, t) => t.reason !== Sn.NAVIGATION && t.reason !== Sn.DISMISSED
		}
	});
};
//#endregion
//#region src/core/lib/patch.js
po();
var as = ra([
	Ia,
	Ya,
	ao,
	Ka,
	Na
], void 0, { experimental: { fragments: !0 } });
function os(e) {
	let t = (e.ownerDocument || document).createElement("div");
	return e.append(t), as(t, ca("div"));
}
var ss = () => {
	let e = null;
	return {
		onRender: (t, n) => {
			!e && !t || (e ||= os(t), e = as(e, n));
		},
		onRenderReset: () => {
			e = null;
		}
	};
}, cs = /* @__PURE__ */ s(((e, t) => {
	t.exports = {
		area: !0,
		base: !0,
		br: !0,
		col: !0,
		embed: !0,
		hr: !0,
		img: !0,
		input: !0,
		keygen: !0,
		link: !0,
		menuitem: !0,
		meta: !0,
		param: !0,
		source: !0,
		track: !0,
		wbr: !0
	};
})), ls = /* @__PURE__ */ s(((e, t) => {
	var n = /([\w-]+)|=|(['"])([.\s\S]*?)\2/g, r = cs();
	t.exports = function(e) {
		var t = 0, i, a = !0, o = {
			type: "tag",
			name: "",
			voidElement: !1,
			attrs: {},
			children: []
		};
		return e.replace(n, function(n) {
			if (n === "=") {
				a = !0, t++;
				return;
			}
			a ? t === 0 ? ((r[n] || e.charAt(e.length - 2) === "/") && (o.voidElement = !0), o.name = n) : (o.attrs[i] = n.replace(/^['"]|['"]$/g, ""), i = void 0) : (i && (o.attrs[i] = i), i = n), t++, a = !1;
		}), o;
	};
})), us = /* @__PURE__ */ s(((e, t) => {
	var n = /(?:<!--[\S\s]*?-->|<(?:"[^"]*"|'[^']*'|[^'">])+>)/g, r = ls(), i = Object.create ? Object.create(null) : {};
	function a(e, t, n, r, i) {
		var a = t.indexOf("<", r), o = t.slice(r, a === -1 ? void 0 : a);
		/^\s*$/.test(o) && (o = " "), (!i && a > -1 && n + e.length >= 0 || o !== " ") && e.push({
			type: "text",
			content: o
		});
	}
	t.exports = function(e, t) {
		t ||= {}, t.components ||= i;
		var o = [], s, c = -1, l = [], u = {}, d = !1;
		return e.replace(n, function(n, i) {
			if (d) {
				if (n !== "</" + s.name + ">") return;
				d = !1;
			}
			var f = n.charAt(1) !== "/", p = n.indexOf("<!--") === 0, m = i + n.length, h = e.charAt(m), g;
			f && !p && (c++, s = r(n), s.type === "tag" && t.components[s.name] && (s.type = "component", d = !0), !s.voidElement && !d && h && h !== "<" && a(s.children, e, c, m, t.ignoreWhitespace), u[s.tagName] = s, c === 0 && o.push(s), g = l[c - 1], g && g.children.push(s), l[c] = s), (p || !f || s.voidElement) && (p || c--, !d && h !== "<" && h && (g = c === -1 ? o : l[c].children, a(g, e, c, m, t.ignoreWhitespace)));
		}), !o.length && e.length && a(o, e, 0, 0, t.ignoreWhitespace), o;
	};
})), ds = /* @__PURE__ */ s(((e) => {
	Object.defineProperty(e, "__esModule", { value: !0 }), e.createTextVNode = n, e.transformName = r, e.unescapeEntities = o;
	var t = (po(), d(fo));
	function n(e, n) {
		return (0, t.vnode)(void 0, void 0, void 0, o(e, n));
	}
	function r(e) {
		return e = e.replace(/-(\w)/g, function(e, t) {
			return t.toUpperCase();
		}), "" + e.charAt(0).toLowerCase() + e.substring(1);
	}
	var i = /* @__PURE__ */ RegExp("&[a-z0-9#]+;", "gi"), a = null;
	function o(e, t) {
		return a ||= t.createElement("div"), e.replace(i, function(e) {
			return a.innerHTML = e, a.textContent;
		});
	}
})), fs = /* @__PURE__ */ s(((e) => {
	Object.defineProperty(e, "__esModule", { value: !0 }), e.default = function(e) {
		var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, r = n.context || document;
		if (!e) return null;
		var i = [], a = o((0, t.default)(e), i, r), c = void 0;
		return c = a ? a.length === 1 ? a[0] : a : s({
			type: "text",
			content: e
		}, i, r), n.hooks && n.hooks.create && i.forEach(function(e) {
			n.hooks.create(e);
		}), c;
	};
	var t = i(us()), n = (po(), d(fo)), r = ds();
	function i(e) {
		return e && e.__esModule ? e : { default: e };
	}
	function a(e, t, n) {
		return t in e ? Object.defineProperty(e, t, {
			value: n,
			enumerable: !0,
			configurable: !0,
			writable: !0
		}) : e[t] = n, e;
	}
	function o(e, t, n) {
		if (e instanceof Array && e.length > 0) return e.map(function(e) {
			return s(e, t, n);
		});
	}
	function s(e, t, i) {
		var a = void 0;
		return a = e.type === "text" ? (0, r.createTextVNode)(e.content, i) : (0, n.h)(e.name, c(e, i), o(e.children, t, i)), t.push(a), a;
	}
	function c(e, t) {
		var n = {};
		if (!e.attrs) return n;
		var i = Object.keys(e.attrs).reduce(function(n, i) {
			if (i !== "style" && i !== "class") {
				var o = (0, r.unescapeEntities)(e.attrs[i], t);
				n ? n[i] = o : n = a({}, i, o);
			}
			return n;
		}, null);
		i && (n.attrs = i);
		var o = l(e);
		o && (n.style = o);
		var s = u(e);
		return s && (n.class = s), n;
	}
	function l(e) {
		try {
			return e.attrs.style.split(";").reduce(function(e, t) {
				var n = t.split(":"), i = (0, r.transformName)(n[0].trim());
				if (i) {
					var o = n[1].replace("!important", "").trim();
					e ? e[i] = o : e = a({}, i, o);
				}
				return e;
			}, null);
		} catch {
			return null;
		}
	}
	function u(e) {
		try {
			return e.attrs.class.split(" ").reduce(function(e, t) {
				return t = t.trim(), t && (e ? e[t] = !0 : e = a({}, t, !0)), e;
			}, null);
		} catch {
			return null;
		}
	}
})), ps = /* @__PURE__ */ s(((e, t) => {
	t.exports = fs();
})), ms = /* @__PURE__ */ c({
	applyOverridesToVnode: () => Ts,
	createStyleState: () => bs,
	createVnodeTree: () => ws,
	findId: () => xs,
	injectHandlers: () => Ds,
	mergeVnodeData: () => Ss,
	traverseTree: () => Cs,
	virtualizeContent: () => gs,
	wrapContent: () => Es
});
po();
var hs = /* @__PURE__ */ u(ps(), 1), gs = typeof hs.default == "function" ? hs.default : hs.default.default, _s = "data-interaction-style", vs = (e) => e.replace(/([A-Z])/g, (e) => `-${e[0].toLowerCase()}`), ys = (e) => e.replace(/&amp;/g, "&").replace(/&lt;/g, "<").replace(/&gt;/g, ">").replace(/&#39;/g, "'").replace(/&quot;/g, "\""), bs = ({ nodeId: e, interactionId: t, state: n }) => {
	let r = t ? `[${_s}="${t}"]` : `#${e}`;
	return Object.keys(n).map((e) => `${r}:${e} {
        ${Object.entries(n[e]).map(([e, t]) => {
		let n = ys(String(t));
		return `${vs(e)}:${n} !important`;
	}).join(";")}
      }`).join(" ");
}, xs = (e) => e.data && e.data.attrs ? e.data.attrs.id : void 0, Ss = (e, t) => Object.keys(t).reduce((e, n) => ({
	...e,
	[n]: {
		...e[n],
		...t[n]
	}
}), e.data || {}), Cs = (e, t) => {
	e && (t(e), e.children && e.children.forEach((e) => Cs(e, t)));
}, ws = (e) => {
	if (typeof e == "string") return ys(e);
	if (e == null) return la([]);
	let { is: t = "div", children: n = [], style: r, behaviors: i, ...a } = e.props, { state: o, ...s } = r ?? {}, c = e.props.id, l = e.props[_s], u = ca(t, {
		...Object.keys(s).length > 0 && { style: s },
		...Object.keys(a).length > 0 && { attrs: a }
	}, n.map(ws));
	return o ? la([ca("style", bs({
		nodeId: c,
		interactionId: l,
		state: o
	})), u]) : u;
}, Ts = (e, t) => {
	let n = t(xs(e)) ?? {};
	return {
		...e,
		data: Ss(e, n),
		children: e.children?.map((e) => Ts(e, t))
	};
}, Es = ({ step: e }) => {
	let t = vr(e.id), n = ca("div", {
		attrs: { [cr]: t },
		style: {
			width: "100%",
			display: "contents"
		}
	}, [e.virtualizedContent]);
	return { step: {
		...e,
		virtualizedContent: n
	} };
}, Ds = (e, t) => (e.data = {
	...e.data,
	on: t.on,
	hook: t.hook
}, e), Os = /* @__PURE__ */ c({ makeElementsAccessible: () => js }), ks = (e, t) => t.includes(e.data?.attrs?.id) && typeof e.data?.attrs?.tabindex != "string" && typeof e.data?.attrs?.tabIndex != "number", As = (e) => {
	e.data.attrs.tabindex = 0, e.sel = "button", e.data.style = {
		...e.data.style,
		border: e.data?.style?.border ?? "none",
		...e?.children?.length > 0 && { backgroundColor: e.data?.style?.backgroundColor ?? "transparent" }
	};
}, js = ({ virtualizedContent: e, index: t }, { interactiveEls: n = [], focusableEls: r = [] }) => (Cs(e, (e) => {
	ks(e, n) ? As(e) : ks(e, r) && (e.data.attrs = {
		...e.data.attrs,
		tabindex: 0,
		role: "dialog",
		"aria-labelledby": `content-${t}`,
		"aria-describedby": `content-${t}`
	}), e.data?.class?.canvas && (e.data.attrs = {
		...e.data.attrs,
		id: `content-${t}`
	});
}), e), Ms = "@appcues/close", Ns = { markComplete: !0 };
Si(Ms, ({ markComplete: e = Ns.markComplete } = Ns, { stopExperience: t, step: n }) => {
	e ? t() : n.dismissExperience();
});
//#endregion
//#region src/actions/redirectTo/redirect-to.js
var Ps = "@appcues/redirectTo";
function Fs(e, t) {
	if (/^https?:\/\//i.test(t)) return t;
	try {
		return new URL(t, e.location.origin).href;
	} catch {
		return t;
	}
}
Si(Ps, ({ url: e = "", openInNewWindow: t = !1 } = {}, { reportError: n, getWindowReference: r }) => {
	if (!e) {
		n("Can't redirect to undefined URL");
		return;
	}
	let i = r(), a = Fs(i, e);
	i.open(a, t ? "_blank" : "_self", "noopener");
}), Si("@appcues/trackEvent", ({ name: e, properties: t = {} }, { sendCustomEvent: n }) => {
	n(e, t);
}), Si("@appcues/triggerFlow", ({ flowId: e, url: t, prefetch: n = !1 } = {}, { showFlow: r }) => {
	r({
		flowId: e,
		url: t,
		prefetch: n
	});
});
//#endregion
//#region src/lib/objects.js
var Is = (e) => Object.keys(e).length === 0, Ls = (e) => {
	switch (e) {
		case "date.now": return Date.now();
		default: return null;
	}
}, Rs = (e) => typeof e == "string" && e.startsWith("{") && e.endsWith("}"), zs = (e) => Object.entries(e).reduce((e, [t, n]) => {
	if (Rs(n)) {
		let r = Ls(n.slice(1, -1));
		return {
			...e,
			[t]: r ?? n
		};
	}
	return {
		...e,
		[t]: n
	};
}, {});
Si("@appcues/setUserProperties", (e, { updateUserProfile: t }) => {
	Is(e) || t(zs(e));
}), Si("@appcues/toggleActions", ({ actions: e = [], target: t } = {}, n) => {
	let r = n.querySelector(t.selector);
	r.length !== 0 && e.forEach((e) => {
		let t = `toggleActions_${e.id}`, i = n.getAction(e.type), [a] = r, o = !a.getAttribute(t);
		i && o && (i(e.config, n), a.setAttribute(t, !0)), o || a.removeAttribute(t);
	});
});
//#endregion
//#region ../../node_modules/intl-locale-textinfo-polyfill/lib/Locale.js
var Bs = /([\.\*\+\^\$\[\]\\\(\)\|\{\}\,\-\:\?])/g, Vs = /^([a-zA-Z]{2,3}|[a-zA-Z]{5,8})(-[a-zA-Z]{4})?(-(?:[a-zA-Z]{2}|\d{3}))?(-(?:[a-zA-Z\d]{5,8}|\d[a-zA-Z\d]{3}))?$/, Hs = class e {
	constructor(e) {
		if (typeof e != "string") throw TypeError("A string argument is expected");
		if (!Vs.test(e)) throw RangeError("A proper locale must be provided");
		this._locale = e;
	}
	static _escapeRegExpPattern(e) {
		return typeof e == "string" ? e.replace(Bs, "\\$1") : e;
	}
	static _toLowerCase(e, t) {
		return typeof e == "string" ? e.toLowerCase() : t && e;
	}
	static _toUpperCase(e, t) {
		return typeof e == "string" ? e.toUpperCase() : t && e;
	}
	static _trim(e, t, n) {
		let r = [], i, a = function(e) {
			r.push("^" + e + "+|" + e + "+$");
		};
		if (typeof t == "boolean" && (n = t, t = null), typeof e != "string") return n ? e : void 0;
		Array.isArray(t) && t.map((e) => {
			a(this._escapeRegExpPattern(e));
		}), typeof t == "string" && a(this._escapeRegExpPattern(t)), t || a("\\s");
		let o = "(" + r.join("|") + ")";
		for (i = new RegExp(o, "g"); e.match(i);) e = e.replace(i, "");
		return e;
	}
	static _parseLocale(e) {
		if (typeof e != "string") return;
		let t = Vs.exec(e), n, r, i;
		if (!e || !t) return;
		let a = this._trim(t[2], ["-", "_"]), o = this._trim(t[3], ["-", "_"]);
		return n = this._toLowerCase(t[1]), r = this._toLowerCase(a) || r, i = this._toUpperCase(o) || i, {
			lang: n,
			script: r,
			countryCode: i
		};
	}
	_isRtlLang() {
		let { lang: t, script: n } = e._parseLocale(this._locale);
		return n ? e._RTL_SCRIPTS.indexOf(n) >= 0 : e._BIDI_RTL_LANGS.indexOf(t) >= 0;
	}
	get textInfo() {
		return { direction: this._isRtlLang() ? "rtl" : "ltr" };
	}
};
Hs._RTL_SCRIPTS = /* @__PURE__ */ "adlm.arab.armi.avst.chrs.cprt.elym.hatr.hebr.hung.khar.lydi.mand.mani.mend.merc.mero.narb.nbat.nkoo.orkh.ougr.palm.phli.phlp.phnx.prti.rohg.samr.sarb.sogd.sogo.syrc.thaa.yezi".split("."), Hs._BIDI_RTL_LANGS = /* @__PURE__ */ "ae.aeb.ajt.apc.apd.ar.ara.arb.arc.arq.ars.ary.arz.ave.avl.bal.bcc.bej.bft.bgn.bqi.brh.cja.ckb.cld.dcc.dgl.div.drw.dv.fa.fas.fia.fub.gbz.gjk.gju.glk.grc.gwc.gwt.haz.he.heb.hnd.hno.iw.ji.kas.kby.khw.ks.kvx.kxp.kzh.lad.lah.lki.lrc.luz.mde.mfa.mki.mvy.myz.mzn.nqo.oru.ota.otk.oui.pal.pbu.per.pes.phl.phn.pnb.pra.prd.prs.ps.pus.rhg.rmt.scl.sd.sdh.shu.skr.smp.snd.sog.swb.syr.tnf.trw.ug.uig.ur.urd.wni.xco.xld.xmn.xmr.xna.xpr.xsa.ydd.yi.yid.zdj".split(".");
//#endregion
//#region src/traits/contentDirection/content-direction.js
var Us = "@appcues/content-direction";
function Ws(e) {
	try {
		return new Hs(e).textInfo;
	} catch {
		return { direction: "ltr" };
	}
}
var Gs = ({ updateRootStyle: e, getTraitConfig: t }) => {
	let n = navigator.languages ? navigator.languages[0] : navigator.language || navigator.userLanguage, { currentLanguage: r = n, forceDirection: i = null } = t(), a = Ws(r);
	e({ direction: i ?? a.direction }, { forceUpdate: !0 });
};
Q(Us, ({ addHook: e }) => {
	e("step.begin", Gs), e("step.container_change", Gs);
});
//#endregion
//#region ../../node_modules/@floating-ui/utils/dist/floating-ui.utils.mjs
var Ks = [
	"top",
	"right",
	"bottom",
	"left"
], qs = ["start", "end"], Js = /* @__PURE__ */ Ks.reduce((e, t) => e.concat(t, t + "-" + qs[0], t + "-" + qs[1]), []), Ys = Math.min, Xs = Math.max, Zs = Math.round, Qs = (e) => ({
	x: e,
	y: e
}), $s = {
	left: "right",
	right: "left",
	bottom: "top",
	top: "bottom"
}, ec = {
	start: "end",
	end: "start"
};
function tc(e, t, n) {
	return Xs(e, Ys(t, n));
}
function nc(e, t) {
	return typeof e == "function" ? e(t) : e;
}
function rc(e) {
	return e.split("-")[0];
}
function ic(e) {
	return e.split("-")[1];
}
function ac(e) {
	return e === "x" ? "y" : "x";
}
function oc(e) {
	return e === "y" ? "height" : "width";
}
var sc = /* @__PURE__ */ new Set(["top", "bottom"]);
function cc(e) {
	return sc.has(rc(e)) ? "y" : "x";
}
function lc(e) {
	return ac(cc(e));
}
function uc(e, t, n) {
	n === void 0 && (n = !1);
	let r = ic(e), i = lc(e), a = oc(i), o = i === "x" ? r === (n ? "end" : "start") ? "right" : "left" : r === "start" ? "bottom" : "top";
	return t.reference[a] > t.floating[a] && (o = fc(o)), [o, fc(o)];
}
function dc(e) {
	return e.replace(/start|end/g, (e) => ec[e]);
}
function fc(e) {
	return e.replace(/left|right|bottom|top/g, (e) => $s[e]);
}
function pc(e) {
	return {
		top: 0,
		right: 0,
		bottom: 0,
		left: 0,
		...e
	};
}
function mc(e) {
	return typeof e == "number" ? {
		top: e,
		right: e,
		bottom: e,
		left: e
	} : pc(e);
}
function hc(e) {
	let { x: t, y: n, width: r, height: i } = e;
	return {
		width: r,
		height: i,
		top: n,
		left: t,
		right: t + r,
		bottom: n + i,
		x: t,
		y: n
	};
}
//#endregion
//#region node_modules/@floating-ui/core/dist/floating-ui.core.mjs
function gc(e, t, n) {
	let { reference: r, floating: i } = e, a = cc(t), o = lc(t), s = oc(o), c = rc(t), l = a === "y", u = r.x + r.width / 2 - i.width / 2, d = r.y + r.height / 2 - i.height / 2, f = r[s] / 2 - i[s] / 2, p;
	switch (c) {
		case "top":
			p = {
				x: u,
				y: r.y - i.height
			};
			break;
		case "bottom":
			p = {
				x: u,
				y: r.y + r.height
			};
			break;
		case "right":
			p = {
				x: r.x + r.width,
				y: d
			};
			break;
		case "left":
			p = {
				x: r.x - i.width,
				y: d
			};
			break;
		default: p = {
			x: r.x,
			y: r.y
		};
	}
	switch (ic(t)) {
		case "start":
			p[o] -= f * (n && l ? -1 : 1);
			break;
		case "end":
			p[o] += f * (n && l ? -1 : 1);
			break;
	}
	return p;
}
var _c = async (e, t, n) => {
	let { placement: r = "bottom", strategy: i = "absolute", middleware: a = [], platform: o } = n, s = a.filter(Boolean), c = await (o.isRTL == null ? void 0 : o.isRTL(t)), l = await o.getElementRects({
		reference: e,
		floating: t,
		strategy: i
	}), { x: u, y: d } = gc(l, r, c), f = r, p = {}, m = 0;
	for (let n = 0; n < s.length; n++) {
		let { name: a, fn: h } = s[n], { x: g, y: _, data: v, reset: y } = await h({
			x: u,
			y: d,
			initialPlacement: r,
			placement: f,
			strategy: i,
			middlewareData: p,
			rects: l,
			platform: o,
			elements: {
				reference: e,
				floating: t
			}
		});
		u = g ?? u, d = _ ?? d, p = {
			...p,
			[a]: {
				...p[a],
				...v
			}
		}, y && m <= 50 && (m++, typeof y == "object" && (y.placement && (f = y.placement), y.rects && (l = y.rects === !0 ? await o.getElementRects({
			reference: e,
			floating: t,
			strategy: i
		}) : y.rects), {x: u, y: d} = gc(l, f, c)), n = -1);
	}
	return {
		x: u,
		y: d,
		placement: f,
		strategy: i,
		middlewareData: p
	};
};
async function vc(e, t) {
	t === void 0 && (t = {});
	let { x: n, y: r, platform: i, rects: a, elements: o, strategy: s } = e, { boundary: c = "clippingAncestors", rootBoundary: l = "viewport", elementContext: u = "floating", altBoundary: d = !1, padding: f = 0 } = nc(t, e), p = mc(f), m = o[d ? u === "floating" ? "reference" : "floating" : u], h = hc(await i.getClippingRect({
		element: await (i.isElement == null ? void 0 : i.isElement(m)) ?? !0 ? m : m.contextElement || await (i.getDocumentElement == null ? void 0 : i.getDocumentElement(o.floating)),
		boundary: c,
		rootBoundary: l,
		strategy: s
	})), g = u === "floating" ? {
		x: n,
		y: r,
		width: a.floating.width,
		height: a.floating.height
	} : a.reference, _ = await (i.getOffsetParent == null ? void 0 : i.getOffsetParent(o.floating)), v = await (i.isElement == null ? void 0 : i.isElement(_)) && await (i.getScale == null ? void 0 : i.getScale(_)) || {
		x: 1,
		y: 1
	}, y = hc(i.convertOffsetParentRelativeRectToViewportRelativeRect ? await i.convertOffsetParentRelativeRectToViewportRelativeRect({
		elements: o,
		rect: g,
		offsetParent: _,
		strategy: s
	}) : g);
	return {
		top: (h.top - y.top + p.top) / v.y,
		bottom: (y.bottom - h.bottom + p.bottom) / v.y,
		left: (h.left - y.left + p.left) / v.x,
		right: (y.right - h.right + p.right) / v.x
	};
}
var yc = (e) => ({
	name: "arrow",
	options: e,
	async fn(t) {
		let { x: n, y: r, placement: i, rects: a, platform: o, elements: s, middlewareData: c } = t, { element: l, padding: u = 0 } = nc(e, t) || {};
		if (l == null) return {};
		let d = mc(u), f = {
			x: n,
			y: r
		}, p = lc(i), m = oc(p), h = await o.getDimensions(l), g = p === "y", _ = g ? "top" : "left", v = g ? "bottom" : "right", y = g ? "clientHeight" : "clientWidth", b = a.reference[m] + a.reference[p] - f[p] - a.floating[m], x = f[p] - a.reference[p], S = await (o.getOffsetParent == null ? void 0 : o.getOffsetParent(l)), C = S ? S[y] : 0;
		(!C || !await (o.isElement == null ? void 0 : o.isElement(S))) && (C = s.floating[y] || a.floating[m]);
		let w = b / 2 - x / 2, T = C / 2 - h[m] / 2 - 1, E = Ys(d[_], T), D = Ys(d[v], T), O = E, k = C - h[m] - D, A = C / 2 - h[m] / 2 + w, j = tc(O, A, k), M = !c.arrow && ic(i) != null && A !== j && a.reference[m] / 2 - (A < O ? E : D) - h[m] / 2 < 0, N = M ? A < O ? A - O : A - k : 0;
		return {
			[p]: f[p] + N,
			data: {
				[p]: j,
				centerOffset: A - j - N,
				...M && { alignmentOffset: N }
			},
			reset: M
		};
	}
});
function bc(e, t, n) {
	return (e ? [...n.filter((t) => ic(t) === e), ...n.filter((t) => ic(t) !== e)] : n.filter((e) => rc(e) === e)).filter((n) => e ? ic(n) === e || (t ? dc(n) !== n : !1) : !0);
}
var xc = function(e) {
	return e === void 0 && (e = {}), {
		name: "autoPlacement",
		options: e,
		async fn(t) {
			let { rects: n, middlewareData: r, placement: i, platform: a, elements: o } = t, { crossAxis: s = !1, alignment: c, allowedPlacements: l = Js, autoAlignment: u = !0, ...d } = nc(e, t), f = c !== void 0 || l === Js ? bc(c || null, u, l) : l, p = await vc(t, d), m = r.autoPlacement?.index || 0, h = f[m];
			if (h == null) return {};
			let g = uc(h, n, await (a.isRTL == null ? void 0 : a.isRTL(o.floating)));
			if (i !== h) return { reset: { placement: f[0] } };
			let _ = [
				p[rc(h)],
				p[g[0]],
				p[g[1]]
			], v = [...r.autoPlacement?.overflows || [], {
				placement: h,
				overflows: _
			}], y = f[m + 1];
			if (y) return {
				data: {
					index: m + 1,
					overflows: v
				},
				reset: { placement: y }
			};
			let b = v.map((e) => {
				let t = ic(e.placement);
				return [
					e.placement,
					t && s ? e.overflows.slice(0, 2).reduce((e, t) => e + t, 0) : e.overflows[0],
					e.overflows
				];
			}).sort((e, t) => e[1] - t[1]), x = b.filter((e) => e[2].slice(0, ic(e[0]) ? 2 : 3).every((e) => e <= 0))[0]?.[0] || b[0][0];
			return x === i ? {} : {
				data: {
					index: m + 1,
					overflows: v
				},
				reset: { placement: x }
			};
		}
	};
};
function Sc(e, t) {
	return {
		top: e.top - t.height,
		right: e.right - t.width,
		bottom: e.bottom - t.height,
		left: e.left - t.width
	};
}
function Cc(e) {
	return Ks.some((t) => e[t] >= 0);
}
var wc = function(e) {
	return e === void 0 && (e = {}), {
		name: "hide",
		options: e,
		async fn(t) {
			let { rects: n } = t, { strategy: r = "referenceHidden", ...i } = nc(e, t);
			switch (r) {
				case "referenceHidden": {
					let e = Sc(await vc(t, {
						...i,
						elementContext: "reference"
					}), n.reference);
					return { data: {
						referenceHiddenOffsets: e,
						referenceHidden: Cc(e)
					} };
				}
				case "escaped": {
					let e = Sc(await vc(t, {
						...i,
						altBoundary: !0
					}), n.floating);
					return { data: {
						escapedOffsets: e,
						escaped: Cc(e)
					} };
				}
				default: return {};
			}
		}
	};
}, Tc = /* @__PURE__ */ new Set(["left", "top"]);
async function Ec(e, t) {
	let { placement: n, platform: r, elements: i } = e, a = await (r.isRTL == null ? void 0 : r.isRTL(i.floating)), o = rc(n), s = ic(n), c = cc(n) === "y", l = Tc.has(o) ? -1 : 1, u = a && c ? -1 : 1, d = nc(t, e), { mainAxis: f, crossAxis: p, alignmentAxis: m } = typeof d == "number" ? {
		mainAxis: d,
		crossAxis: 0,
		alignmentAxis: null
	} : {
		mainAxis: d.mainAxis || 0,
		crossAxis: d.crossAxis || 0,
		alignmentAxis: d.alignmentAxis
	};
	return s && typeof m == "number" && (p = s === "end" ? m * -1 : m), c ? {
		x: p * u,
		y: f * l
	} : {
		x: f * l,
		y: p * u
	};
}
var Dc = function(e) {
	return e === void 0 && (e = 0), {
		name: "offset",
		options: e,
		async fn(t) {
			var n;
			let { x: r, y: i, placement: a, middlewareData: o } = t, s = await Ec(t, e);
			return a === o.offset?.placement && (n = o.arrow) != null && n.alignmentOffset ? {} : {
				x: r + s.x,
				y: i + s.y,
				data: {
					...s,
					placement: a
				}
			};
		}
	};
}, Oc = function(e) {
	return e === void 0 && (e = {}), {
		name: "shift",
		options: e,
		async fn(t) {
			let { x: n, y: r, placement: i } = t, { mainAxis: a = !0, crossAxis: o = !1, limiter: s = { fn: (e) => {
				let { x: t, y: n } = e;
				return {
					x: t,
					y: n
				};
			} }, ...c } = nc(e, t), l = {
				x: n,
				y: r
			}, u = await vc(t, c), d = cc(rc(i)), f = ac(d), p = l[f], m = l[d];
			if (a) {
				let e = f === "y" ? "top" : "left", t = f === "y" ? "bottom" : "right", n = p + u[e], r = p - u[t];
				p = tc(n, p, r);
			}
			if (o) {
				let e = d === "y" ? "top" : "left", t = d === "y" ? "bottom" : "right", n = m + u[e], r = m - u[t];
				m = tc(n, m, r);
			}
			let h = s.fn({
				...t,
				[f]: p,
				[d]: m
			});
			return {
				...h,
				data: {
					x: h.x - n,
					y: h.y - r,
					enabled: {
						[f]: a,
						[d]: o
					}
				}
			};
		}
	};
};
//#endregion
//#region ../../node_modules/@floating-ui/utils/dist/floating-ui.utils.dom.mjs
function kc() {
	return typeof window < "u";
}
function Ac(e) {
	return Nc(e) ? (e.nodeName || "").toLowerCase() : "#document";
}
function jc(e) {
	var t;
	return (e == null || (t = e.ownerDocument) == null ? void 0 : t.defaultView) || window;
}
function Mc(e) {
	return ((Nc(e) ? e.ownerDocument : e.document) || window.document)?.documentElement;
}
function Nc(e) {
	return kc() ? e instanceof Node || e instanceof jc(e).Node : !1;
}
function Pc(e) {
	return kc() ? e instanceof Element || e instanceof jc(e).Element : !1;
}
function Fc(e) {
	return kc() ? e instanceof HTMLElement || e instanceof jc(e).HTMLElement : !1;
}
function Ic(e) {
	return !kc() || typeof ShadowRoot > "u" ? !1 : e instanceof ShadowRoot || e instanceof jc(e).ShadowRoot;
}
var Lc = /* @__PURE__ */ new Set(["inline", "contents"]);
function Rc(e) {
	let { overflow: t, overflowX: n, overflowY: r, display: i } = Zc(e);
	return /auto|scroll|overlay|hidden|clip/.test(t + r + n) && !Lc.has(i);
}
var zc = /* @__PURE__ */ new Set([
	"table",
	"td",
	"th"
]);
function Bc(e) {
	return zc.has(Ac(e));
}
var Vc = [":popover-open", ":modal"];
function Hc(e) {
	return Vc.some((t) => {
		try {
			return e.matches(t);
		} catch {
			return !1;
		}
	});
}
var Uc = [
	"transform",
	"translate",
	"scale",
	"rotate",
	"perspective"
], Wc = [
	"transform",
	"translate",
	"scale",
	"rotate",
	"perspective",
	"filter"
], Gc = [
	"paint",
	"layout",
	"strict",
	"content"
];
function Kc(e) {
	let t = Jc(), n = Pc(e) ? Zc(e) : e;
	return Uc.some((e) => n[e] ? n[e] !== "none" : !1) || (n.containerType ? n.containerType !== "normal" : !1) || !t && (n.backdropFilter ? n.backdropFilter !== "none" : !1) || !t && (n.filter ? n.filter !== "none" : !1) || Wc.some((e) => (n.willChange || "").includes(e)) || Gc.some((e) => (n.contain || "").includes(e));
}
function qc(e) {
	let t = $c(e);
	for (; Fc(t) && !Xc(t);) {
		if (Kc(t)) return t;
		if (Hc(t)) return null;
		t = $c(t);
	}
	return null;
}
function Jc() {
	return typeof CSS > "u" || !CSS.supports ? !1 : CSS.supports("-webkit-backdrop-filter", "none");
}
var Yc = /* @__PURE__ */ new Set([
	"html",
	"body",
	"#document"
]);
function Xc(e) {
	return Yc.has(Ac(e));
}
function Zc(e) {
	return jc(e).getComputedStyle(e);
}
function Qc(e) {
	return Pc(e) ? {
		scrollLeft: e.scrollLeft,
		scrollTop: e.scrollTop
	} : {
		scrollLeft: e.scrollX,
		scrollTop: e.scrollY
	};
}
function $c(e) {
	if (Ac(e) === "html") return e;
	let t = e.assignedSlot || e.parentNode || Ic(e) && e.host || Mc(e);
	return Ic(t) ? t.host : t;
}
function el(e) {
	let t = $c(e);
	return Xc(t) ? e.ownerDocument ? e.ownerDocument.body : e.body : Fc(t) && Rc(t) ? t : el(t);
}
function tl(e, t, n) {
	t === void 0 && (t = []), n === void 0 && (n = !0);
	let r = el(e), i = r === e.ownerDocument?.body, a = jc(r);
	if (i) {
		let e = nl(a);
		return t.concat(a, a.visualViewport || [], Rc(r) ? r : [], e && n ? tl(e) : []);
	}
	return t.concat(r, tl(r, [], n));
}
function nl(e) {
	return e.parent && Object.getPrototypeOf(e.parent) ? e.frameElement : null;
}
//#endregion
//#region node_modules/@floating-ui/dom/dist/floating-ui.dom.mjs
function rl(e) {
	let t = Zc(e), n = parseFloat(t.width) || 0, r = parseFloat(t.height) || 0, i = Fc(e), a = i ? e.offsetWidth : n, o = i ? e.offsetHeight : r, s = Zs(n) !== a || Zs(r) !== o;
	return s && (n = a, r = o), {
		width: n,
		height: r,
		$: s
	};
}
function il(e) {
	return Pc(e) ? e : e.contextElement;
}
function al(e) {
	let t = il(e);
	if (!Fc(t)) return Qs(1);
	let n = t.getBoundingClientRect(), { width: r, height: i, $: a } = rl(t), o = (a ? Zs(n.width) : n.width) / r, s = (a ? Zs(n.height) : n.height) / i;
	return (!o || !Number.isFinite(o)) && (o = 1), (!s || !Number.isFinite(s)) && (s = 1), {
		x: o,
		y: s
	};
}
var ol = /* @__PURE__ */ Qs(0);
function sl(e) {
	let t = jc(e);
	return !Jc() || !t.visualViewport ? ol : {
		x: t.visualViewport.offsetLeft,
		y: t.visualViewport.offsetTop
	};
}
function cl(e, t, n) {
	return t === void 0 && (t = !1), !n || t && n !== jc(e) ? !1 : t;
}
function ll(e, t, n, r) {
	t === void 0 && (t = !1), n === void 0 && (n = !1);
	let i = e.getBoundingClientRect(), a = il(e), o = Qs(1);
	t && (r ? Pc(r) && (o = al(r)) : o = al(e));
	let s = cl(a, n, r) ? sl(a) : Qs(0), c = (i.left + s.x) / o.x, l = (i.top + s.y) / o.y, u = i.width / o.x, d = i.height / o.y;
	if (a) {
		let e = jc(a), t = r && Pc(r) ? jc(r) : r, n = e, i = nl(n);
		for (; i && r && t !== n;) {
			let e = al(i), t = i.getBoundingClientRect(), r = Zc(i), a = t.left + (i.clientLeft + parseFloat(r.paddingLeft)) * e.x, o = t.top + (i.clientTop + parseFloat(r.paddingTop)) * e.y;
			c *= e.x, l *= e.y, u *= e.x, d *= e.y, c += a, l += o, n = jc(i), i = nl(n);
		}
	}
	return hc({
		width: u,
		height: d,
		x: c,
		y: l
	});
}
function ul(e, t) {
	let n = Qc(e).scrollLeft;
	return t ? t.left + n : ll(Mc(e)).left + n;
}
function dl(e, t) {
	let n = e.getBoundingClientRect();
	return {
		x: n.left + t.scrollLeft - ul(e, n),
		y: n.top + t.scrollTop
	};
}
function fl(e) {
	let { elements: t, rect: n, offsetParent: r, strategy: i } = e, a = i === "fixed", o = Mc(r), s = t ? Hc(t.floating) : !1;
	if (r === o || s && a) return n;
	let c = {
		scrollLeft: 0,
		scrollTop: 0
	}, l = Qs(1), u = Qs(0), d = Fc(r);
	if ((d || !d && !a) && ((Ac(r) !== "body" || Rc(o)) && (c = Qc(r)), Fc(r))) {
		let e = ll(r);
		l = al(r), u.x = e.x + r.clientLeft, u.y = e.y + r.clientTop;
	}
	let f = o && !d && !a ? dl(o, c) : Qs(0);
	return {
		width: n.width * l.x,
		height: n.height * l.y,
		x: n.x * l.x - c.scrollLeft * l.x + u.x + f.x,
		y: n.y * l.y - c.scrollTop * l.y + u.y + f.y
	};
}
function pl(e) {
	return Array.from(e.getClientRects());
}
function ml(e) {
	let t = Mc(e), n = Qc(e), r = e.ownerDocument.body, i = Xs(t.scrollWidth, t.clientWidth, r.scrollWidth, r.clientWidth), a = Xs(t.scrollHeight, t.clientHeight, r.scrollHeight, r.clientHeight), o = -n.scrollLeft + ul(e), s = -n.scrollTop;
	return Zc(r).direction === "rtl" && (o += Xs(t.clientWidth, r.clientWidth) - i), {
		width: i,
		height: a,
		x: o,
		y: s
	};
}
var hl = 25;
function gl(e, t) {
	let n = jc(e), r = Mc(e), i = n.visualViewport, a = r.clientWidth, o = r.clientHeight, s = 0, c = 0;
	if (i) {
		a = i.width, o = i.height;
		let e = Jc();
		(!e || e && t === "fixed") && (s = i.offsetLeft, c = i.offsetTop);
	}
	let l = ul(r);
	if (l <= 0) {
		let e = r.ownerDocument, t = e.body, n = getComputedStyle(t), i = e.compatMode === "CSS1Compat" && parseFloat(n.marginLeft) + parseFloat(n.marginRight) || 0, o = Math.abs(r.clientWidth - t.clientWidth - i);
		o <= hl && (a -= o);
	} else l <= hl && (a += l);
	return {
		width: a,
		height: o,
		x: s,
		y: c
	};
}
var _l = /* @__PURE__ */ new Set(["absolute", "fixed"]);
function vl(e, t) {
	let n = ll(e, !0, t === "fixed"), r = n.top + e.clientTop, i = n.left + e.clientLeft, a = Fc(e) ? al(e) : Qs(1);
	return {
		width: e.clientWidth * a.x,
		height: e.clientHeight * a.y,
		x: i * a.x,
		y: r * a.y
	};
}
function yl(e, t, n) {
	let r;
	if (t === "viewport") r = gl(e, n);
	else if (t === "document") r = ml(Mc(e));
	else if (Pc(t)) r = vl(t, n);
	else {
		let n = sl(e);
		r = {
			x: t.x - n.x,
			y: t.y - n.y,
			width: t.width,
			height: t.height
		};
	}
	return hc(r);
}
function bl(e, t) {
	let n = $c(e);
	return n === t || !Pc(n) || Xc(n) ? !1 : Zc(n).position === "fixed" || bl(n, t);
}
function xl(e, t) {
	let n = t.get(e);
	if (n) return n;
	let r = tl(e, [], !1).filter((e) => Pc(e) && Ac(e) !== "body"), i = null, a = Zc(e).position === "fixed", o = a ? $c(e) : e;
	for (; Pc(o) && !Xc(o);) {
		let t = Zc(o), n = Kc(o);
		!n && t.position === "fixed" && (i = null), (a ? !n && !i : !n && t.position === "static" && i && _l.has(i.position) || Rc(o) && !n && bl(e, o)) ? r = r.filter((e) => e !== o) : i = t, o = $c(o);
	}
	return t.set(e, r), r;
}
function Sl(e) {
	let { element: t, boundary: n, rootBoundary: r, strategy: i } = e, a = [...n === "clippingAncestors" ? Hc(t) ? [] : xl(t, this._c) : [].concat(n), r], o = a[0], s = a.reduce((e, n) => {
		let r = yl(t, n, i);
		return e.top = Xs(r.top, e.top), e.right = Ys(r.right, e.right), e.bottom = Ys(r.bottom, e.bottom), e.left = Xs(r.left, e.left), e;
	}, yl(t, o, i));
	return {
		width: s.right - s.left,
		height: s.bottom - s.top,
		x: s.left,
		y: s.top
	};
}
function Cl(e) {
	let { width: t, height: n } = rl(e);
	return {
		width: t,
		height: n
	};
}
function wl(e, t, n) {
	let r = Fc(t), i = Mc(t), a = n === "fixed", o = ll(e, !0, a, t), s = {
		scrollLeft: 0,
		scrollTop: 0
	}, c = Qs(0);
	function l() {
		c.x = ul(i);
	}
	if (r || !r && !a) if ((Ac(t) !== "body" || Rc(i)) && (s = Qc(t)), r) {
		let e = ll(t, !0, a, t);
		c.x = e.x + t.clientLeft, c.y = e.y + t.clientTop;
	} else i && l();
	a && !r && i && l();
	let u = i && !r && !a ? dl(i, s) : Qs(0);
	return {
		x: o.left + s.scrollLeft - c.x - u.x,
		y: o.top + s.scrollTop - c.y - u.y,
		width: o.width,
		height: o.height
	};
}
function Tl(e) {
	return Zc(e).position === "static";
}
function El(e, t) {
	if (!Fc(e) || Zc(e).position === "fixed") return null;
	if (t) return t(e);
	let n = e.offsetParent;
	return Mc(e) === n && (n = n.ownerDocument.body), n;
}
function Dl(e, t) {
	let n = jc(e);
	if (Hc(e)) return n;
	if (!Fc(e)) {
		let t = $c(e);
		for (; t && !Xc(t);) {
			if (Pc(t) && !Tl(t)) return t;
			t = $c(t);
		}
		return n;
	}
	let r = El(e, t);
	for (; r && Bc(r) && Tl(r);) r = El(r, t);
	return r && Xc(r) && Tl(r) && !Kc(r) ? n : r || qc(e) || n;
}
var Ol = async function(e) {
	let t = this.getOffsetParent || Dl, n = this.getDimensions, r = await n(e.floating);
	return {
		reference: wl(e.reference, await t(e.floating), e.strategy),
		floating: {
			x: 0,
			y: 0,
			width: r.width,
			height: r.height
		}
	};
};
function kl(e) {
	return Zc(e).direction === "rtl";
}
var Al = {
	convertOffsetParentRelativeRectToViewportRelativeRect: fl,
	getDocumentElement: Mc,
	getClippingRect: Sl,
	getOffsetParent: Dl,
	getElementRects: Ol,
	getClientRects: pl,
	getDimensions: Cl,
	getScale: al,
	isElement: Pc,
	isRTL: kl
}, jl = Dc, Ml = xc, Nl = Oc, Pl = wc, Fl = yc, Il = (e, t, n) => {
	let r = /* @__PURE__ */ new Map(), i = {
		platform: Al,
		...n
	}, a = {
		...i.platform,
		_c: r
	};
	return _c(e, t, {
		...i,
		platform: a
	});
}, Ll = /* @__PURE__ */ s(((e, t) => {
	var n = "Expected a function", r = NaN, i = "[object Symbol]", a = /^\s+|\s+$/g, o = /^[-+]0x[0-9a-f]+$/i, s = /^0b[01]+$/i, c = /^0o[0-7]+$/i, l = parseInt, u = typeof global == "object" && global && global.Object === Object && global, d = typeof self == "object" && self && self.Object === Object && self, f = u || d || Function("return this")(), p = Object.prototype.toString, m = Math.max, h = Math.min, g = function() {
		return f.Date.now();
	};
	function _(e, t, r) {
		var i, a, o, s, c, l, u = 0, d = !1, f = !1, p = !0;
		if (typeof e != "function") throw TypeError(n);
		t = x(t) || 0, v(r) && (d = !!r.leading, f = "maxWait" in r, o = f ? m(x(r.maxWait) || 0, t) : o, p = "trailing" in r ? !!r.trailing : p);
		function _(t) {
			var n = i, r = a;
			return i = a = void 0, u = t, s = e.apply(r, n), s;
		}
		function y(e) {
			return u = e, c = setTimeout(C, t), d ? _(e) : s;
		}
		function b(e) {
			var n = e - l, r = e - u, i = t - n;
			return f ? h(i, o - r) : i;
		}
		function S(e) {
			var n = e - l, r = e - u;
			return l === void 0 || n >= t || n < 0 || f && r >= o;
		}
		function C() {
			var e = g();
			if (S(e)) return w(e);
			c = setTimeout(C, b(e));
		}
		function w(e) {
			return c = void 0, p && i ? _(e) : (i = a = void 0, s);
		}
		function T() {
			c !== void 0 && clearTimeout(c), u = 0, i = l = a = c = void 0;
		}
		function E() {
			return c === void 0 ? s : w(g());
		}
		function D() {
			var e = g(), n = S(e);
			if (i = arguments, a = this, l = e, n) {
				if (c === void 0) return y(l);
				if (f) return c = setTimeout(C, t), _(l);
			}
			return c === void 0 && (c = setTimeout(C, t)), s;
		}
		return D.cancel = T, D.flush = E, D;
	}
	function v(e) {
		var t = typeof e;
		return !!e && (t == "object" || t == "function");
	}
	function y(e) {
		return !!e && typeof e == "object";
	}
	function b(e) {
		return typeof e == "symbol" || y(e) && p.call(e) == i;
	}
	function x(e) {
		if (typeof e == "number") return e;
		if (b(e)) return r;
		if (v(e)) {
			var t = typeof e.valueOf == "function" ? e.valueOf() : e;
			e = v(t) ? t + "" : t;
		}
		if (typeof e != "string") return e === 0 ? e : +e;
		e = e.replace(a, "");
		var n = s.test(e);
		return n || c.test(e) ? l(e.slice(2), n ? 2 : 8) : o.test(e) ? r : +e;
	}
	t.exports = _;
})), Rl = /* @__PURE__ */ s(((e, t) => {
	var n = 200, r = "__lodash_hash_undefined__", i = Infinity, a = "[object Function]", o = "[object GeneratorFunction]", s = /[\\^$.*+?()[\]{}|]/g, c = /^\[object .+?Constructor\]$/, l = typeof global == "object" && global && global.Object === Object && global, u = typeof self == "object" && self && self.Object === Object && self, d = l || u || Function("return this")();
	function f(e, t) {
		return !!(e && e.length) && h(e, t, 0) > -1;
	}
	function p(e, t, n) {
		for (var r = -1, i = e ? e.length : 0; ++r < i;) if (n(t, e[r])) return !0;
		return !1;
	}
	function m(e, t, n, r) {
		for (var i = e.length, a = n + (r ? 1 : -1); r ? a-- : ++a < i;) if (t(e[a], a, e)) return a;
		return -1;
	}
	function h(e, t, n) {
		if (t !== t) return m(e, g, n);
		for (var r = n - 1, i = e.length; ++r < i;) if (e[r] === t) return r;
		return -1;
	}
	function g(e) {
		return e !== e;
	}
	function _(e, t) {
		return e.has(t);
	}
	function v(e, t) {
		return e?.[t];
	}
	function y(e) {
		var t = !1;
		if (e != null && typeof e.toString != "function") try {
			t = !!(e + "");
		} catch {}
		return t;
	}
	function b(e) {
		var t = -1, n = Array(e.size);
		return e.forEach(function(e) {
			n[++t] = e;
		}), n;
	}
	var x = Array.prototype, S = Function.prototype, C = Object.prototype, w = d["__core-js_shared__"], T = function() {
		var e = /[^.]+$/.exec(w && w.keys && w.keys.IE_PROTO || "");
		return e ? "Symbol(src)_1." + e : "";
	}(), E = S.toString, D = C.hasOwnProperty, O = C.toString, k = RegExp("^" + E.call(D).replace(s, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"), A = x.splice, j = W(d, "Map"), M = W(d, "Set"), N = W(Object, "create");
	function P(e) {
		var t = -1, n = e ? e.length : 0;
		for (this.clear(); ++t < n;) {
			var r = e[t];
			this.set(r[0], r[1]);
		}
	}
	function ee() {
		this.__data__ = N ? N(null) : {};
	}
	function F(e) {
		return this.has(e) && delete this.__data__[e];
	}
	function I(e) {
		var t = this.__data__;
		if (N) {
			var n = t[e];
			return n === r ? void 0 : n;
		}
		return D.call(t, e) ? t[e] : void 0;
	}
	function L(e) {
		var t = this.__data__;
		return N ? t[e] !== void 0 : D.call(t, e);
	}
	function R(e, t) {
		var n = this.__data__;
		return n[e] = N && t === void 0 ? r : t, this;
	}
	P.prototype.clear = ee, P.prototype.delete = F, P.prototype.get = I, P.prototype.has = L, P.prototype.set = R;
	function z(e) {
		var t = -1, n = e ? e.length : 0;
		for (this.clear(); ++t < n;) {
			var r = e[t];
			this.set(r[0], r[1]);
		}
	}
	function B() {
		this.__data__ = [];
	}
	function te(e) {
		var t = this.__data__, n = de(t, e);
		return n < 0 ? !1 : (n == t.length - 1 ? t.pop() : A.call(t, n, 1), !0);
	}
	function ne(e) {
		var t = this.__data__, n = de(t, e);
		return n < 0 ? void 0 : t[n][1];
	}
	function V(e) {
		return de(this.__data__, e) > -1;
	}
	function re(e, t) {
		var n = this.__data__, r = de(n, e);
		return r < 0 ? n.push([e, t]) : n[r][1] = t, this;
	}
	z.prototype.clear = B, z.prototype.delete = te, z.prototype.get = ne, z.prototype.has = V, z.prototype.set = re;
	function ie(e) {
		var t = -1, n = e ? e.length : 0;
		for (this.clear(); ++t < n;) {
			var r = e[t];
			this.set(r[0], r[1]);
		}
	}
	function ae() {
		this.__data__ = {
			hash: new P(),
			map: new (j || z)(),
			string: new P()
		};
	}
	function H(e) {
		return he(this, e).delete(e);
	}
	function oe(e) {
		return he(this, e).get(e);
	}
	function U(e) {
		return he(this, e).has(e);
	}
	function se(e, t) {
		return he(this, e).set(e, t), this;
	}
	ie.prototype.clear = ae, ie.prototype.delete = H, ie.prototype.get = oe, ie.prototype.has = U, ie.prototype.set = se;
	function ce(e) {
		var t = -1, n = e ? e.length : 0;
		for (this.__data__ = new ie(); ++t < n;) this.add(e[t]);
	}
	function le(e) {
		return this.__data__.set(e, r), this;
	}
	function ue(e) {
		return this.__data__.has(e);
	}
	ce.prototype.add = ce.prototype.push = le, ce.prototype.has = ue;
	function de(e, t) {
		for (var n = e.length; n--;) if (ve(e[n][0], t)) return n;
		return -1;
	}
	function fe(e) {
		return !ye(e) || ge(e) ? !1 : (q(e) || y(e) ? k : c).test(_e(e));
	}
	function pe(e, t, r) {
		var i = -1, a = f, o = e.length, s = !0, c = [], l = c;
		if (r) s = !1, a = p;
		else if (o >= n) {
			var u = t ? null : me(e);
			if (u) return b(u);
			s = !1, a = _, l = new ce();
		} else l = t ? [] : c;
		outer: for (; ++i < o;) {
			var d = e[i], m = t ? t(d) : d;
			if (d = r || d !== 0 ? d : 0, s && m === m) {
				for (var h = l.length; h--;) if (l[h] === m) continue outer;
				t && l.push(m), c.push(d);
			} else a(l, m, r) || (l !== c && l.push(m), c.push(d));
		}
		return c;
	}
	var me = M && 1 / b(new M([, -0]))[1] == i ? function(e) {
		return new M(e);
	} : be;
	function he(e, t) {
		var n = e.__data__;
		return G(t) ? n[typeof t == "string" ? "string" : "hash"] : n.map;
	}
	function W(e, t) {
		var n = v(e, t);
		return fe(n) ? n : void 0;
	}
	function G(e) {
		var t = typeof e;
		return t == "string" || t == "number" || t == "symbol" || t == "boolean" ? e !== "__proto__" : e === null;
	}
	function ge(e) {
		return !!T && T in e;
	}
	function _e(e) {
		if (e != null) {
			try {
				return E.call(e);
			} catch {}
			try {
				return e + "";
			} catch {}
		}
		return "";
	}
	function K(e) {
		return e && e.length ? pe(e) : [];
	}
	function ve(e, t) {
		return e === t || e !== e && t !== t;
	}
	function q(e) {
		var t = ye(e) ? O.call(e) : "";
		return t == a || t == o;
	}
	function ye(e) {
		var t = typeof e;
		return !!e && (t == "object" || t == "function");
	}
	function be() {}
	t.exports = K;
})), zl = /* @__PURE__ */ u(Ll(), 1), Bl = /* @__PURE__ */ u(Rl(), 1), Vl = (e, t, n, r) => {
	let i = `-${15 / 2}px`, { staticSide: a, rotation: o, shadowOpacity: s } = {
		top: {
			staticSide: "bottom",
			rotation: 45,
			shadowOpacity: 40
		},
		bottom: {
			staticSide: "top",
			rotation: 225,
			shadowOpacity: 7
		},
		right: {
			staticSide: "left",
			rotation: 135,
			shadowOpacity: 7
		},
		left: {
			staticSide: "right",
			rotation: -45,
			shadowOpacity: 40
		}
	}[e.split("-")[0]];
	return {
		boxShadow: `1px 1px 1px hsl(0deg 0% 13% / ${s}%)`,
		transform: `rotate(${o}deg)`,
		clipPath: "polygon(0% 100%, 100% 100%, 100% 0%)",
		left: t == null ? "" : `${t}px`,
		top: n == null ? "" : `${n}px`,
		right: "",
		bottom: "",
		[a]: i,
		zIndex: r
	};
}, Hl = (e, t) => {
	let n = e.slice(1);
	return t.find(({ config: e, type: t }) => t === "@appcues/overlay" && n === e.rootId);
}, Ul = (e, t) => {
	let n = 17.5;
	return t.includes("start") ? e - n : e + n;
}, Wl = ({ placementUnit: e, distance: t, skidding: n, placement: r, targetEl: i }) => {
	let a = r.startsWith("left") || r.startsWith("right"), o = a ? t : n, s = a ? n : t;
	if (e !== "percentage" || !i) return {
		mainAxis: t,
		crossAxis: n
	};
	let { width: c, height: l } = i.getBoundingClientRect();
	return {
		mainAxis: a ? c * o / 100 : l * s / 100,
		crossAxis: a ? l * s / 100 : c * o / 100
	};
}, Gl = (e, t) => {
	try {
		let n = t(), r = n.document, i = n.getComputedStyle(e), { overflow: a, overflowY: o, overflowX: s } = i, c = new Set([
			a,
			o,
			s
		]);
		if (i.position === "fixed" || i.position === "sticky" || c.has("auto") || c.has("hidden")) return !0;
		let { host: l = null } = e?.getRootNode() ?? {}, u = l?.tagName?.includes("APPCUES-EXPERIENCE-CONTAINER") || l?.tagName?.includes("APPCUES-EXPERIENCE-CONTAINER-BUILDER");
		return e.parentElement === null && l && !u ? Gl(l.parentElement, t) : e.parentElement !== null && e.parentElement !== r.body ? Gl(e.parentElement, t) : !1;
	} catch {
		return !1;
	}
};
function Kl(e) {
	return e === "fixed" || e === "relative" || e === "absolute" || e === "sticky";
}
function ql(e) {
	return e.display === "flex" || e.display === "inline-flex";
}
function Jl(e, t, n, r, i) {
	let a = i, o = t.zIndex, s = t.position, c = e.parentElement, l = c ? r.getComputedStyle(c) : {};
	if (o !== "" && o !== "auto" && !Kl(s) && !ql(l) && (o = "auto"), (!a || o !== "" && o !== "auto" && (Kl(s) || ql(l))) && (a = o), c && c !== n.body && c !== n.documentElement) return Jl(c, l, n, r, a);
	if (/^\d+$/.test(a)) {
		let e = Number.parseInt(a, 10);
		e += 1, a = e;
	}
	return a;
}
var Yl = (e, t) => {
	let n = t(), r = n.document;
	return Jl(e, n.getComputedStyle(e), r, n);
}, Xl = ({ targetEl: e, rootStyle: t, shouldAutoCalculateZIndex: n, getWindowReference: r }) => {
	let i = t;
	if (n) {
		let n = Yl(e, r);
		i = {
			...t,
			zIndex: n
		};
	}
	return i;
}, { addEventListener: Zl, removeEventListener: Ql } = (() => {
	let e = /* @__PURE__ */ new Map();
	function t(t) {
		t.composedPath().forEach((n) => {
			(e.get(n) ?? {})[t.type]?.map((e) => e(t));
		});
	}
	return {
		addEventListener: (n, r, i) => {
			e.get(n) || e.set(n, {});
			let a = e.get(n);
			a[r] || (a[r] = []), a[r].includes(i) || (a[r] = [...a[r], i], e.set(n, a)), a[r].length === 1 && n.addEventListener(r, t, !0);
		},
		removeEventListener: (n, r, i) => {
			let a = e.get(n);
			a && (a[r] = (a[r] ?? []).filter((e) => e !== i), e.set(n, a), a[r].length === 0 && n.removeEventListener(r, t, !0));
		}
	};
})(), $l = (() => {
	let e = /* @__PURE__ */ new Map(), t = /* @__PURE__ */ new Map(), n = (n) => {
		if (t.has(n)) return;
		let r = setInterval(() => {
			e.get(n).forEach((e) => e());
		}, n);
		t.set(n, r);
	}, r = (n, r) => {
		let i = e.get(r);
		if (i) {
			let a = i.filter((e) => e !== n);
			if (a.length > 0) {
				e.set(r, a);
				return;
			}
			let o = t.get(r);
			clearInterval(o), e.delete(r), t.delete(r);
		}
	};
	return (t, i) => {
		let a = e.get(i) ?? [];
		return e.set(i, [...a, t]), n(i), () => r(t, i);
	};
})(), eu = (e, t) => {
	if (!t) return e;
	let { order: n, text: r } = t, i = [...e];
	return r && r !== "" && (i = i.filter((e) => e.textContent.replace(/\r\n|\r|\n/g, " ").toLowerCase().trim() === r.toString().toLowerCase().trim())), n == null ? i : i.length > n ? [i[n]] : [];
}, tu = (e) => e.includes(hr), nu = (e, t) => e != null && e.ownerDocument !== t.document, ru = (e, t) => ({ getBoundingClientRect() {
	let n = 0, r = 0, i = e.ownerDocument?.defaultView, a = 0;
	for (; i && i !== t && a < 20;) {
		a += 1;
		try {
			let e = i.frameElement;
			if (!e) break;
			let t = e.getBoundingClientRect(), a = e.ownerDocument.defaultView.getComputedStyle(e);
			n += t.left + e.clientLeft + Number.parseFloat(a.paddingLeft || "0"), r += t.top + e.clientTop + Number.parseFloat(a.paddingTop || "0");
			let o = i.parent;
			if (o === i) break;
			i = o;
		} catch {
			break;
		}
	}
	let o = e.getBoundingClientRect(), s = n + o.left, c = r + o.top;
	return {
		x: s,
		y: c,
		left: s,
		top: c,
		right: s + o.width,
		bottom: c + o.height,
		width: o.width,
		height: o.height,
		toJSON() {
			return this;
		}
	};
} }), iu = "@appcues/overlay", au = 500, ou = "top 200ms, left 200ms, right 200ms, bottom 200ms", su = {
	top: "top",
	"top-left": "top-start",
	"top-right": "top-end",
	right: "right",
	"right-top": "right-start",
	"right-bottom": "right-end",
	bottom: "bottom",
	"bottom-right": "bottom-end",
	"bottom-left": "bottom-start",
	left: "left",
	"left-bottom": "left-end",
	"left-top": "left-start",
	center: "top-start"
}, cu = (e) => {
	let t, n, r, i = [], a, o = () => {}, s;
	function c() {
		e();
	}
	let l = (0, zl.default)(c, 100);
	function u() {
		let e = t.getBoundingClientRect();
		s && (e.x !== s.x || e.y !== s.y || e.width !== s.width || e.height !== s.height) && l(), s = e;
	}
	return {
		setElements(e, a, o) {
			return t = e, n = a, r = o, i = [], this;
		},
		start() {
			r && (i = (0, Bl.default)([...tl(r)])), i.forEach((e) => {
				Zl(e, "scroll", l), Zl(e, "resize", l);
			}), a = new ResizeObserver(l), a.observe(n), s = t.getBoundingClientRect(), o = $l(u, 200);
		},
		remove() {
			i.forEach((e) => {
				Ql(e, "scroll", l), Ql(e, "resize", l);
			}), a?.unobserve(n), o();
		}
	};
};
Q(iu, ({ addHook: e, registerAction: t }) => {
	let n, r, i, a = !1, o = null, s = !1, c, l, u, d, f, p, m, h, g = !1, _ = "absolute", v, y;
	e("step.begin", ({ onElementInserted: e, onElementRemoved: t, querySelector: b, reportError: x, step: S, updateStyle: C, getWindowReference: w, getTraitConfig: T, getContainer: E }) => {
		let { traits: D } = S.getConfig(), { arrowId: O = "arrow", target: k, rootId: A, placement: j = "auto", distance: M, skidding: N, placementUnit: P = "pixels", shouldAutoCalculateZIndex: ee = !0 } = T(), F = Hl(k.selector, D), I = D.find((e) => e.type === "@appcues/toggle")?.config?.startHidden ?? !0;
		I || C(A, { position: "absolute" }), f = () => {
			let e = S.querySelector(`#${A}`), t = S.querySelector(`#${O}`), n = eu(b(k.selector), k.filters);
			return {
				matchingElements: n,
				targetEl: n[0],
				rootEl: e[0],
				arrowEl: t[0]
			};
		};
		let L = async () => {
			let { targetEl: e, rootEl: t, arrowEl: n } = f();
			if (!a && e && t) {
				a = !0;
				let r = Date.now();
				o === null && (o = r);
				let i = r - o > au, s = Wl({
					placement: j,
					targetEl: e,
					distance: M,
					skidding: N,
					placementUnit: P
				}), c = [jl(({ placement: e }) => ({
					...s,
					crossAxis: n && /start|end/gm.test(e) ? Ul(N, e) : s.crossAxis
				}))];
				j === "auto" && c.push(Nl(), Ml({ crossAxis: !0 })), n && c.push(Fl({
					element: n,
					padding: 10
				}));
				let l = w(), u = nu(e, l), d = F != null && tu(F.config.target.selector), f = u ? ru(e, l) : e;
				!u && !d && c.push(Pl());
				let { middlewareData: p, strategy: v, x: y, y: b, placement: x } = await Il(f, t, {
					middleware: c,
					placement: su[j] ?? "auto",
					strategy: _
				}), { referenceHidden: S } = p.hide ?? { referenceHidden: !1 };
				if (n) {
					let { x: e, y: t } = p.arrow;
					C(O, {
						...Vl(x, e, t),
						transition: i ? ou : "none"
					});
				}
				let T = Xl({
					targetEl: e,
					rootStyle: {
						left: `${y}px`,
						position: v,
						top: `${b}px`
					},
					shouldAutoCalculateZIndex: ee,
					getWindowReference: w
				});
				e.style.visibility === "hidden" && (T.visibility = "hidden", h = e.style.visibility), S && t.style.visibility !== "hidden" && (m = t.style.visibility, g = !0, T.visibility = "hidden"), !S && g && (T.visibility = m ?? "visible", g = !1), !S && e.style.visibility !== "hidden" && e.style.visibility !== "" && h === "hidden" && (T.visibility = "visible"), j === "center" && (T.transform = "translate(-50%, 50%)"), T.transition = i ? ou : "none", C(A, T);
			}
		};
		v = () => {
			a = !1, L();
		}, p = cu(v);
		let R = () => eu(b(k.selector), k.filters), z = () => {
			if (!F) return R();
			let { selector: e, filters: t } = F.config.target;
			return eu(b(e), t);
		}, B = () => F ? F.config.target.selector : k.selector;
		r = () => {
			c &&= (c(), void 0), c = e({
				getTarget: z,
				onInserted: async () => {
					a = !1, s = !1, F && await new Promise((e) => {
						setTimeout(e, 0);
					}), await n() && (s = !0);
				}
			});
		}, i = () => {
			if (u &&= (u(), void 0), !d) return;
			let t = d, n = y, r = !1, i = [], o = () => {
				i.forEach((e) => e()), i = [];
			}, c = () => {
				r = !0, a = !1, s = !1, o(), u = void 0, S.recover({ errorId: n });
			}, l = () => {
				r || t().length !== 1 || c();
			};
			if (t().length === 1) {
				c();
				return;
			}
			i.push(e({
				getTarget: t,
				onInserted: l
			}));
			let f = () => l(), p = w().document;
			i.push(fr(p.body, f));
			let m = E?.();
			m && m !== p.body && i.push(fr(m, f)), u = o;
		}, n = async () => {
			c && c(), l && l(), u &&= (u(), void 0);
			let { matchingElements: e, rootEl: n } = f(), i = e.length === 1, o = e.length > 1, s = z(), h = s.length === 1, v = s.length > 1, b = () => {
				F || (l = t({
					getTarget: R,
					onRemoved: () => {
						a = !1, y = x(`Target got removed => ${k.selector}`), d = R, p.remove();
					}
				}));
			};
			if (i && !n) return y = x(`Could not find root element #${A} for overlay positioning.`), d = () => S.querySelector(`#${A}`), !1;
			if (o) return y = x(`Found ${e.length} elements for selector ${k.selector}.`), d = R, !1;
			if (v) return y = x(`Found ${s.length} elements for selector ${B()}.`), d = z, !1;
			if (!i || !h) {
				let e = B();
				return s.length === 0 && tu(e) ? r() : (y = x(`Could not find element for selector ${e}.`), d = z), !1;
			}
			if (i) {
				let t = F ? s : null;
				if (I) {
					if (nu(e[0], w())) _ = "absolute";
					else {
						let n = t != null && t[0] != null ? Gl(t[0].parentElement, w) : !1;
						_ = Gl(e[0]?.parentElement, w) || n ? "fixed" : "absolute";
					}
					C(A, { position: _ });
				}
				return await L(), (nu(e[0], w()) || F != null && tu(F.config.target.selector)) && !g && C(A, { visibility: m ?? "visible" }), b(), d = void 0, p.setElements(e[0], n, t ? t[0] : null).start(), !0;
			}
			return !1;
		};
	}), e("step.postrender", async () => {
		s || await n() && (s = !0);
	}), e("step.end", () => {
		c && c(), l && l(), u &&= (u(), void 0), p.remove(), a = !1, s = !1, o = null;
	}), e("step.error", () => {
		a = !1, s = !1, o = null, i && i();
	});
}), Q("@appcues/persistent", ({ addHook: e }) => {
	e("experience.begin", ({ steps: e }) => {
		e.map((e) => e.start());
	});
});
//#endregion
//#region src/traits/inline/inline.js
var lu = {
	left: "beforebegin",
	"inner-left": "afterbegin",
	right: "afterend",
	"inner-right": "beforeend"
}, uu = "@appcues/inline", du = "appcues-hide", fu = `.${du} { display: none !important; }`, pu = ({ distanceUnit: e, yOffset: t, xOffset: n, targetEl: r }) => {
	if (e !== "%" || !r) return {
		x: `${n}px`,
		y: `${t}px`
	};
	let { width: i, height: a } = r.getBoundingClientRect();
	return {
		x: `${i * n / 100}px`,
		y: `${a * t / 100}px`
	};
};
function mu({ addHook: e }) {
	let t, n, r, i = [], a = [], o = null, s = null, c = (e) => {
		if (o) return;
		let { document: t } = e();
		o = t.createElement("style"), o.textContent = fu, t.head.append(o);
	}, l = () => {
		i.forEach((e) => e.classList.remove(du)), i = [], a.forEach((e) => {
			let t = e.firstChild;
			t && e.replaceWith(t);
		}), a = [], o &&= (o.remove(), null);
	};
	e("step.begin", ({ step: e, getTraitConfig: o, reportError: u, onElementRemoved: d, updateRootStyle: f, querySelector: p, getWindowReference: m }) => {
		let { target: h, placement: g = "right", verticalAlignment: _ = "bottom", allowOverlap: v = !1, xOffset: y = 0, yOffset: b = 0, distanceUnit: x = "px", sticky: S = !1, rootDisplay: C = "inline-block", clearContainer: w = !1 } = o();
		t && t(), n && n();
		let T = eu(p(h.selector), h.filters), E = T.length === 1, D = T.length > 1, O = T.length === 0, k = (t) => {
			let n = m().document.createElement("div");
			if (s &&= (s.remove(), null), l(), w && g.includes("inner")) if (w === "hide") {
				c(m);
				let { document: e } = m();
				Array.from(t.childNodes).forEach((t) => {
					if (t.nodeType === Node.ELEMENT_NODE) t.classList.add(du), i.push(t);
					else if (t.nodeType === Node.TEXT_NODE && t.textContent.trim()) {
						let n = e.createElement("span");
						n.classList.add(du), t.replaceWith(n), n.append(t), a.push(n);
					}
				});
			} else for (; t.firstChild;) t.firstChild.remove();
			if (t.insertAdjacentElement(lu[g], n) == null) {
				u(`can't insert inline container on the ${g}`);
				return;
			}
			s = n, e.setStepContainerTarget(n);
		}, A = () => eu(p(h.selector), h.filters), j = () => {
			n = d({
				getTarget: A,
				onRemoved: () => {
					r = u(`Target got removed => ${h.selector}`);
				}
			});
		};
		if (E) {
			k(T[0]);
			let e = {
				display: C,
				verticalAlign: _
			}, { x: t, y: n } = pu({
				distanceUnit: x,
				xOffset: y,
				yOffset: b,
				targetEl: T[0]
			});
			if (v) e.position = "absolute", e.transform = `translate(${t}, ${n})`;
			else {
				let r = g.includes("left") ? "right" : "left";
				e[`margin-${r}`] = t, e[`margin-${_}`] = n;
			}
			if (S) {
				e.position = "sticky";
				let t = g.includes("left") ? "top" : "bottom";
				e[t] = 0, e.zIndex = Vr;
			}
			f(e), j();
			return;
		}
		D && u(`Found ${T.length} elements for selector ${h.selector}.`), O && (r = u(`Could not find element for selector ${h.selector}.`));
	}), e("step.error", ({ step: e, getTraitConfig: n, onElementInserted: i, querySelector: a }) => {
		let { target: o } = n();
		t = i({
			getTarget: () => eu(a(o.selector), o.filters),
			onInserted: () => {
				e.recover({ errorId: r });
			}
		});
	}), e("step.end", () => {
		t && t(), n && n(), s &&= (s.remove(), null), l();
	});
}
Q(uu, mu);
//#endregion
//#region src/traits/toggle/helpers.js
var hu = (e, t, n) => {
	let { height: r, width: i, left: a, top: o } = e.getBoundingClientRect();
	return Math.floor(Math.hypot(t - (a + i / 2), n - (o + r / 2)) / 2);
}, gu = (e, t) => {
	let { height: n, width: r } = e.getBoundingClientRect(), i = Math.floor(Math.hypot(n, r) / 4);
	return Math.max(t, 0) + i;
}, _u = (e) => e.key === "Escape", vu = (e, t) => ![...e.composedPath()].filter((e) => e.nodeType === Node.ELEMENT_NODE).some((e) => e?.contains?.(t) ?? !1), yu = (e, t) => ({
	remove: () => {
		e.removeEventListener("keydown", t), e.removeEventListener("click", t, !0);
	},
	start: () => {
		e.addEventListener("click", t, !0), e.addEventListener("keydown", t);
	}
}), bu = (e, t, n) => t.length === 0 ? (n("Element not found"), !1) : t.length > 1 ? (n(`More than one element found with id: ${e}`), !1) : !0, xu = "@appcues/toggle.style", Su = ({ targetId: e, styles: t = {} }, { updateStyle: n }) => {
	n(e, t);
}, Cu = { [xu]: Su };
Q("@appcues/toggle", ({ addHook: e, registerAction: t }, { startHidden: n = !0, targetId: r, transition: i, closeOnClickOutside: a = !0, closeRadius: o }) => {
	let s, c, l, u = !1, d = [], f = null, p = [], m = () => {
		d.forEach((e) => e.remove()), d = [];
	};
	n && e("step.begin", ({ updateStyle: e, getWindowReference: t }) => {
		e(r, {
			opacity: "0",
			visibility: "hidden",
			"pointer-events": "none"
		}), p = [...t().document.querySelectorAll("iframe")];
	}), e("step.end", () => {
		a && m(), f?.remove(), f = null;
	}), e("step.error", () => {
		a && m(), f?.remove(), f = null;
	});
	let h = ({ on: e } = {}, t) => {
		let { reportError: n, step: c, updateStyle: l, getWindowReference: d } = t, f = d().document;
		if (!bu(r, c.querySelector(`#${r}`), n)) return;
		a && m();
		let h = {};
		i || (h.visibility = "hidden", h["pointer-events"] = "none"), l(r, {
			...h,
			opacity: "0"
		}), i && setTimeout(() => {
			l(r, {
				visibility: "hidden",
				"pointer-events": "none"
			});
		}, i.duration * 1e3), o && u && (Ql(f, "mousemove", s), p.forEach((e) => {
			e.contentDocument?.body && Ql(e.contentDocument.body, "mousemove", s);
		}), u = !1), e?.close?.forEach((e) => Cu[e.type](e.config, t));
	}, g = ({ on: e } = {}, t) => {
		let { reportError: n, step: m, updateStyle: g, getWindowReference: _ } = t, v = _().document, y = m.querySelector(`#${r}`);
		if (!bu(r, y, n)) return;
		let b = {};
		if (i && (b.transition = `opacity ${i.duration}s ${i.easing}`), g(r, {
			...b,
			visibility: "visible",
			opacity: "1",
			"pointer-events": "auto"
		}), e?.open?.forEach((e) => Cu[e.type](e.config, t)), a && d.length === 0) {
			let n = m.querySelector(":first-child")[0];
			l = (n) => {
				(_u(n) || vu(n, y[0])) && h({ on: e }, t);
			};
			let r = p.map((e) => e.contentDocument?.body ? yu(e.contentDocument.body, l) : null).filter(Boolean);
			d.push(yu(v, l), yu(n, l), ...r), d.forEach((e) => e.start());
		}
		if (f || (c = (n) => {
			if (n.type === "keydown" && !["Enter", " "].includes(n.key)) return;
			let r = [...n.composedPath()];
			["a", "button"].includes(r[0].tagName.toLowerCase()) && h({ on: e }, t);
		}, f = yu(y[0], c), f.start()), o && !u) {
			let t = gu(y[0], o);
			s = (0, zl.default)((r) => {
				hu(y[0], r.clientX, r.clientY) > t && h({ on: e }, {
					reportError: n,
					step: m,
					updateStyle: g,
					getWindowReference: _
				});
			}, 60), Zl(v, "mousemove", s), p.forEach((e) => {
				e.contentDocument?.body && Zl(e.contentDocument.body, "mousemove", s);
			}), u = !0;
		}
	};
	t("run", ({ on: e } = {}, t) => {
		let { step: n, reportError: i, getWindowReference: a } = t, o = n.querySelector(`#${r}`);
		if (bu(r, o, i)) {
			if (a().getComputedStyle(o[0]).visibility === "hidden") {
				g({ on: e }, t);
				return;
			}
			h({ on: e }, t);
		}
	}), t("open", g), t("close", h), t("style", Su);
}), Q("@appcues/coreEvents", ({ registerAction: e }) => {
	e("step_seen", (e, { step: t }) => {
		t.seen();
	}), e("extended_event", ({ name: e, ...t }, { step: n }) => {
		n.extendedEvent(e, t);
	}), e("step_interaction", (e, { step: t }) => {
		t.interaction(e.interactionType, e.interactionData);
	}), e("experience_dismissed", (e, { step: t }) => {
		t.dismissExperience();
	}), e("experience_snoozed", (e, { step: t }) => {
		t.snoozeExperience();
	});
});
//#endregion
//#region src/traits/store/helpers.js
var wu = (e, t = {}, n = () => window) => {
	let r = t, i = [], a = n().document, o = (e) => {
		let { el: t, callbackFn: n } = e.detail;
		i.push([t, n]), t[n].apply(e.target, [r]);
	};
	return a.addEventListener(`${e}:connect`, o), {
		getState: () => r,
		setState: (e) => {
			r = {
				...r,
				...e
			}, i.forEach(([e, t]) => {
				e[t].apply(e, [r]);
			});
		},
		destroy: () => {
			a.removeEventListener(`${e}:connect`, o);
		}
	};
};
Q("@appcues/store", ({ addHook: e, registerAction: t }, { id: n, initialState: r = {} }) => {
	let i;
	e("step.begin", ({ getWindowReference: e }) => {
		i = wu(n, r, e);
	}), e("step.end", () => {
		i && i.destroy();
	}), t("setState", ({ stateKey: e }, t, n) => {
		i && i.setState({ [e]: n?.detail });
	});
});
//#endregion
//#region src/traits/animate/animations.js
var Tu = {
	slide_in_down: [{
		transform: "translate3d(0, -100%, 0)",
		visibility: "visible"
	}, { transform: "translate3d(0, 0, 0)" }],
	slide_out_down: [
		{
			transform: "translate3d(0, 0, 0)",
			offset: 0
		},
		{
			transform: "translate3d(0, 100%, 0)",
			offset: .99
		},
		{
			visibility: "hidden",
			offset: 1
		}
	],
	slide_in_up: [{
		transform: "translate3d(0, 100%, 0)",
		visibility: "visible"
	}, { transform: "translate3d(0, 0, 0)" }],
	pulse: [
		{ transform: "scale3d(1, 1, 1)" },
		{ transform: "scale3d(1.05, 1.05, 1.05)" },
		{ transform: "scale3d(1, 1, 1)" }
	]
}, Eu = "@appcues/animate", Du = 500, Ou = "none", ku = "button, [href], input, select, textarea, [tabindex]:not([tabindex=\"-1\"])", Au = (e) => {
	let t = e?.activeElement;
	for (; t?.shadowRoot?.activeElement;) t = t.shadowRoot.activeElement;
	return t;
}, ju = /* @__PURE__ */ new WeakMap(), Mu = (e) => {
	let t = Tu[e?.effect] || e?.keyframes, n = Array.isArray(t) ? t[t.length - 1] : null;
	return n ? Number(n.opacity) === 0 || n.visibility === "hidden" || n.display === "none" : !1;
}, Nu = (e, t) => new Promise((n) => {
	let { keyframes: r, duration: i = Du, iterations: a, effect: o, fill: s = Ou, easing: c = "linear", composite: l } = t, u = Tu[o] || r, d = {
		duration: i,
		iterations: a,
		fill: s,
		easing: c,
		...l ? { composite: l } : {}
	};
	if (!u) {
		n();
		return;
	}
	let f = e.animate(u, d);
	f?.addEventListener ? f.addEventListener("finish", n, { once: !0 }) : n();
});
Q(Eu, ({ addHook: e, registerAction: t }, n) => {
	if (n.phase === "exit") e("step.end", ({ querySelector: e }) => {
		let { target: t } = n;
		if (!t) return;
		let r = e(t.selector);
		if (r.length !== 0) return Nu(r[0], n);
	});
	else {
		let t = !1;
		e("step.postrender", ({ querySelector: e }) => {
			if (t) return;
			let { target: r } = n;
			if (!r) return;
			let i = e(r.selector);
			i.length !== 0 && (t = !0, Nu(i[0], n));
		});
	}
	t("toggle", ({ toggleGroupId: e, target: t, animations: n, autoFocus: r = !0 }, { querySelector: i, getWindowReference: a }) => {
		let o = i(t.selector);
		if (o.length === 0) return;
		let [s] = o, c = s.getAttribute(e) === n[0].id ? n[1] : n[0];
		if (!c) return;
		let l = Mu(c);
		l || (s.inert = !1);
		let u = r ? Au(a?.()?.document) : null, d = Nu(s, c);
		c.id && s.setAttribute(e, c.id);
		let f = () => c.id != null && s.getAttribute(e) !== c.id;
		if (!r) {
			l && d.then(() => {
				f() || (s.inert = !0);
			});
			return;
		}
		d.then(() => {
			if (!f()) if (l) {
				let e = ju.get(s);
				e?.isConnected && e.focus({ preventScroll: !0 }), ju.delete(s), s.inert = !0;
			} else u && ju.set(s, u), (s.querySelector(ku) ?? s).focus({ preventScroll: !0 });
		});
	}), t("run", async (e, t) => {
		let { querySelector: n, getAction: r } = t, { toggleGroupId: i, target: a, animation: o, ignoreToggleGroup: s = !1, onFinish: c = [] } = e;
		if (!a) return;
		let l = n(a.selector);
		if (l.length === 0) return;
		let u = l[0], d = u.getAttribute(i);
		(!d || d === o.id) && !s || (await Nu(u, o ?? e), c.forEach((e) => {
			r(e.type)(e?.config ?? {}, t);
		}), s || u.setAttribute(i, o.id));
	});
});
//#endregion
//#region src/traits/floating/helpers.js
var Pu = {
	pixels: "px",
	percentage: "%"
};
function Fu(e, t, n, r) {
	let i = Pu[n] || "px";
	switch (e) {
		case "left": return {
			left: 0,
			transform: `translateX(${t}${i})`,
			...r && { right: "unset" }
		};
		case "center": return {
			left: "50%",
			transform: `translateX(calc(-50% + ${t}${i}))`,
			...r && { right: "unset" }
		};
		default: return {
			right: 0,
			transform: `translateX(-${t}${i})`,
			...r && { left: "unset" }
		};
	}
}
function Iu(e, t, n, r) {
	let i = Pu[n] || "px";
	switch (e) {
		case "top": return {
			top: 0,
			transform: `translateY(${t}${i})`,
			...r && { bottom: "unset" }
		};
		case "center": return {
			top: "50%",
			transform: `translateY(calc(-50% + ${t}${i}))`,
			...r && { bottom: "unset" }
		};
		default: return {
			bottom: 0,
			transform: `translateY(-${t}${i})`,
			...r && { top: "unset" }
		};
	}
}
Q("@appcues/floating", ({ addHook: e }) => {
	e("step.begin", ({ getTraitConfig: e, updateStyle: t, updateRootStyle: n }) => {
		let { target: r, strategy: i = "fixed", xOffset: a = 0, yOffset: o = 0, xPosition: s = "left", yPosition: c = "top", placementUnit: l = "pixels", unsetOppositeDirection: u = !1, applyToRoot: d = !1 } = e(), f = {
			position: i,
			...[Fu(s, a, l, u), Iu(c, o, l, u)].reduce((e, t) => {
				let { transform: n, ...r } = t;
				return n && (e.transform = e.transform ? `${e.transform} ${n}` : n), {
					...e,
					...r
				};
			}, {})
		};
		if (d) {
			n(f, { forceUpdate: !0 });
			return;
		}
		t(r.selector, f);
	});
});
//#endregion
//#region src/traits/dismissible/dismissible.js
var Lu = "@appcues/dismissible";
function Ru(e) {
	return `_experience_dismissed_${e}`;
}
Q(Lu, ({ addHook: e, registerAction: t }, { strategy: n = "permanent" }) => {
	function r(e, t) {
		return n === "session" ? t().sessionStorage.getItem(Ru(e)) === "1" : !1;
	}
	e("experience.begin", ({ stopExperience: e, getExperienceId: t, getWindowReference: n }) => {
		r(t(), n) && e();
	}), t("dismiss", (e, { stopExperience: t, updateUserProfile: r, getExperienceId: i, getWindowReference: a }) => {
		let o = Ru(i());
		n === "session" ? a().sessionStorage.setItem(o, "1") : n === "permanent" && r({ [o]: "permanently_dismissed" }), t();
	});
}), Q("@appcues/experienceStyle", ({ addHook: e }) => {
	e("step.begin", ({ updateRootStyle: e, getTraitConfig: t }) => {
		e(t(), { forceUpdate: !0 });
	}), e("step.container_change", ({ updateRootStyle: e, getTraitConfig: t }) => {
		e(t(), { forceUpdate: !0 });
	}), e("step.end", ({ updateRootStyle: e, getTraitConfig: t }) => {
		e(Object.keys(t()).reduce((e, t) => (e[t] = null, e), {}), { forceUpdate: !0 });
	});
});
//#endregion
//#region src/traits/rootStyle/root-style.js
var zu = "@appcues/rootStyle", Bu = ({ getTraitConfig: e, updateRootStyle: t }) => {
	let { forceUpdate: n = !1, ...r } = e();
	t(r, { forceUpdate: n });
};
function Vu({ addHook: e }) {
	e("step.begin", Bu), e("step.container_change", Bu);
}
Q(zu, Vu);
//#endregion
//#region ../sdk-middleware-events/dist/index.js
var Hu = "appcues:launchpad_close", Uu = "appcues:launchpad_search", Wu = "appcues:launchpad_search_error", Gu = "appcues:launchpad_search_response", Ku = function(e, t) {
	return window.addEventListener(e, t), function() {
		return window.removeEventListener(e, t);
	};
}, qu = function(e) {
	return Ku(Hu, e);
}, Ju = function(e, t, n) {
	var r = new CustomEvent(Uu, { detail: {
		integrationId: e,
		query: t,
		experienceId: n
	} });
	window.dispatchEvent(r);
}, Yu = function(e, t) {
	return Ku(`${Gu}:${e}`, t);
}, Xu = function(e, t) {
	return Ku(`${Wu}:${e}`, t);
};
Q("@appcues/sdk-middleware-events", ({ addHook: e }, { onLaunchpadClose: t }) => {
	let n;
	e("step.begin", (e) => {
		n = qu(() => {
			t.forEach((t) => {
				e.getAction(t.type)?.(t.config, e);
			});
		});
	}), e("step.end", () => {
		n?.();
	});
});
//#endregion
//#region src/traits/knowledgeBaseIntegration/knowledge-base-integration.js
var Zu = "@appcues/knowledge-base-integration", Qu = (e, { querySelector: t, reportError: n }) => {
	let r = t(e), i = r.length > 1, a = r.length === 0;
	return i && n("The target element is duplicated, please provide a more specific selector"), a && n("The target element is not found"), r[0];
};
Q(Zu, ({ addHook: e, registerAction: t }, n) => {
	let { integrationConnected: r = !1 } = n, i, a, o, s, c, l = () => {
		r && a?.prev();
	}, u = (e) => {
		if (!r) return;
		let { integrationId: t } = n, { inputValue: l } = e.detail;
		o.setAttribute("searchTerm", l), o.setAttribute("state", "loading"), i.setAttribute("loading", !0), s && (s.scrollTop = 0), a?.next(), Ju(t, l, c);
	};
	e("step.begin", ({ getExperienceId: e }) => {
		c = e(), Yu(c, (e) => {
			let t = e.detail, n = t.results?.length === 0 ? "empty" : "showing_results";
			o.setAttribute("state", n), o.setAttribute("results", JSON.stringify(t.results)), i.setAttribute("loading", !1);
		}), Xu(c, () => {
			o.setAttribute("state", "error"), i.setAttribute("loading", !1);
		});
	}), e("step.end", () => {
		i?.removeEventListener("onSearch", u), i?.removeEventListener("onCancel", l);
	}), t("bindListeners", (e, t) => {
		let { navigation: r } = n;
		(!a || !i) && (a = Qu(r.selector, t), i = Qu("appcues-search-header", t), o = Qu("appcues-search-results", t), s = Qu("#launchpad-container", t), i?.addEventListener("onSearch", u), i?.addEventListener("onCancel", l));
	});
});
//#endregion
//#region src/traits/sequential/sequential.js
var $u = "@appcues/sequential", ed = (e, t) => e.findIndex((e) => e.getConfig()?.id === t);
Q($u, ({ addHook: e, registerAction: t }) => {
	let n, r = "forward", i = (e, { steps: t }, i) => {
		r = "backward", n !== 0 && t[n].stop(() => {
			--n, t[n].start();
		}, i);
	}, a = (e, { steps: t }, i) => {
		if (r = "forward", n === t.length - 1) {
			t[n].stop(void 0, i);
			return;
		}
		t[n].stop(() => {
			n += 1, t[n].start();
		}, i);
	};
	e("experience.begin", ({ steps: e, getTraitConfig: t, reportError: r }) => {
		let { startStepId: i } = t() ?? {};
		if (i) {
			let t = ed(e, i);
			t === -1 && r(`startStepId "${i}" did not match any step; starting at 0`), n = t === -1 ? 0 : t;
		} else n = 0;
		e[n].start();
	}), t("next", a), t("prev", i), t("goTo", (e, { step: t, steps: i }, a) => {
		let o = ed(i, e.stepId);
		o !== -1 && (r = "forward", t.stop(() => {
			n = o, i[n].start();
		}, a));
	}), t("skip", (e, t, n) => r === "backward" ? i(e, t, n) : a(e, t, n));
});
//#endregion
//#region src/traits/delay/delay.js
var td = "@appcues/delay", nd = 3e5;
Q(td, ({ addHook: e }, t) => {
	let n = null;
	e("step.begin", () => {
		let e = t?.duration;
		if (!e) return;
		let r = Math.min(e, nd);
		return r !== e && console.warn(`[@appcues/delay] duration ${e}ms exceeds the 5-minute maximum (${nd}ms) and has been capped.`), new Promise((e) => {
			n = setTimeout(e, r);
		});
	}), e("step.end", () => {
		n !== null && (clearTimeout(n), n = null);
	});
});
//#endregion
//#region src/traits/dialog/backdrops/constants.js
var rd = "appcues-cutout-backdrop", id = "appcues-custom-backdrop", ad = "apc-spotlight", od = "\n  :where(dialog) { all: unset; }\n", sd = "\n  ::backdrop { backdrop-filter: var(--backdrop-blur); background-color: var(--backdrop-color); }\n", cd = ({ backdropBlur: e, backdropColor: t }) => ({
	...e && { "--backdrop-blur": e },
	...t && { "--backdrop-color": t }
}), ld = ({ getWindowReference: e, backdropZIndex: t, backdropBlur: n, backdropColor: r }) => {
	if (e().document.querySelector("#appcues-custom-backdrop")) return null;
	let i = e().document.createElement("div");
	return i.id = id, i.style.cssText = `
    z-index: ${t};
    position: fixed;
    inset: 0;
    backdrop-filter: ${n};
    background-color: ${r};
    pointer-events: none;
  `, i;
}, ud = /* @__PURE__ */ c({
	build: () => hd,
	update: () => gd
}), dd = 1500, fd = .67, pd = (e) => {
	Object.assign(e.style, {
		position: "fixed",
		top: "0",
		left: "0",
		width: "100vw",
		height: "100vh",
		overflow: "hidden",
		pointerEvents: "none"
	});
}, md = (e, t) => {
	let { top: n, left: r, width: i, height: a } = t;
	Object.assign(e.style, {
		position: "absolute",
		top: `${n - dd}px`,
		left: `${r - dd}px`,
		height: `${a ? a + 2 * dd : 0}px`,
		width: `${i ? i + 2 * dd : 0}px`,
		boxSizing: "border-box",
		border: `${dd}px solid transparent`,
		pointerEvents: "none",
		borderImage: `radial-gradient(transparent 2%, rgba(0,0,0,${fd}) 28%) 49% 49% 49% 49%`,
		boxShadow: `0 0 0 2500px rgba(0,0,0,${fd})`
	});
}, hd = ({ document: e, rect: t, zIndex: n }) => {
	let r = e.createElement("div");
	r.id = rd, pd(r), r.style.zIndex = n;
	let i = e.createElement("div");
	return i.className = ad, md(i, t), r.append(i), r;
}, gd = ({ container: e, rect: t }) => {
	let n = e.firstElementChild;
	n && md(n, t);
}, _d = /* @__PURE__ */ c({
	build: () => Cd,
	update: () => wd
}), vd = .5, yd = (e) => {
	Object.assign(e.style, {
		position: "fixed",
		top: "0",
		left: "0",
		width: "100vw",
		height: "100vh",
		pointerEvents: "none"
	});
}, bd = (e, t, n) => {
	let { top: r, left: i, width: a, height: o } = n;
	Object.assign(e.style, {
		position: "absolute",
		top: `${r}px`,
		left: `${i}px`,
		width: `${a}px`,
		height: `${o}px`,
		overflow: "hidden",
		pointerEvents: "none"
	}), Object.assign(t.style, {
		position: "relative",
		width: `${a}px`,
		height: `${o}px`,
		boxShadow: `0px 0px 0px 2000px rgba(0,0,0,${vd})`,
		borderRadius: "0px",
		pointerEvents: "none"
	});
}, xd = (e, t, n, r, i) => {
	Object.assign(e.style, {
		position: "absolute",
		top: `${t}px`,
		left: `${n}px`,
		width: `${r}px`,
		height: `${i}px`,
		background: `rgba(0,0,0,${vd})`,
		pointerEvents: "all"
	});
}, Sd = ([e, t, n, r], i, a) => {
	let { top: o, left: s, right: c, bottom: l, width: u } = i, d = a.innerWidth, f = a.innerHeight;
	xd(e, 0, s, u, Math.max(0, o)), xd(t, 0, c, Math.max(0, d - c), f), xd(n, l, s, u, Math.max(0, f - l)), xd(r, 0, 0, Math.max(0, s), f);
}, Cd = ({ document: e, win: t, rect: n, zIndex: r }) => {
	let i = e.createElement("div");
	i.id = rd, yd(i), i.style.zIndex = r;
	let a = e.createElement("div"), o = e.createElement("div");
	return o.className = ad, bd(a, o, n), a.append(o), i.append(a), Sd([
		"top",
		"right",
		"bottom",
		"left"
	].map((t) => {
		let n = e.createElement("div");
		return n.className = ad, n.setAttribute("aria-label", `${t}-panel`), i.append(n), n;
	}), n, t), i;
}, wd = ({ container: e, win: t, rect: n }) => {
	let r = e.children[0], i = r?.firstElementChild;
	r && i && bd(r, i, n);
	let a = [...e.children].slice(1);
	a.length === 4 && Sd(a, n, t);
}, Td = {
	soft: ud,
	hard: _d
}, Ed = (e) => e in Td, Dd = ({ getWindowReference: e, target: t, backdropType: n, zIndex: r }) => {
	let i = e(), a;
	try {
		a = i.document.querySelector(t);
	} catch {
		a = null;
	}
	if (!a) return null;
	let o = a.getBoundingClientRect(), s = {
		document: i.document,
		win: i,
		rect: o,
		zIndex: r
	};
	return Td[n].build(s);
}, Od = ({ container: e, getWindowReference: t, target: n, backdropType: r }) => {
	let i = t(), a;
	try {
		a = i.document.querySelector(n);
	} catch {
		a = null;
	}
	if (!a || !e) return;
	let o = a.getBoundingClientRect();
	Td[r].update({
		container: e,
		win: i,
		rect: o
	});
}, kd = new Set([or, sr]), Ad = (e) => e.id === "appcues-cutout-backdrop" || kd.has(e.tagName), jd = (e, t) => {
	if (!t) return null;
	try {
		return e.querySelector(t);
	} catch {
		return null;
	}
}, Md = (e, { targetSelector: t } = {}) => {
	let { body: n } = e.document, r = /* @__PURE__ */ new Set(), i = jd(n, t);
	for (let e of n.children) !Ad(e) && !e.inert && !e.contains(i) && (e.inert = !0, r.add(e));
	return () => {
		for (let e of r) e.inert = !1;
	};
};
Q("@appcues/dialog", ({ addHook: e }, t) => {
	let { backdrop: n, variables: r, customBackdrop: i, inlineBackdrop: a = !1, target: o, autoFocus: s = !0 } = t, { dialogZIndex: c, backdropZIndex: l, backdropBlur: u, backdropColor: d } = r || {}, f = {
		backdrop: null,
		dialog: null
	}, p, m, h, g, _, v, y = (e, t, n) => {
		f[e]?.remove();
		let r = n.document.createElement("style");
		r.textContent = t, p.prepend(r), f[e] = r;
	}, b = () => {
		g && _ && (g.removeEventListener("scroll", _, !0), g.removeEventListener("resize", _));
	};
	if (n === !0 && !i && !o) {
		let t = ({ getTraitConfig: e, updateRootStyle: t }) => {
			let { variables: n } = e();
			t(cd(n || {}), { forceUpdate: !0 });
		};
		e("step.begin", t), e("step.container_change", t);
	}
	e("step.postrender", ({ step: e, getWindowReference: t, getTraitConfig: x }) => {
		let S = x(), C = S.backdrop ?? n, w = S.customBackdrop ?? i, T = S.target ?? o, E = S.autoFocus ?? s, D = S.inlineBackdrop ?? a, O = S.variables ?? r ?? {}, k = O.dialogZIndex ?? c, A = O.backdropZIndex ?? l, j = O.backdropBlur ?? u, M = O.backdropColor ?? d;
		[p] = e.querySelector("dialog") ?? [];
		let N = t();
		if (p) {
			C === !0 && w ? (m?.remove(), m = ld({
				getWindowReference: t,
				backdropZIndex: A,
				backdropBlur: j,
				backdropColor: M
			}), m && (D && p.parentNode ? p.parentNode.insertBefore(m, p) : N.document.body.append(m))) : (m?.remove(), m = void 0), C === !0 && !w && !T ? y("backdrop", sd, N) : (f.backdrop?.remove(), f.backdrop = null), y("dialog", od, N), p.style.zIndex = k, p.removeAttribute("autofocus");
			let e = C === !0 && !w && !T ? "showModal" : "show";
			if (e === "show" && !T) return;
			let n = e === "show" ? {
				x: N.scrollX,
				y: N.scrollY
			} : null, r = p.open;
			p[e](), n && (N.scrollX !== n.x || N.scrollY !== n.y) && N.scrollTo(n.x, n.y), e === "show" && E && !r && p.focus({ preventScroll: !0 });
		}
		b(), v?.(), h?.remove(), h = void 0, T && Ed(C) && (g = t(), h = Dd({
			getWindowReference: t,
			target: T,
			backdropType: C,
			zIndex: (k ?? 2) - 1
		}), h && (g.document.body.append(h), _ = () => Od({
			container: h,
			getWindowReference: t,
			target: T,
			backdropType: C
		}), g.addEventListener("scroll", _, !0), g.addEventListener("resize", _), C === "hard" && (v = Md(g, { targetSelector: T }))));
	}), e("step.end", () => {
		p?.close(), f.backdrop?.remove(), f.dialog?.remove(), m?.remove(), h?.remove(), b(), v?.();
	});
}), Q("@appcues/experienceTheme", ({ addHook: e }) => {
	let t = null;
	function n({ getContainer: e, getExperienceId: n, getWindowReference: r, getTraitConfig: i }) {
		let { css: a } = i(), o = e();
		if (!a || t && t.parentNode === o) return;
		let s = n();
		o && (t = r().document.createElement("style"), t.id = `appcues-experience-style-${s}`, t.textContent = a, o.prepend(t));
	}
	function r() {
		t &&= (t.remove(), null);
	}
	e("step.begin", n), e("experience.end", r);
}), Q("@appcues/navigation", ({ addHook: e }, t) => {
	e("step.begin", async ({ handleNavigation: e, reportError: n }) => {
		if (t?.type) try {
			await e(t);
		} catch (e) {
			n(e?.message ?? "Navigation failed");
		}
	});
}), Q("@appcues/scroll-into-view", ({ addHook: e }) => {
	let t = !1;
	e("step.postrender", ({ getTraitConfig: e, querySelector: n, getWindowReference: r }) => {
		if (t) return;
		let { target: i, behavior: a = "smooth", block: o = "nearest", inline: s = "nearest" } = e();
		if (!i?.selector) return;
		let c = eu(n(i.selector), i.filters);
		if (c.length === 0) return;
		let l = c[0], { innerWidth: u, innerHeight: d } = r(), { top: f, left: p, bottom: m, right: h } = l.getBoundingClientRect();
		if (f >= 0 && p >= 0 && m <= d && h <= u) {
			t = !0;
			return;
		}
		l.scrollIntoView({
			behavior: a,
			block: o,
			inline: s
		}), t = !0;
	}), e("step.end", () => {
		t = !1;
	});
});
//#endregion
//#region src/traits/advance-on-error/advance-on-error.js
var Nd = "@appcues/advance-on-error", Pd = 3e5, Fd = "@appcues/sequential.next", Id = "@appcues/sequential.skip", Ld = (e) => e === Fd ? Id : e;
Q(Nd, ({ addHook: e }, t) => {
	let n = null, r = () => {
		n !== null && (clearTimeout(n), n = null);
	};
	e("step.error", (e) => {
		r();
		let { getAction: i } = e, a = Number(t?.duration ?? 500), o = Number.isFinite(a) ? a : 500, s = t?.action;
		s?.type && (n = setTimeout(() => {
			n = null;
			let t = i(Ld(s.type));
			t && t(s.config ?? {}, e, Sn.ERROR);
		}, Math.min(Math.max(o, 0), Pd)));
	}), e("step.prebegin", r), e("step.end", r);
});
//#endregion
//#region src/core/components/appcues-container.js
var Rd = (e) => class extends e.HTMLElement {
	constructor() {
		super();
		let t = this.ownerDocument || e.document;
		this.hideContentStyles = t.createElement("style"), this.hideContentStyles.innerHTML = "\n        * {\n          visibility: hidden;\n        }\n      ";
		try {
			this.attachShadow({ mode: "open" });
		} catch {}
		this.webComponentStyles = t.createElement("style"), this.webComponentStyles.innerHTML = "\n        :host {\n          all: initial;\n          font-family: inherit;\n          display: inline;\n        }\n      ";
	}
	async connectedCallback() {
		this.shadowRoot.append(this.hideContentStyles), this.shadowRoot.append(...this.childNodes), this.getAttribute("themeId") && await Xr(this), this.shadowRoot.prepend(this.webComponentStyles), this.hideContentStyles.remove();
	}
}, zd = /* @__PURE__ */ new WeakMap(), Bd = (e = () => window) => {
	let t = e();
	if (zd.has(t)) return zd.get(t);
	if (!t.customElements.get("appcues-experience-container")) {
		let e = Rd(t);
		t.customElements.define(ar, e);
	}
	let n = t.customElements.whenDefined(ar);
	return zd.set(t, n), n;
}, Vd = !1;
function Hd({ runningExperiences: e = /* @__PURE__ */ new Map(), sendEvent: t = () => {}, sendCustomEvent: n = () => {}, showFlow: r = () => {}, updateUserProfile: i = () => {}, handleNavigation: a = () => {}, createRenderListener: o = ss, vNodeHandlers: s = ms, accessibilityHandlers: c = Os, getWindowReference: l = () => window, apiOverrides: u = {} } = {}) {
	Ur(u);
	let d = /* @__PURE__ */ new Map(), f = /* @__PURE__ */ new Map(), p = {
		sendEvent: t,
		sendCustomEvent: n,
		showFlow: r,
		updateUserProfile: i,
		handleNavigation: a,
		createRenderListener: o,
		vNodeHandlers: s,
		accessibilityHandlers: c,
		getWindowReference: l,
		apiOverrides: u,
		getExperienceSend: (e) => f.get(e)
	}, m = (e) => e ? p?.[e] ? p[e] : () => {
		throw Error(`can't find external dependency called ${e}`);
	} : p, h = (e, t) => {
		f.set(e, (e) => t.send(e));
	}, g = ({ reason: t = Sn.NAVIGATION } = {}) => {
		e.forEach((e) => {
			e.experienceService.send({
				type: xn,
				reason: t
			}), e.experienceService.subscribe((t) => {
				t.matches("end-final") && e.experienceService.stop();
			});
		}), e.clear(), f.clear();
	}, _ = (t, { reason: n = Sn.NAVIGATION } = {}) => {
		e.has(t) && (e.get(t).experienceService.send({
			type: xn,
			reason: n
		}), e.delete(t), f.delete(t));
	};
	return {
		registerAction: Si,
		registerTrait: Q,
		show: async (t) => {
			Bd(l), await l().customElements.whenDefined(ar);
			let n = dn(dn(t, "traits", (e) => (e ?? []).map((e, t) => ({
				...e,
				id: e.id || `${e.type}:${t}`
			}))), "steps", (e) => (e ?? []).map((e) => dn(e, "traits", (e) => (e ?? []).map((e, t) => ({
				...e,
				id: e.id || `${e.type}:${t}`
			}))))), r = e.get(t.id)?.experienceService ?? Ft(is(n, m), { devTools: Vd }).start();
			h(t.id, r), r.send({
				type: bn,
				experience: n
			}), e.set(t.id, {
				experienceService: r,
				experience: n
			});
		},
		stopAll: g,
		stop: _,
		pause: (t) => {
			if (d.get(t)) return;
			let n = e.get(t);
			n && (_(t), d.set(t, {
				experienceService: n.experienceService,
				experience: n.experience
			}));
		},
		resume: (t) => {
			let n = d.get(t);
			n && (n.experienceService.send({ type: bn }), e.set(t, {
				experienceService: n.experienceService,
				experience: n.experience
			}), h(t, n.experienceService), d.delete(t));
		},
		getRunningExperiences: () => [...e].map(([, { experience: e }]) => e),
		isExperiencePaused: (e) => d.has(e)
	};
}
//#endregion
export { Hd as default };
